(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[182],{

/***/ 54505:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[companyId]",
      function () {
        return __webpack_require__(46442);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CompanyLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/types/actionStatus.ts
var ActionStatus = {
    INITIAL: "initial",
    REQUEST: "request",
    SUCCESS: "success",
    FAILURE: "failure"
};
/* harmony default export */ var actionStatus = (ActionStatus);

;// CONCATENATED MODULE: ./src/hooks/useImageLoading.tsx


/**
 * imageUrl 을 받아서 이미지 객체의 로딩 상태를 반환한다
 *
 * @param {string} imageUrl 이미지 url
 * @return {{status: ActionStatus}} image 로딩 상태를 담은 객체
 */ function useImageLoading(imageUrl) {
    var ref = (0,react.useState)({
        status: actionStatus.INITIAL
    }), image = ref[0], setImage = ref[1];
    (0,react.useEffect)(function() {
        var img = new Image();
        if (imageUrl) {
            setImage({
                status: actionStatus.REQUEST
            });
            img.src = imageUrl;
        }
        img.onload = function() {
            setImage({
                status: actionStatus.SUCCESS
            });
        };
        img.onerror = function() {
            setImage({
                status: actionStatus.FAILURE
            });
        };
    }, [
        imageUrl
    ]);
    return image;
}
/* harmony default export */ var hooks_useImageLoading = (useImageLoading);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/CompanyLogo/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        img {\n          object-fit: contain;\n          width: 100%;\n          height: 100%;\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    overflow: hidden;\n    width: 70px;\n    height: 70px;\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var S = {
    Logo: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-eccbfe20-0"
    })(_templateObject2(), function(props) {
        return props.hasBorder && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(param) {
            var theme = param.theme;
            return theme.colors.gray400;
        });
    }, function(props) {
        return props.logoCss && props.logoCss;
    }, function(props) {
        return props.hasLogo && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
    })
};

;// CONCATENATED MODULE: ./src/components/CompanyLogo/index.tsx



/**
 *
 * @param {
 * PK_NM_HASH: company hash값
 * hasBorder?: border 유무
 * logoCss?: image wrapper size와 image size를 작성해주세요.
 * }
 * @returns
 */ function CompanyLogo(param) {
    var PK_NM_HASH = param.PK_NM_HASH, _hasBorder = param.hasBorder, hasBorder = _hasBorder === void 0 ? true : _hasBorder, logoCss = param.logoCss, _alt = param.alt, alt = _alt === void 0 ? "company_logo" : _alt;
    var logo = "https://s3.ap-northeast-2.amazonaws.com/kreditjob-public/logo/".concat(PK_NM_HASH);
    var logoImg = hooks_useImageLoading(logo);
    if (!PK_NM_HASH) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(S.Logo, {
        hasLogo: logoImg.status === "success",
        hasBorder: hasBorder,
        logoCss: logoCss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: alt,
            src: logo,
            width: 200,
            onError: function(e) {
                e.currentTarget.src = "https://static.wanted.co.kr/images/kj/default_company_logo.png";
            }
        })
    }, PK_NM_HASH);
}
/* harmony default export */ var components_CompanyLogo = (CompanyLogo);


/***/ }),

/***/ 7927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14141);





function ArrowLine(_param) {
    var _width = _param.width, width = _width === void 0 ? 6 : _width, _height = _param.height, height = _height === void 0 ? 10 : _height, color = _param.color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color"
    ]);
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 6 10"
    }, props), {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0 9.10606L0.910026 10L6 5L0.910026 0L0 0.893939L4.17995 5L0 9.10606Z",
            fill: color || theme.colors.gray900
        })
    }));
};


/***/ }),

/***/ 43573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);


function Check(param) {
    var _width = param.width, width = _width === void 0 ? 12 : _width, _height = param.height, height = _height === void 0 ? 10 : _height, color = param.color;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.99993 7.80007L1.19993 5.00006L0.266602 5.9334L3.99993 9.66673L11.9999 1.66673L11.0666 0.733398L3.99993 7.80007Z",
            fill: color || theme.colors.gray900
        })
    });
};


/***/ }),

/***/ 17353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_styles_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6965);





var ExclamationMark = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 60 : _width, color = _param.color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "width",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: width,
        height: width,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.75 11.25H8.25V6.75H6.75V11.25ZM7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM6.75 5.25H8.25V3.75H6.75V5.25Z",
            fill: color || _lib_styles_Theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].colors.yellow500 */ .Z.colors.yellow500
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ExclamationMark);


/***/ }),

/***/ 95813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function LinkIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 18,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.118 3.06a3.25 3.25 0 0 0-4.596 0L9.216 4.364l-.068.077a.75.75 0 0 0 1.128.984l1.306-1.306.106-.098a1.75 1.75 0 0 1 2.37 2.573l-3.536 3.535-.106.097a1.75 1.75 0 0 1-2.736-.633l-.047-.091a.75.75 0 0 0-1.328.69 3.25 3.25 0 0 0 5.277.997l3.536-3.535.127-.134a3.25 3.25 0 0 0-.127-4.462Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.191 6.986a3.25 3.25 0 0 0-4.596 0L3.059 10.52l-.126.134a3.25 3.25 0 0 0 4.723 4.463l1.306-1.306.067-.077A.75.75 0 0 0 7.9 12.75l-1.306 1.306-.106.097a1.75 1.75 0 0 1-2.369-2.572l3.536-3.535.105-.098a1.75 1.75 0 0 1 2.747.658l.045.092a.75.75 0 0 0 1.338-.67 3.244 3.244 0 0 0-.7-1.043Z",
                fill: "white"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LinkIcon);


/***/ }),

/***/ 33148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pencil; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);


function Pencil(param) {
    var _width = param.width, width = _width === void 0 ? 13 : _width, color = param.color;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: width,
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0 10.5V13H2.5L9.87333 5.62662L7.37333 3.12662L0 10.5ZM11.8067 3.69329C12.0667 3.43329 12.0667 3.01329 11.8067 2.75329L10.2467 1.19329C9.98667 0.933291 9.56667 0.933291 9.30667 1.19329L8.08667 2.41329L10.5867 4.91329L11.8067 3.69329Z",
            fill: color || theme.colors.white100
        })
    });
};


/***/ }),

/***/ 84964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ScrapIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




function ScrapIcon(_param) {
    var _width = _param.width, width = _width === void 0 ? 12 : _width, _height = _param.height, height = _height === void 0 ? 15 : _height, _fill = _param.fill, fill = _fill === void 0 ? "white" : _fill, stroke = _param.stroke, strokeWidth = _param.strokeWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "fill",
        "stroke",
        "strokeWidth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height,
        fill: fill,
        viewBox: "0 0 12 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0.777279 2.16704V2.16667C0.777279 1.57745 1.25422 1.1 1.83561 1.1H10.1689C10.7542 1.1 11.2356 1.58137 11.2356 2.16667V14.5901L6.23863 12.4485L6.00228 12.3472L5.76593 12.4485L0.769514 14.5898L0.777279 2.16704Z",
            fill: fill,
            stroke: stroke,
            strokeWidth: strokeWidth
        })
    }));
};


/***/ }),

/***/ 78982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Picture; },
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/utils/browser/getOptimizeSrc.ts
/**
 * 원티드 이미지 최적화 URL로 반환
 * @see https://wantedlab.atlassian.net/wiki/spaces/FE/pages/2464972903/CloudFront+Lambda+Function+URL+.
 *
 * @param src
 * @param width
 * @param quality
 * @returns
 */ function getOptimizeSrc(param) {
    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    if (src.startsWith("/")) {
        return src;
    }
    return "https://image.wanted.co.kr/optimize?src=".concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality <= 0 || quality > 100 ? 75 : quality);
}

;// CONCATENATED MODULE: ./src/components/Image/index.tsx




/**
 * 1. 이미지 리사이징을 해줍니다.
 * 2. 브라우저가 webp 지원하면 webp포맷으로 내려줍니다.
 * 참고:
 * 보안을 위해 white list로 domain 관리하고 있습니다.
 * white list에 등록되지 않은 domain으로 요청이 들어오면 요청은 응답 거부(400 error) 됩니다.
 * @link https://us-east-1.console.aws.amazon.com/cloudfront/v3/home?region=ap-northeast-2#/functions/image-reize-allow-domain
 * ---------------------------------------------------------------------------------------------------------------------------------
 * @param src 이미지 원본 URL
 * @param alt 이미지 대체 텍스트 값. SEO 에 영향을 주므로 이미지에 맞는 대체텍스트를 넣을 것을 지향합니다.
 * @param width 이미지 가로사이즈이며, 크기에 영향을 줍니다.
 * @param quality 리사이징시 이미지 품질을 나타내는 정수값 입니다. 최상의 품질은 100이며, 기본값은 75 입니다.
 * @see https://wantedlab.atlassian.net/wiki/spaces/FE/pages/2464972903/CloudFront+Lambda+Function+URL+.
 */ var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, width = _param.width, _quality = _param.quality, quality = _quality === void 0 ? 75 : _quality, other = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "width",
        "quality"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: getOptimizeSrc({
            src: src,
            width: width,
            quality: quality
        }),
        alt: alt
    }, other));
};
function Picture(_param) {
    var mobile = _param.mobile, resolution2xSrc = _param.resolution2xSrc, src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, width = _param.width, _quality = _param.quality, quality = _quality === void 0 ? 75 : _quality, props = (0,_object_without_properties/* default */.Z)(_param, [
        "mobile",
        "resolution2xSrc",
        "src",
        "alt",
        "width",
        "quality"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        children: [
            mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: "".concat(getOptimizeSrc({
                    src: mobile.src,
                    width: mobile.width,
                    quality: mobile.quality
                }), " 2x"),
                media: "(max-width: 767px)"
            }),
            resolution2xSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: "".concat(getOptimizeSrc({
                    src: resolution2xSrc,
                    width: Number(width) * 2,
                    quality: quality
                }), " 2x")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
                src: src,
                width: width,
                quality: quality,
                alt: alt
            }, props))
        ]
    });
}
/* harmony default export */ var components_Image = (Image);


/***/ }),

/***/ 26224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RenderOnClientReady; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72688);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12447);



function RenderOnClientReady(param) {
    var children = param.children;
    var isReady = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isReady;
    if (!isReady) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};


/***/ }),

/***/ 3279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SSRSafeSuspense; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useIsMount.ts

/**
 * @description
 * Component의 mount 여부를 알 수 있는 hook 입니다.
 *
 * SSR 환경에서 실제로 컴포넌트가 브라우저에서 mount 된 이후에 어떤 동작을 실행하기 위해서 사용합니다.
 *
 * - 이 함수가 아니라 `isServer()` 함수를 사용할 경우, SSR 환경에서 Hydration 오류로 인해서 서비스가 심각하게 오동작할 수 있습니다.
 *
 * @example
 * const isMounted = useIsMounted();
 *
 * useEffect(() => {
 *   if (!isMounted) {
 *     return;
 *   }
 *   if (clientBenefitIntelliQuery.data === undefined) {
 *     return;
 *   }
 *   setBenefitIntelliContents(clientBenefitIntelliQuery.data);
 * }, [clientBenefitIntelliQuery.data, isMounted]);
 */ function useIsMounted() {
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    return mounted;
}

;// CONCATENATED MODULE: ./src/components/SSRSafeSuspense/index.tsx



var SSRSafeSuspense = function(param) {
    var pendingFallback = param.pendingFallback, children = param.children;
    var isMounted = useIsMounted();
    if (!isMounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: pendingFallback,
        children: children
    });
};
/* harmony default export */ var components_SSRSafeSuspense = (SSRSafeSuspense);


/***/ }),

/***/ 22807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TinyDropDown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useMedia.ts
var useMedia = __webpack_require__(12447);
;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/helper.ts
function getOptionText(option) {
    if (option) {
        return option.label || option.value;
    }
}

// EXTERNAL MODULE: ./src/components/Icon/Check.tsx
var Check = __webpack_require__(43573);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/Option/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: inherit;\n      color: ",
        ";\n\n      &:hover,\n      &:focus {\n        color: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  padding: 10px 15px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n    background-color: rgba(204, 204, 204, 0.15);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Anchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-14276d76-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.black100;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black100;
}, function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(param) {
        var theme = param.theme;
        return theme.colors.gray600;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.gray600;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.white100;
    });
});

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/Option/index.tsx



function Option(param) {
    var label = param.label, value = param.value, disabled = param.disabled, selected = param.selected, onClick = param.onClick;
    var handleClick = function(e) {
        e.preventDefault();
        if (disabled || selected) {
            return;
        }
        if (onClick) {
            onClick(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor, {
            disabled: disabled,
            selected: selected,
            onClick: handleClick,
            href: "#",
            children: [
                label,
                selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useDocumentClick.ts
var useDocumentClick = __webpack_require__(63740);
;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/OptionsContainer/helper.ts

function helper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        left: 0;\n        transform: translate3d(0, 100%, 0);\n      "
    ]);
    helper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function helper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        left: 50%;\n        transform: translate3d(-50%, 100%, 0);\n      "
    ]);
    helper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: 0;\n        transform: translate3d(0, 100%, 0);\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

function getAlign(align) {
    switch(align){
        case "left":
            return (0,styled_components_browser_esm/* css */.iv)(helper_templateObject());
        case "center":
            return (0,styled_components_browser_esm/* css */.iv)(helper_templateObject1());
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
    }
}

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/OptionsContainer/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -5px;\n  width: 160px;\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  z-index: 20;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  ",
        ";\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-112d067c-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var align = param.align;
    return getAlign(align);
});

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/OptionsContainer/index.tsx



function OptionsContainer(param) {
    var open = param.open, setOpen = param.setOpen, children = param.children, align = param.align;
    (0,useDocumentClick/* default */.Z)(function() {
        return setOpen(false);
    });
    if (!open) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        align: align,
        tabIndex: 0,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/utils/common/getUuid.ts
function getUuid() {
    return Math.random().toString(36).substring(2, 11);
};

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/SelectMobile/style.ts

function SelectMobile_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n"
    ]);
    SelectMobile_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Select = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-7dad3a38-0"
})(SelectMobile_style_templateObject());

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/SelectMobile/index.tsx





function SelectMobile(param) {
    var value = param.value, options = param.options, onChange = param.onChange;
    var prefixKey = (0,react.useMemo)(function() {
        return getUuid();
    }, []);
    var handleChange = function(e) {
        var selectedIndex = e.target.selectedIndex;
        var newSelectedValue = options[selectedIndex].value;
        if (onChange) {
            onChange(newSelectedValue);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
        value: value,
        onChange: handleChange,
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: option.value,
                disabled: option.disabled,
                children: getOptionText(option)
            }, "".concat(prefixKey, "-value-").concat(index));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/style.ts

function TinyDropDown_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n    "
    ]);
    TinyDropDown_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-width: 60px;\n  padding: 0 17px 0 0;\n  display: inline-block;\n  ",
        "\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 11px;\n    right: 5px;\n    display: block;\n    width: 7px;\n    height: 5px;\n    background-image: url('/images/ico-tiny-dropdown.svg');\n    background-size: 7px 5px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: none;\n  border: none;\n  z-index: 5;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: 26px;\n  line-height: 26px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-align: right;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7c1722f-0"
})(style_templateObject1(), function(param) {
    var $width = param.$width;
    return $width && (0,styled_components_browser_esm/* css */.iv)(TinyDropDown_style_templateObject(), $width);
});
var ButtonDropDown = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f7c1722f-1"
})(style_templateObject2());
var SelectedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7c1722f-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.greynavy300;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
});
var Placeholder = (0,styled_components_browser_esm/* default */.ZP)(SelectedText).withConfig({
    componentId: "sc-f7c1722f-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});
var NoData = (0,styled_components_browser_esm/* default */.ZP)(SelectedText).withConfig({
    componentId: "sc-f7c1722f-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});

;// CONCATENATED MODULE: ./src/components/common/TinyDropDown/index.tsx








function TinyDropDown(param) {
    var value = param.value, $width = param.$width, options = param.options, _align = param.align, align = _align === void 0 ? "center" : _align, onChange = param.onChange;
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(), selectedText = ref1[0], setSelectedText = ref1[1];
    var displayText = (0,react.useMemo)(function() {
        if (!options || (options === null || options === void 0 ? void 0 : options.length) === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData, {
                children: "정보없음"
            });
        }
        if (selectedText) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedText, {
                children: selectedText
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {
            children: "Choose here"
        });
    }, [
        selectedText,
        options
    ]);
    var handleClickDropDown = function(e) {
        e.stopPropagation();
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    (0,react.useEffect)(function() {
        var selectedOption = options.find(function(option) {
            return option.value === value;
        });
        setSelectedText(getOptionText(selectedOption));
    }, [
        value,
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Wrapper, {
        $width: $width,
        children: [
            displayText,
            options && options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectMobile, {
                    value: value,
                    onChange: onChange,
                    options: options
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDropDown, {
                            title: selectedText,
                            onClick: handleClickDropDown
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsContainer, {
                            open: open,
                            setOpen: setOpen,
                            align: align,
                            children: options.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                    label: getOptionText(option),
                                    value: option.value,
                                    disabled: option.disabled,
                                    selected: option.value === value,
                                    onClick: onChange
                                }, option.value);
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 66185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12447);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n\n  ",
        "\n  & .tooltiptext {\n    line-height: 1.5;\n    visibility: hidden;\n    padding: 15px;\n    width: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: 500;\n    text-align: left;\n    border-radius: 4px;\n    z-index: 1;\n    position: absolute;\n    top: calc(100% + 12px);\n    right: -9px;\n    ",
        "\n\n    margin-left: -60px;\n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n\n  & .tooltiptext::after {\n    content: '';\n    display: block;\n    position: absolute;\n\n    ",
        "\n    ",
        "\n\n    bottom: 100%;\n    width: 0;\n    height: 0;\n    border: 7px solid transparent;\n    border-bottom-color: ",
        ";\n  }\n\n  &:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Tooltip(param) {
    var children = param.children, tooltipText = param.tooltipText, position = param.position, _width = param.width, width = _width === void 0 ? 282 : _width;
    var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TooltipWrapper, {
        width: width,
        position: position,
        isMobile: isMobile,
        role: "tooltip",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "tooltiptext",
                dangerouslySetInnerHTML: {
                    __html: tooltipText
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);
var TooltipWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-45b8c054-0"
})(_templateObject(), function(props) {
    return props.isMobile && '\n    &:after {\n      content: "";\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 200%;\n      height: 200%;\n    }\n  ';
}, function(props) {
    return props.width;
}, function(props) {
    return props.theme.colors.magenta700;
}, function(props) {
    return props.theme.colors.white100;
}, function(props) {
    return props.theme.fontSize.C1;
}, function(props) {
    return props.position === "center" && "right: calc(50% - ".concat(props.width / 2 + 2, "px);");
}, function(props) {
    return props.position === "center" && "right : calc(50% - 7px);";
}, function(props) {
    return props.position === "right" && "right: 11px;";
}, function(props) {
    return props.theme.colors.magenta700;
});


/***/ }),

/***/ 75561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CompanyLogoCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14141);
/* harmony import */ var _components_CompanyLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43277);
/* harmony import */ var _components_Text_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24985);
/* harmony import */ var _utils_formatted_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23230);
/* harmony import */ var _utils_locationFormat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23133);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-radius: 4px;\n  overflow-x: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 45px;\n  height: 45px;\n  min-width: 45px;\n  padding: 3px;\n\n  & > img {\n    width: 24px;\n    height: 15px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  max-width: 100%;\n  margin-bottom: 3px;\n  color: ",
        ";\n  text-align: left;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 12px;\n  overflow: hidden;\n\n  ",
        " {\n    flex: inherit;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  text-align: right;\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







function CompanyLogoCard(_param) {
    var companyName = _param.companyName, location = _param.location, locationCode = _param.locationCode, salary = _param.salary, href = _param.href, inlineCss = _param.inlineCss, PK_NM_HASH = _param.PK_NM_HASH, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "companyName",
        "location",
        "locationCode",
        "salary",
        "href",
        "inlineCss",
        "PK_NM_HASH",
        "onClick"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleClick = function() {
        if (onClick) {
            onClick();
        }
        router.push(href);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Anchor, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        inlineCss: inlineCss,
        onClick: handleClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LeftArea, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CompanyLogo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        PK_NM_HASH: PK_NM_HASH,
                        logoCss: logoCss
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CompanyInfo, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                                children: companyName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Location, {
                                children: (0,_utils_locationFormat__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedAddress */ .r)(locationCode, location)
                            })
                        ]
                    })
                ]
            }),
            !!salary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Salary, {
                children: [
                    "평균 ",
                    (0,_utils_formatted_number__WEBPACK_IMPORTED_MODULE_4__/* .millionFormattedtoString */ .X6)(salary),
                    "만원"
                ]
            })
        ]
    }));
};
var Anchor = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-db6e9436-0"
})(_templateObject(), function(param) {
    var inlineCss = param.inlineCss;
    return inlineCss;
});
var LeftArea = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db6e9436-1"
})(_templateObject1());
var logoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject2());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db6e9436-2"
})(_templateObject3(), (0,_components_Text_helper__WEBPACK_IMPORTED_MODULE_10__/* .getFontStyle */ .p)("bold120_B3"), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var Location = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db6e9436-3"
})(_templateObject4(), (0,_components_Text_helper__WEBPACK_IMPORTED_MODULE_10__/* .getFontStyle */ .p)("midium120_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var CompanyInfo = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db6e9436-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Salary = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db6e9436-5"
})(_templateObject6(), (0,_components_Text_helper__WEBPACK_IMPORTED_MODULE_10__/* .getFontStyle */ .p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});


/***/ }),

/***/ 74203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oL": function() { return /* binding */ useModalOpen; },
/* harmony export */   "tJ": function() { return /* binding */ useConstants; }
/* harmony export */ });
/* unused harmony exports useGetDefaultMenuValue, useGetModalInfo */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * 연봉상세 모달팝업을 함수 호출을 통해 제어할 수 있도록 제공
 *
 * @param data
 * @returns {isModalOpen, setIsModalOpen, modalInfo, handleModalOpen}
 */ function useModalOpen(data) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), modalInfo = ref1[0], setModalInfo = ref1[1];
    var getDefaultMenuValue = useGetDefaultMenuValue().getDefaultMenuValue;
    var getModalInfo = useGetModalInfo().getModalInfo;
    /**
   * - 모달의 type(신입 or 경력)값에 따라 modalInfo를 설정한다.
   * - defaultMenuValue 파라미터가 없다면 getDefaultMenu 함수에서 기본 menu를 가져온다.
   * @param params
   */ var handleModalOpen = function(params) {
        var defaultMenuValue = params.defaultMenuValue || getDefaultMenuValue(params.type, data);
        var newModalInfo = getModalInfo(params.type, defaultMenuValue);
        setModalInfo(newModalInfo);
        setIsModalOpen(true);
    };
    return {
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        modalInfo: modalInfo,
        handleModalOpen: handleModalOpen
    };
}
function useConstants() {
    var NEW_EMPLOYEE_NAV_DATA = [
        {
            label: "고졸",
            value: "HIGHSCHOOL"
        },
        {
            label: "초대졸",
            value: "COLLEGE"
        },
        {
            label: "대졸",
            value: "UNIVERSITY"
        },
        {
            label: "대학원졸",
            value: "MASTER"
        }, 
    ];
    var CAREER_EMPLOYEE_NAV_DATA = [
        {
            label: "2-4년",
            value: "JIDR"
        },
        {
            label: "5-7년",
            value: "GJ"
        },
        {
            label: "8-10년",
            value: "CJ"
        },
        {
            label: "10년 초과",
            value: "BJ"
        }, 
    ];
    var DEFAULT_NEW_EMPLOYEE_VALUE = NEW_EMPLOYEE_NAV_DATA[2].value;
    var DEFAULT_CAREER_EMPLOYEE_VALUE = CAREER_EMPLOYEE_NAV_DATA[0].value;
    return {
        NEW_EMPLOYEE_NAV_DATA: NEW_EMPLOYEE_NAV_DATA,
        CAREER_EMPLOYEE_NAV_DATA: CAREER_EMPLOYEE_NAV_DATA,
        DEFAULT_NEW_EMPLOYEE_VALUE: DEFAULT_NEW_EMPLOYEE_VALUE,
        DEFAULT_CAREER_EMPLOYEE_VALUE: DEFAULT_CAREER_EMPLOYEE_VALUE
    };
}
function useGetDefaultMenuValue() {
    var ref = useConstants(), CAREER_EMPLOYEE_NAV_DATA = ref.CAREER_EMPLOYEE_NAV_DATA, NEW_EMPLOYEE_NAV_DATA = ref.NEW_EMPLOYEE_NAV_DATA, DEFAULT_NEW_EMPLOYEE_VALUE = ref.DEFAULT_NEW_EMPLOYEE_VALUE, DEFAULT_CAREER_EMPLOYEE_VALUE = ref.DEFAULT_CAREER_EMPLOYEE_VALUE;
    /**
   * 아래 조건으로 연봉상세 모달팝업의 기본메뉴를 반환한다.
   *
   * [신입]
   *
   * - (1순위) 대졸
   * - (2순위 : 예상연봉="정보없음"일 경우)
   * - 좌측 순으로 정보가 있을 경우노출
   * - ex. 고졸 > 초대졸 > 대졸 > 대학원졸
   *
   * [경력]
   *
   * - (1순위) 2-4년
   * - (2순위 : 예상연봉="정보없음"일 경우)
   * - 좌측 순으로 정보가 있을 경우노출
   * - ex. 2-4년 > 5-7년 > 8-10년 > 10년 초과
   *
   * @param type '신입' | '연봉'
   * @param data WikiSalaryChartResponse
   * @returns menuValue (ex. 'HIGHSCHOOL' or 'COLLEGE' or 'JIDR' or 'GJ')
   */ var getDefaultMenuValue = function(type, data) {
        if (!data) {
            return type === "경력" ? DEFAULT_CAREER_EMPLOYEE_VALUE : DEFAULT_NEW_EMPLOYEE_VALUE;
        }
        if (type === "경력") {
            if (data[DEFAULT_CAREER_EMPLOYEE_VALUE].avg) {
                return DEFAULT_CAREER_EMPLOYEE_VALUE;
            }
            var availableMenu = CAREER_EMPLOYEE_NAV_DATA.filter(function(item) {
                return !!data[item.value].avg;
            });
            if (availableMenu.length > 0) {
                return availableMenu[0].value;
            }
            return DEFAULT_CAREER_EMPLOYEE_VALUE;
        } else {
            if (data[DEFAULT_NEW_EMPLOYEE_VALUE].avg) {
                return DEFAULT_NEW_EMPLOYEE_VALUE;
            }
            var availableMenu1 = NEW_EMPLOYEE_NAV_DATA.filter(function(item) {
                return !!data[item.value].avg;
            });
            if (availableMenu1.length > 0) {
                return availableMenu1[0].value;
            }
            return DEFAULT_NEW_EMPLOYEE_VALUE;
        }
    };
    return {
        getDefaultMenuValue: getDefaultMenuValue
    };
}
function useGetModalInfo() {
    var ref = useConstants(), NEW_EMPLOYEE_NAV_DATA = ref.NEW_EMPLOYEE_NAV_DATA, CAREER_EMPLOYEE_NAV_DATA = ref.CAREER_EMPLOYEE_NAV_DATA;
    /**
   * modalInfo를 반환한다.
   * @param type
   * @param defaultMenuValue
   * @returns modalInfo
   */ var getModalInfo = function(type, defaultMenuValue) {
        var obj = {
            navData: NEW_EMPLOYEE_NAV_DATA,
            title: "신입 예상 연봉",
            defaultMenuValue: defaultMenuValue,
            type: type
        };
        if (type === "경력") {
            obj.navData = CAREER_EMPLOYEE_NAV_DATA;
            obj.title = "경력 예상 연봉";
        }
        return obj;
    };
    return {
        getModalInfo: getModalInfo
    };
}


/***/ }),

/***/ 51286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePostBookmarks; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_api_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35088);
/* harmony import */ var _lib_api_queryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87303);
/* harmony import */ var _store_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8546);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24858);






function usePostBookmarks() {
    var toastShow = (0,_store_toast__WEBPACK_IMPORTED_MODULE_2__/* .useToastStore */ .E)().toastShow;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)(function(bookmarks) {
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .post */ .v_)("/api/user/bookmark", {
            PK_NM_HASHs: bookmarks
        });
    }, {
        onSuccess: function(response) {
            // bookmark List updater
            var newBookmark = response.data;
            toastShow("스크랩에서 저장되었습니다.");
            _lib_api_queryClient__WEBPACK_IMPORTED_MODULE_1__/* .queryClient.setQueryData */ .E.setQueryData([
                _queryKeys__WEBPACK_IMPORTED_MODULE_3__/* ["default"].bookmark */ .Z.bookmark,
                "detail"
            ], function(prev) {
                // 캐싱된 데이터가 있을 경우만
                if (prev) {
                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(newBookmark).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prev));
                }
            });
        }
    });
};


/***/ }),

/***/ 6016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGetCompanyCultureReviewQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24858);
/* harmony import */ var _user_useMyInfoQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9419);




function useGetCompanyCultureReviewQuery(companyHash) {
    var isActiveUser = (0,_user_useMyInfoQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isActiveUser;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_1__/* ["default"].companyReviewCulture */ .Z.companyReviewCulture,
        companyHash,
        isActiveUser
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._)("/api/review/culture?PK_NM_HASH=".concat(companyHash));
    }, {
        enabled: !!companyHash && isActiveUser,
        select: function(response) {
            return getChartData(response);
        }
    });
};
function getChartData(data) {
    var cultureList = data.map(function(item) {
        return {
            content: item.content,
            chartData: {
                leftData: {
                    legend: item.answers[0].content,
                    rate: item.answers[0].rate,
                    count: item.answers[0].count
                },
                rightData: {
                    legend: item.answers[1].content,
                    rate: item.answers[1].rate,
                    count: item.answers[1].count
                }
            },
            isEmpty: item.answers[0].count === 0 && item.answers[1].count === 0
        };
    });
    var isAllEmpty = cultureList.every(function(item) {
        return item.isEmpty;
    });
    return {
        cultureList: cultureList,
        isAllEmpty: isAllEmpty
    };
}


/***/ }),

/***/ 57513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useSuspensedCompanyInfo; },
/* harmony export */   "Z": function() { return /* binding */ useGetCompanyInfo; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useRouterQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41771);
/* harmony import */ var _hooks_useSuspenseQuery_useSuspenseQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21274);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24858);





var getUrl = function(companyHash) {
    return "/api/company/".concat(companyHash, "/info");
};
function useGetCompanyInfo(companyHash) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].companyInfo */ .Z.companyInfo,
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)(getUrl(companyHash));
    }, {
        enabled: !!companyHash
    });
};
function useSuspensedCompanyInfo() {
    var companyId = (0,_hooks_useRouterQuery__WEBPACK_IMPORTED_MODULE_0__/* .useRouterQuery */ .o)("companyId");
    return (0,_hooks_useSuspenseQuery_useSuspenseQuery__WEBPACK_IMPORTED_MODULE_4__/* .useSuspendedQuery */ .u)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].companyInfo */ .Z.companyInfo,
        companyId
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)(getUrl(companyId));
    }, {
        enabled: !!companyId
    });
}


/***/ }),

/***/ 88061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCompanyReviewWorkLife; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24858);
/* harmony import */ var _user_useMyInfoQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9419);






function useCompanyReviewWorkLife(companyHash) {
    var ref, ref1;
    var isActiveUser = (0,_user_useMyInfoQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isActiveUser;
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_1__/* ["default"].companyReviewWorkLife */ .Z.companyReviewWorkLife,
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._)("/api/review/worklife?PK_NM_HASH=".concat(companyHash));
    }, {
        enabled: !!companyHash && isActiveUser
    });
    var ref2;
    var isEmptyOvertime = Object.values((ref2 = (ref = result.data) === null || ref === void 0 ? void 0 : ref.overtime) !== null && ref2 !== void 0 ? ref2 : {}).every(function(obj) {
        return obj.count === 0;
    });
    var ref3;
    var isEmptyWeekend = Object.values((ref3 = (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.weekend) !== null && ref3 !== void 0 ? ref3 : {}).every(function(obj) {
        return obj.count === 0;
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, result), {
        isEmptyOvertime: isEmptyOvertime,
        isEmptyWeekend: isEmptyWeekend,
        isEmpty: isEmptyOvertime && isEmptyWeekend
    });
};


/***/ }),

/***/ 47720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGetCompanyStates; },
/* harmony export */   "s": function() { return /* binding */ useSuspensedCompanyStates; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useRouterQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41771);
/* harmony import */ var _hooks_useSuspenseQuery_useSuspenseQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21274);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24858);





var getUrl = function(companyHash) {
    return "/api/company/".concat(companyHash, "/states");
};
function useGetCompanyStates(companyHash) {
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].companyStates */ .Z.companyStates,
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)(getUrl(companyHash));
    }, {
        enabled: !!companyHash
    }), data = ref.data, status = ref.status;
    return {
        status: status,
        data: data
    };
};
function useSuspensedCompanyStates() {
    var companyHash = (0,_hooks_useRouterQuery__WEBPACK_IMPORTED_MODULE_0__/* .useRouterQuery */ .o)("companyId");
    return (0,_hooks_useSuspenseQuery_useSuspenseQuery__WEBPACK_IMPORTED_MODULE_4__/* .useSuspendedQuery */ .u)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].companyStates */ .Z.companyStates,
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)(getUrl(companyHash));
    }, {
        enabled: !!companyHash
    });
}


/***/ }),

/***/ 62857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIndustries; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24858);



function useIndustries() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_1__/* ["default"].industries */ .Z.industries
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._)("/api/industries");
    });
};


/***/ }),

/***/ 65008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useGetInterviewReviewTabs; },
/* harmony export */   "Z": function() { return /* binding */ useGetInterview; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24858);






function useGetInterview(companyHash) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_1__/* ["default"].companyReviewInterview */ .Z.companyReviewInterview,
        "list",
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._)("/api/review/interview?PK_NM_HASH=".concat(companyHash));
    }, {
        enabled: !!companyHash
    });
};
function useGetInterviewReviewTabs(companyHash) {
    var _ref = useGetInterview(companyHash), data = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    if (rest.status !== "success" || !data) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            data: undefined
        }, rest);
    }
    var keys = Object.keys(data === null || data === void 0 ? void 0 : data.reviews);
    var tabs = keys.map(function(key) {
        return {
            id: key,
            content: data.reviews[key].content
        };
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        data: tabs
    });
}


/***/ }),

/***/ 398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGetIndustryByCode; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _query_company_useIndustries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62857);


/**
 * 업종 코드로 업종 데이터를 반환
 * @returns { getIndustryByCode }
 */ function useGetIndustryByCode() {
    var ref = (0,_query_company_useIndustries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), industries = ref.data;
    var getIndustryByCode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(code) {
        return industries === null || industries === void 0 ? void 0 : industries.find(function(industry) {
            return industry.code === code;
        });
    }, [
        industries
    ]);
    return {
        getIndustryByCode: getIndustryByCode
    };
};


/***/ }),

/***/ 21274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useSuspendedQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__);



function useSuspendedQuery(queryKey, queryFn, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, queryFn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, options), {
        suspense: true
    }));
}


/***/ }),

/***/ 55153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LH": function() { return /* binding */ ellipsis; }
/* harmony export */ });
/* unused harmony exports multiEllipsis, nowrap */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  white-space: unset;\n  display: -webkit-box;\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  white-space: nowrap;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ellipsis = function() {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
};
var multiEllipsis = function() {
    var lines = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
    return css(_templateObject1(), ellipsis(), lines);
};
var nowrap = function() {
    return css(_templateObject2());
};


/***/ }),

/***/ 46442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _companyId_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(91224);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/RenderOnClient/index.tsx
var RenderOnClient = __webpack_require__(26224);
// EXTERNAL MODULE: ./node_modules/@marvelapp/react-ab-test/index.js
var react_ab_test = __webpack_require__(59249);
// EXTERNAL MODULE: ./src/hooks/useMedia.ts
var useMedia = __webpack_require__(12447);
// EXTERNAL MODULE: ./src/store/admin.ts
var admin = __webpack_require__(11909);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./src/hooks/useRouterQuery.ts
var useRouterQuery = __webpack_require__(41771);
// EXTERNAL MODULE: ./src/lib/api/client.ts
var client = __webpack_require__(35088);
// EXTERNAL MODULE: ./src/hooks/query/company/useCompanyInfo.tsx
var useCompanyInfo = __webpack_require__(57513);
;// CONCATENATED MODULE: ./src/hooks/query/admin/useCompanyPreference.ts








/**
 * HASH값을 이용해 redux에 정의되어있는 companyId를 반환
 * @returns companyId
 */ function useGetCompanyId() {
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var data = (0,useCompanyInfo/* default */.Z)(companyHash).data;
    return data === null || data === void 0 ? void 0 : data.id;
}
/**
 * api요청시 사용되는 payload, 인증에 사용되는 jwt token을 병합하는 함수를 반환
 * @type {{a: boolean}}
 * @returns {function} combineWithSsid
 */ function useCombineWithSsid() {
    var jwt = useAdminStore().jwt;
    var combineWithSsid = useCallback(function(payload) {
        return _object_spread_props(_object_spread({}, payload), {
            ssid: jwt
        });
    }, [
        jwt
    ]);
    return combineWithSsid;
}
function handleSuccess() {
    alert("Success");
    window.location.reload();
}
// @ts-ignore
function handleError(err) {
    console.log(err);
    alert("Error");
}
/**
 * 기업의 연봉, 인원, 매출, 잡담, 홈 랭킹 노출여부 api
 * @returns
 */ function useCompanyInfoMutation() {
    var companyId = useGetCompanyId();
    return (0,index_production.useMutation)(function(payload) {
        return(// @ts-ignore
        (0,client/* post */.v_)("/api/hq/company/".concat(companyId, "/preference"), payload));
    }, {
        onSuccess: handleSuccess,
        onError: handleError
    });
}
/**
 * 기업의 폐업여부 api
 * @returns
 */ function useCompanyCloseMutation() {
    var companyId = useGetCompanyId();
    return (0,index_production.useMutation)(function(payload) {
        return (0,client/* post */.v_)("/api/hq/company/".concat(companyId, "/close"), payload);
    }, {
        onSuccess: handleSuccess,
        onError: handleError
    });
}
/**
 * 기업삭제 api
 * @returns
 */ function useCompanyDeleteMutation() {
    var companyId = useGetCompanyId();
    return (0,index_production.useMutation)(function() {
        return (0,client/* del */.IV)("/api/hq/company/".concat(companyId), {
            data: {}
        });
    }, {
        onSuccess: handleSuccess,
        onError: handleError
    });
}
/**
 * 삭제된 기업 복원 api
 * @returns
 */ function useCompanyRestoreMutation() {
    var companyId = useGetCompanyId();
    return (0,index_production.useMutation)(function() {
        return (0,client/* put */.gz)("/api/hq/company/".concat(companyId), {});
    }, {
        onSuccess: handleSuccess,
        onError: handleError
    });
}

// EXTERNAL MODULE: ./src/hooks/query/company/useCompanyStates.tsx
var useCompanyStates = __webpack_require__(47720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 2 modules
var Button = __webpack_require__(71664);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/features/admin/Preferences/ButtonAdmin/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border-width: 0;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &[disabled] {\n    background-color: ",
        ";\n    color: ",
        ";\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var cssDefaultInline = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});

;// CONCATENATED MODULE: ./src/features/admin/Preferences/ButtonAdmin/index.tsx






function ButtonAdmin(_param) {
    var children = _param.children, inlineCss = _param.inlineCss, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "inlineCss"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        variant: "light",
        size: "md",
        inlineCss: [
            cssDefaultInline,
            inlineCss
        ]
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/features/admin/Preferences/Row/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 15px 0;\n  border-bottom: 1px solid ",
        ";\n\n  &:last-child {\n    border-bottom-width: 0;\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 10px;\n  margin-right: 60px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: 700;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-221bc775-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-221bc775-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B1;
});
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-221bc775-2"
})(_templateObject2(), function(param) {
    var alignItems = param.alignItems;
    return alignItems || "center";
});

;// CONCATENATED MODULE: ./src/features/admin/Preferences/Row/index.tsx


function Row(param) {
    var children = param.children, title = param.title, alignItems = param.alignItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                alignItems: alignItems,
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowClosing/helper.ts

function convertDateToISODate(str) {
    return new Date(str).toISOString();
}
function convertDateToFormattedStr(str) {
    if (str) {
        return dayjs_min_default()(str).format("YYYY-MM-DD");
    }
}

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowClosing/style.ts

function RowClosing_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 15px;\n"
    ]);
    RowClosing_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 5px;\n  text-align: left;\n  margin-right: 40px;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 315px;\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 4px;\n  border-width: 0;\n  vertical-align: top;\n  background-color: ",
        ";\n  font-size: ",
        ";\n\n  &[disabled] {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &::placeholder,\n  &::-webkit-input-placeholder {\n    color: ",
        ";\n  }\n\n  &::-webkit-calendar-picker-indicator {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var WrapperCalendar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e72dc5fd-0"
})(RowClosing_style_templateObject());
var Disclaimer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e72dc5fd-1"
})(style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return disabled ? theme.colors.gray900 : theme.colors.gray700;
});
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-e72dc5fd-2"
})(style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowClosing/index.tsx









function RowClosing() {
    var ref = (0,react.useState)(), closedAt = ref[0], setClosedAt = ref[1];
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref1 = (0,useCompanyStates/* default */.Z)(companyId), originCompanyStates = ref1.data;
    var ref2 = useCompanyCloseMutation(), handleClosing = ref2.mutate;
    var handleClick = function() {
        if (!closedAt) {
            // TODO: Modal 적용
            alert("날짜를 입력해주세요");
            return;
        }
        handleClosing({
            closedAt: convertDateToISODate(closedAt)
        });
    };
    (0,react.useEffect)(function() {
        if (originCompanyStates) {
            setClosedAt(convertDateToFormattedStr(originCompanyStates.closedAt));
        }
    }, [
        originCompanyStates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
        title: "폐업 처리",
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperCalendar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                        placeholder: "연도 - 월 - 일",
                        type: "date",
                        value: closedAt,
                        disabled: originCompanyStates === null || originCompanyStates === void 0 ? void 0 : originCompanyStates.closed,
                        onChange: function(e) {
                            setClosedAt(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer, {
                        disabled: originCompanyStates === null || originCompanyStates === void 0 ? void 0 : originCompanyStates.closed,
                        children: "(폐업처리 시 입력 필수)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdmin, {
                onClick: handleClick,
                disabled: originCompanyStates === null || originCompanyStates === void 0 ? void 0 : originCompanyStates.closed,
                children: "완료"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowDelete/style.ts

function RowDelete_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 15px;\n"
    ]);
    RowDelete_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var cssButton = (0,styled_components_browser_esm/* css */.iv)(RowDelete_style_templateObject());

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowDelete/index.tsx







function RowDelete() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyStates/* default */.Z)(companyId), companyStates = ref.data;
    var ref1 = useCompanyDeleteMutation(), handleDelete = ref1.mutate;
    var ref2 = useCompanyRestoreMutation(), handleRestore = ref2.mutate;
    var handleClickDelete = function() {
        if (window.confirm("이 기업을 정말 삭제하시겠습니까?")) {
            handleDelete();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
        title: "기업 삭제",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdmin, {
                onClick: handleClickDelete,
                disabled: companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted,
                inlineCss: cssButton,
                children: "삭제하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdmin, {
                onClick: function() {
                    return handleRestore();
                },
                disabled: !(companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted),
                children: "복원하기"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/SwitchButton/style.ts

function SwitchButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  user-select: none;\n"
    ]);
    SwitchButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwitchButton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 5px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: 700;\n"
    ]);
    SwitchButton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SwitchButton_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n"
    ]);
    SwitchButton_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      &::before {\n        left: 22px;\n        background-image: url('/images/ico-switch-checked.svg');\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 44px;\n  height: 24px;\n  display: block;\n  background-color: ",
        ";\n  border-radius: 12px;\n  margin-bottom: 0;\n  cursor: pointer;\n\n  &::before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-image: url('/images/ico-switch.svg');\n    border-radius: 50%;\n    transition: left 0.1s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n\n  &:disabled + ",
        " {\n    opacity: 0.3;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var style_Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c171201e-0"
})(SwitchButton_style_templateObject());
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c171201e-1"
})(SwitchButton_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
});
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c171201e-2"
})(SwitchButton_style_templateObject2());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-c171201e-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(param) {
    var checked = param.checked;
    return checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
});
var style_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-c171201e-4"
})(_templateObject5(), Label);

;// CONCATENATED MODULE: ./src/components/SwitchButton/index.tsx


function SwitchButton(param) {
    var id = param.id, onChange = param.onChange, label = param.label, disabled = param.disabled, checked = param.checked;
    var handleChange = function(e) {
        if (onChange) {
            onChange(e.target.checked);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Wrapper, {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Input, {
                        type: "checkbox",
                        id: id,
                        checked: checked,
                        onChange: handleChange,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        checked: checked,
                        htmlFor: id,
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowDetail/style.ts

function RowDetail_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 40px;\n    "
    ]);
    RowDetail_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RowDetail_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    RowDetail_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RowDetail_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 20px;\n  margin: 0 40px;\n  background-color: ",
        ";\n"
    ]);
    RowDetail_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff111487-0"
})(RowDetail_style_templateObject1(), function(param) {
    var noMargin = param.noMargin;
    return !noMargin && (0,styled_components_browser_esm/* css */.iv)(RowDetail_style_templateObject());
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff111487-1"
})(RowDetail_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});

;// CONCATENATED MODULE: ./src/features/admin/Preferences/RowDetail/index.tsx










function RowDetail() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyStates/* default */.Z)(companyId), originCompanyStates = ref.data;
    var ref1 = (0,react.useState)(), companyStates = ref1[0], setCompanyStates = ref1[1];
    var ref2 = useCompanyInfoMutation(), handleCompanyInfo = ref2.mutate;
    var updateCompanyStates = function(newValue) {
        setCompanyStates(function(prevState) {
            return (0,src_object_spread/* default */.Z)({}, prevState, newValue);
        });
    };
    (0,react.useEffect)(function() {
        if (originCompanyStates) {
            var salary = originCompanyStates.salary, employee = originCompanyStates.employee, sales = originCompanyStates.sales, board = originCompanyStates.board, rank = originCompanyStates.rank;
            setCompanyStates({
                salary: salary,
                employee: employee,
                sales: sales,
                board: board,
                rank: rank
            });
        }
    }, [
        originCompanyStates
    ]);
    if (!companyStates) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
        title: "정보노출",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    id: "admin-preferences-salary",
                    label: "연봉",
                    checked: companyStates === null || companyStates === void 0 ? void 0 : companyStates.salary,
                    onChange: function(checked) {
                        updateCompanyStates({
                            salary: checked
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    id: "admin-preferences-employee",
                    label: "인원",
                    checked: companyStates === null || companyStates === void 0 ? void 0 : companyStates.employee,
                    onChange: function(checked) {
                        updateCompanyStates({
                            employee: checked
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    id: "admin-preferences-sales",
                    label: "매출",
                    checked: companyStates === null || companyStates === void 0 ? void 0 : companyStates.sales,
                    onChange: function(checked) {
                        updateCompanyStates({
                            sales: checked
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                noMargin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    id: "admin-preferences-board",
                    label: "잡담",
                    checked: companyStates === null || companyStates === void 0 ? void 0 : companyStates.board,
                    onChange: function(checked) {
                        updateCompanyStates({
                            board: checked
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    id: "admin-preferences-rank",
                    label: "홈 랭킹",
                    checked: companyStates === null || companyStates === void 0 ? void 0 : companyStates.rank,
                    onChange: function(checked) {
                        updateCompanyStates({
                            rank: checked
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdmin, {
                onClick: function() {
                    return handleCompanyInfo(companyStates);
                },
                children: "저장"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/admin/Preferences/style.ts

function Preferences_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Preferences_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Preferences_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1180px;\n  margin: 0 auto;\n"
    ]);
    Preferences_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Preferences_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59a6e005-0"
})(Preferences_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59a6e005-1"
})(Preferences_style_templateObject1());

;// CONCATENATED MODULE: ./src/features/admin/Preferences/index.tsx







function Preferences() {
    var isAdmin = (0,admin/* default */.Z)().isAdmin;
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    if (!isAdmin || !isDesktop) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences_style_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Contents, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDetail, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowClosing, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDelete, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/utils/common/thirdPartyEvent.ts
var thirdPartyEvent = __webpack_require__(44278);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(34527);
;// CONCATENATED MODULE: ./src/utils/lodash/throttle/index.ts
/**
 * throttle 입니다.
 * @param {Function} callback - delay(지연) 이후에 실행되는 함수입니다.
 * @param {number} delay - delay(지연)시킬 시간 millisecond 기준.
 * @example
 * ```ts
 *  const callbackFunc = () => {
 *    return 'callback'
 *  }
 *
 *  throttle(callback, 300);
 * ```
 */ 
function throttle(callback, delay) {
    var isThrottle = false;
    return function throttledCallback() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isThrottle === false) {
            callback.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
            isThrottle = true;
            setTimeout(function() {
                isThrottle = false;
            }, delay);
        }
    };
}
/* harmony default export */ var lodash_throttle = (throttle);

;// CONCATENATED MODULE: ./src/features/company/Aside/AsideCard/style.ts

function AsideCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px;\n      ",
        " {\n        padding: 30px 20px;\n      }\n    "
    ]);
    AsideCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AsideCard_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 32px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  background-color: ",
        ";\n\n  &::last-child {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    margin-bottom: 16px;\n    border-width: 0;\n    border-radius: 0;\n  }\n\n  ",
        "\n"
    ]);
    AsideCard_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var AsideCard_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b413838-0"
})(AsideCard_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var noPadding = param.noPadding, theme = param.theme;
    return !noPadding && (0,styled_components_browser_esm/* css */.iv)(AsideCard_style_templateObject(), theme.media.mobile);
});

;// CONCATENATED MODULE: ./src/features/company/Aside/AsideCard/index.tsx





function AsideCard(_param) {
    var children = _param.children, noPadding = _param.noPadding, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "noPadding"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideCard_style_Wrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        noPadding: noPadding
    }, props), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/Loading/index.tsx + 1 modules
var Loading = __webpack_require__(72688);
;// CONCATENATED MODULE: ./src/features/company/CardTitle/style.ts

function CardTitle_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  color: #333;\n  text-align: left;\n"
    ]);
    CardTitle_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-57d6d9b1-0"
})(CardTitle_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/CardTitle/index.tsx


function CardTitle(param) {
    var children = param.children;
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Title, {
        children: children
    });
};

// EXTERNAL MODULE: ./src/features/company/CompanyLogoCard.tsx
var CompanyLogoCard = __webpack_require__(75561);
// EXTERNAL MODULE: ./src/components/Text/helper.ts
var helper = __webpack_require__(24985);
;// CONCATENATED MODULE: ./src/features/company/ErrorSection.tsx

function ErrorSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 30px 0;\n  color: ",
        ";\n"
    ]);
    ErrorSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ErrorSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorSection_Text, {
            children: [
                "예상하지 못한 에러가 발생했습니다.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "잠시 후 다시 시도해주세요."
            ]
        })
    });
};
var ErrorSection_Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7712775a-0"
})(ErrorSection_templateObject(), (0,helper/* getFontStyle */.p)("bold150_B2"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});

// EXTERNAL MODULE: ./src/lib/api/fetch.ts
var fetch = __webpack_require__(45767);
// EXTERNAL MODULE: ./src/hooks/query/queryKeys.ts
var queryKeys = __webpack_require__(24858);
;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyRelations.ts



var getUrl = function(id) {
    return "/api/company/".concat(id, "/relations");
};
/**
 * 연관기업 또는 실시간 검색 기업의 데이터 조회
 *
 * 연관기업의 데이터가 없는경우는 큐에 쌓인 실시간으로 검색된 데이터를 서버에서 반환하고 type으로 데이터유형 구분(RELATION | LIVE)
 * @param id 기업의 hash값
 */ function useGetCompanyRelations(id) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companyRelations */.Z.companyRelations,
        id
    ], function() {
        return (0,fetch/* fetcher */._)(getUrl(id));
    }, {
        enabled: !!id
    });
}

;// CONCATENATED MODULE: ./src/features/company/Aside/CompanyRelations/index.tsx


function CompanyRelations_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 108px 0;\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    CompanyRelations_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyRelations_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin-top: 30px;\n  gap: 15px;\n  grid-template-columns: 1fr 1fr;\n\n  ",
        " {\n    margin-top: 0;\n    gap: 20px;\n    margin-top: 40px;\n    grid-template-columns: inherit;\n  }\n"
    ]);
    CompanyRelations_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyRelations_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    padding-right: 10px;\n  }\n"
    ]);
    CompanyRelations_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









function CompanyRelations() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = useGetCompanyRelations(companyId), companyRelations = ref.data, statusCompanyRelations = ref.status;
    var title = (0,react.useMemo)(function() {
        if ((companyRelations === null || companyRelations === void 0 ? void 0 : companyRelations.type) === "LIVE") {
            return "실시간 검색 기업";
        }
        return "연관 기업";
    }, [
        companyRelations
    ]);
    if (statusCompanyRelations === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSectionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
                })
            ]
        });
    }
    if (statusCompanyRelations === "loading" || !companyRelations) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
                children: (0,_to_consumable_array/* default */.Z)(companyRelations.companies).splice(0, 4).map(function(company) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CompanyLogoCard/* default */.Z, {
                        companyId: company.id,
                        location: company.location,
                        locationCode: company.locationCode,
                        companyName: company.name,
                        PK_NM_HASH: company.PK_NM_HASH,
                        href: "/company/".concat(company.PK_NM_HASH),
                        inlineCss: cssCard,
                        "data-attribute-id": "company__search__click",
                        "data-search-value": company.name,
                        "data-search-type": (companyRelations === null || companyRelations === void 0 ? void 0 : companyRelations.type) === "LIVE" ? "실시간검색" : "연관검색"
                    }, "relations-".concat(company.id));
                })
            })
        ]
    });
};
var ErrorSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51d712f3-0"
})(CompanyRelations_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51d712f3-1"
})(CompanyRelations_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var cssCard = (0,styled_components_browser_esm/* css */.iv)(CompanyRelations_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Text/index.tsx + 1 modules
var components_Text = __webpack_require__(82734);
;// CONCATENATED MODULE: ./src/features/company/Aside/SalaryReportSection/style.ts

function SalaryReportSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n  text-align: center;\n"
    ]);
    SalaryReportSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryReportSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-bottom: 16px;\n  color: ",
        ";\n"
    ]);
    SalaryReportSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryReportSection_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  img {\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n  }\n"
    ]);
    SalaryReportSection_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var SalaryReportSection_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4481f51-0"
})(SalaryReportSection_style_templateObject());
var SalaryReportSection_style_Title = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-b4481f51-1"
})(SalaryReportSection_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var style_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b4481f51-2"
})(SalaryReportSection_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.blue500;
});

;// CONCATENATED MODULE: ./src/features/company/Aside/SalaryReportSection/index.tsx



function SalaryReportSection(param) {
    var companyName = param.companyName, PK_NM_HASH = param.PK_NM_HASH;
    var router = (0,next_router.useRouter)();
    var handleClick = function() {
        router.push("/salaryreport/step");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryReportSection_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryReportSection_style_Title, {
                typography: "midium150_B1",
                children: "내 연봉 순위가 궁금하다면?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Button, {
                size: "lg",
                onClick: handleClick,
                leading: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    srcSet: "https://image.wanted.co.kr/kreditjob/www/ico-trophy.png, https://image.wanted.co.kr/kreditjob/www/ico-trophy@2x.png 2x",
                    src: "https://image.wanted.co.kr/kreditjob/www/ico-trophy.png",
                    alt: ""
                }),
                "data-attribute-id": "company__salaryRank__click",
                "data-company-name": companyName,
                "data-company-hash": PK_NM_HASH,
                children: "연봉 제보하기"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/GoogleAdsBanner/index.tsx + 2 modules
var GoogleAdsBanner = __webpack_require__(85326);
;// CONCATENATED MODULE: ./src/features/company/Aside/style.ts

function Aside_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    position: fixed;\n    top: 135px;\n    right: 50%;\n    margin-right: -568px;\n  }\n"
    ]);
    Aside_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Aside_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    position: absolute;\n    top: ",
        "px;\n    right: 0;\n    margin-right: 0;\n  }\n"
    ]);
    Aside_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Aside_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n\n  ",
        " {\n    margin-bottom: 32px;\n  }\n\n  ",
        " {\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin-bottom: 0;\n  }\n"
    ]);
    Aside_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    position: absolute;\n    right: 0;\n    margin-right: 0;\n    width: 300px;\n  }\n\n  ",
        ";\n  ",
        "\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: 0 auto;\n    text-align: center;\n  }\n"
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var cssSticky = (0,styled_components_browser_esm/* css */.iv)(Aside_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var cssStickyFixed = (0,styled_components_browser_esm/* css */.iv)(Aside_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
}, function(param) {
    var fixedStickyTop = param.fixedStickyTop;
    return fixedStickyTop;
});
var Aside_style_Wrapper = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-a38599e1-0"
})(Aside_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var style_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38599e1-1"
})(style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
}, function(param) {
    var isSticky = param.isSticky;
    return isSticky && cssSticky;
}, function(param) {
    var fixedStickyTop = param.fixedStickyTop;
    return fixedStickyTop && cssStickyFixed;
});
var style_GoogleAdsBanner = (0,styled_components_browser_esm/* default */.ZP)(GoogleAdsBanner/* default */.Z).withConfig({
    componentId: "sc-a38599e1-2"
})(style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});

;// CONCATENATED MODULE: ./src/features/company/Aside/index.tsx









function Aside(param) {
    var companyInfo = param.companyInfo, targetRef = param.targetRef;
    var ref = (0,react.useRef)(null);
    var contentsRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), isActiveScrollEvent = ref1[0], setIsActiveScrollEvent = ref1[1];
    var ref2 = (0,react.useState)(0), fixedStickyTop = ref2[0], setFixedStickyTop = ref2[1];
    var ref3 = (0,useMedia/* default */.Z)(), isMobile = ref3.isMobile, isDesktop = ref3.isDesktop, isTablet = ref3.isTablet, isReady = ref3.isReady;
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "-138px 0px 300px",
        threshold: 1
    });
    (0,react.useEffect)(function() {
        var gapFromManageSection = 233;
        var fixedContentsOffsetTop = 135;
        var topArea = 280;
        var handleScroll = function() {
            if (targetRef.current && contentsRef.current) {
                var ref;
                var footerOffsetTop = targetRef.current.offsetTop;
                var contentsHeight = (ref = contentsRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
                var top = footerOffsetTop - gapFromManageSection - contentsHeight - topArea;
                var triggerPoint = window.scrollY + contentsHeight + fixedContentsOffsetTop + gapFromManageSection;
                if (footerOffsetTop < triggerPoint) {
                    setFixedStickyTop(top);
                } else {
                    setFixedStickyTop(0);
                }
            }
        };
        if (!isMobile && !isActiveScrollEvent) {
            window.addEventListener("scroll", lodash_throttle(handleScroll, 100));
            setIsActiveScrollEvent(true);
            setTimeout(function() {
                handleScroll();
            }, 800);
        }
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        targetRef,
        isMobile,
        isActiveScrollEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_style_Wrapper, {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Contents, {
            ref: contentsRef,
            isSticky: !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting),
            fixedStickyTop: fixedStickyTop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideCard, {
                    noPadding: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryReportSection, {
                        companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        PK_NM_HASH: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AsideCard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyRelations, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    "data-attribute-id": "company__banner__click",
                    "data-banner-location": "right",
                    "data-banner-type": "ads",
                    children: [
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_GoogleAdsBanner, {
                            bannerType: "mobileBanner",
                            slotId: "8076432031"
                        }),
                        isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_GoogleAdsBanner, {
                            bannerType: "leaderBoard",
                            slotId: "8397610632"
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_GoogleAdsBanner, {
                            bannerType: "mediumRectangle",
                            slotId: "3872914400"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Badge/style.ts

function Badge_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 1.5px 4px;\n    border-radius: 9px;\n\n    color: ",
        ";\n    background-color: ",
        ";\n    ",
        ";\n  "
    ]);
    Badge_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var S = {
    StyledBadge: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-9872e661-0"
    })(Badge_style_templateObject(), function(param) {
        var fontColor = param.fontColor;
        return fontColor;
    }, function(param) {
        var bgColor = param.bgColor;
        return bgColor;
    }, (0,helper/* getFontStyle */.p)("midium120_C1"))
};

;// CONCATENATED MODULE: ./src/components/Badge/index.tsx


function Badge(param) {
    var fontColor = param.fontColor, bgColor = param.bgColor, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(S.StyledBadge, {
        fontColor: fontColor,
        bgColor: bgColor,
        children: children
    });
}
/* harmony default export */ var components_Badge = (Badge);

// EXTERNAL MODULE: ./src/components/common/Tooltip/index.tsx
var Tooltip = __webpack_require__(66185);
// EXTERNAL MODULE: ./src/components/Icon/ExclamationMark.tsx
var ExclamationMark = __webpack_require__(17353);
;// CONCATENATED MODULE: ./src/constant/company.ts
// order 중요
var COMPANY_DETAIL_MENU = {
    COMPANY_SUMMARY: "company-summary",
    REVIEW: "company-review",
    INTERVIEW_REVIEW: "interview-review",
    EMPLOYEE: "employee",
    SALARY: "salary",
    SALES: "sales",
    COMMUNITY: "community"
};
var COMPANY_DETAIL_MENU_OBJ_LIST = [
    {
        id: COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
        text: "기업 요약"
    },
    {
        id: COMPANY_DETAIL_MENU.REVIEW,
        text: "다녀본 리뷰"
    },
    {
        id: COMPANY_DETAIL_MENU.INTERVIEW_REVIEW,
        text: "면접 리뷰",
        isNew: true
    },
    {
        id: COMPANY_DETAIL_MENU.EMPLOYEE,
        text: "인원"
    },
    {
        id: COMPANY_DETAIL_MENU.SALARY,
        text: "연봉"
    },
    {
        id: COMPANY_DETAIL_MENU.SALES,
        text: "매출"
    },
    {
        id: COMPANY_DETAIL_MENU.COMMUNITY,
        text: "JOB담"
    }, 
];
var COMPANY_DETAIL_MENU_OBJ_LIST_B = [
    {
        id: COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
        text: "기업 요약"
    },
    {
        id: COMPANY_DETAIL_MENU.REVIEW,
        text: "다녀본 리뷰"
    },
    {
        id: COMPANY_DETAIL_MENU.INTERVIEW_REVIEW,
        text: "면접 리뷰",
        isNew: true
    },
    {
        id: COMPANY_DETAIL_MENU.EMPLOYEE,
        text: "인원"
    },
    {
        id: COMPANY_DETAIL_MENU.SALARY,
        text: "연봉"
    },
    {
        id: COMPANY_DETAIL_MENU.SALES,
        text: "매출"
    }, 
];

;// CONCATENATED MODULE: ./src/features/company/CompanySectionTitle.tsx

function CompanySectionTitle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: left;\n  ",
        ";\n  ",
        ";\n\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n\n  gap: 5px;\n"
    ]);
    CompanySectionTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function CompanySectionTitle(param) {
    var children = param.children, inlineCss = param.inlineCss;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySectionTitle_Wrapper, {
        inlineCss: inlineCss,
        children: children
    });
};
var CompanySectionTitle_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a9c4d74-0"
})(CompanySectionTitle_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B2"), function(param) {
    var inlineCss = param.inlineCss;
    return inlineCss;
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/hooks/query/user/useMyInfoQuery.tsx + 2 modules
var useMyInfoQuery = __webpack_require__(9419);
// EXTERNAL MODULE: ./node_modules/chart.js/dist/chart.mjs
var chart = __webpack_require__(66775);
// EXTERNAL MODULE: ./node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.esm.js + 2 modules
var chartjs_plugin_datalabels_esm = __webpack_require__(56429);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.js
var dist = __webpack_require__(55376);
;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyEmployeeChart.ts



var url = function(companyId) {
    return "/api/company/".concat(companyId, "/employeesChart");
};
function useGetCompanyEmployeeChartData(companyId) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companyEmployeeChart */.Z.companyEmployeeChart,
        companyId
    ], function() {
        return (0,fetch/* fetcher */._)(url(companyId));
    }, {
        enabled: !!companyId
    });
};

// EXTERNAL MODULE: ./src/utils/lodash/isEqual/index.ts + 1 modules
var isEqual = __webpack_require__(48192);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/ButtonGroup/style.ts

function ButtonGroup_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  margin-top: 40px;\n  margin-bottom: 20px;\n"
    ]);
    ButtonGroup_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-right: 1px solid ",
        ";\n      "
    ]);
    ButtonGroup_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-left: 1px solid ",
        ";\n      "
    ]);
    ButtonGroup_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    ButtonGroup_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    ButtonGroup_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 32px;\n  background: none;\n  padding: 0;\n  border-width: 0;\n  ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n\n  &:first-child {\n    border-radius: 16px 0px 0px 16px;\n\n    ",
        "\n  }\n\n  &:nth-child(2) {\n    border-left: none;\n    border-right: none;\n  }\n  &:last-child {\n    border-radius: 0px 16px 16px 0px;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ButtonGroup_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4fb76ee-0"
})(ButtonGroup_style_templateObject());
var ButtonGroup_style_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d4fb76ee-1"
})(_templateObject6(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var year = param.year;
    return year === 3 && (0,styled_components_browser_esm/* css */.iv)(ButtonGroup_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var year = param.year;
    return year === 3 && (0,styled_components_browser_esm/* css */.iv)(ButtonGroup_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 1 && (0,styled_components_browser_esm/* css */.iv)(ButtonGroup_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 5 && (0,styled_components_browser_esm/* css */.iv)(ButtonGroup_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 3 && (0,styled_components_browser_esm/* css */.iv)(style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/ButtonGroup/index.tsx


var YEARS = [
    1,
    3,
    5
];
function ButtonGroup(param) {
    var currentYear = param.currentYear, onClick = param.onClick;
    var handleClick = function(year) {
        if (onClick) {
            onClick(year);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup_style_Wrapper, {
        children: YEARS.map(function(year) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup_style_Button, {
                active: currentYear === year,
                year: currentYear,
                "data-attribute-id": "company__personnel__filter__click",
                "data-year": "".concat(year, "년"),
                onClick: function() {
                    return handleClick(year);
                },
                children: "".concat(year, "년")
            }, "employee-chart-button-".concat(year));
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/GuideMessage/style.ts

function GuideMessage_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    GuideMessage_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GuideMessage_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 10px 20px;\n  background: rgba(244, 244, 244, 0.9);\n  border-radius: 4px;\n  text-align: center;\n  transform: translate3d(-50%, -50%, 0);\n  transition: all 0.2s;\n  opacity: 0;\n  ",
        ";\n\n  ",
        "\n\n  ",
        " {\n    width: 180px;\n    margin-top: -20px;\n  }\n"
    ]);
    GuideMessage_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var GuideMessage_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d197a4ab-0"
})(GuideMessage_style_templateObject1(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var isEntered = param.isEntered;
    return isEntered && (0,styled_components_browser_esm/* css */.iv)(GuideMessage_style_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/GuideMessage/index.tsx




function GuideMessage() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), isEntered = ref[0], setIsEntered = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setIsEntered(true);
        }, 150);
    }, []);
    return(// FIXME: Sales Guide message랑 통일
    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideMessage_style_Wrapper, {
        isEntered: isEntered,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "".concat(isMobile ? "손가락" : "마우스", "를 올려"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "상세 정보를 확인해 보세요."
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/GuideMessage/hooks.ts


function useDisplayTrigger(ref) {
    var _$ref = (0,react.useState)(), isDisplayed = _$ref[0], setIsDisplayed = _$ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && !isDisplayed) {
            setIsDisplayed(true);
        }
    }, [
        entry,
        isDisplayed
    ]);
    return isDisplayed || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
}

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/helper.ts



/**
 * 오늘 기준으로 1년,3년,5년의 모든 월정보를 문자열 배열로 반환한다. (YYYY-MM)
 * byQuarter인 경우 분기가 종료되는 날짜의 정보만 가져온다.
 * @param year
 * @param byQuarter
 * @returns
 */ function getXAxisDates(year) {
    var length = year * 12;
    var dates = new Array(length).fill("");
    var lastYear = dayjs().subtract(year, "year").add(1, "month");
    dates.reduce(function(prev, current, index) {
        dates[index] = prev.format("YYYY-MM-01");
        return prev.add(1, "month");
    }, lastYear);
    return dates;
}
/**
 * 날짜를 특정년도만큼 잘라내고(1년/3년/5년) 오름차순으로 내려오는 데이터를 내림차순으로 변경
 * FIXME: 서버에 내림차순으로 내려줄 수 있는지
 *
 * @param data
 * @param year
 * @returns
 */ function getSliceData(data, year) {
    if (!data) {
        return [];
    }
    return data.slice(year * -12);
}
function getBarChartSizeProps(year, hasPadding) {
    switch(year){
        case 1:
            if (hasPadding) {
                return {
                    barThickness: 14,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 10
            };
        case 3:
            if (hasPadding) {
                return {
                    barThickness: 10,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 6
            };
        default:
            if (hasPadding) {
                return {
                    barThickness: 7,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 3
            };
    }
}
function getQuarter(month) {
    return Math.ceil(month / 3);
}
/**
 * 쿼터별로 데이터를 머지한다.
 * date는 YYYY.NQ
 * @param data
 */ function getDataByQuarter(data, year) {
    var periodNum = 3;
    var result = [];
    var slicedData = getSliceData(data, year);
    slicedData.reduce(function(prev, current, index) {
        var date = dayjs_min_default()(current.date);
        var month = date.get("month") + 1;
        var quarter = getQuarter(month);
        if (prev === null) {
            // 분기/년의 첫번째 개월이자 데이터의 마지막 요소인 경우
            if (index === slicedData.length - 1) {
                result.push((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, current), {
                    date: "".concat(date.format("YYYY"), ".").concat(quarter, "Q")
                }));
                return null;
            }
            return current;
        }
        if (month % periodNum === 0 || index === slicedData.length - 1) {
            result.push({
                date: "".concat(date.format("YYYY"), ".").concat(quarter, "Q"),
                hired: prev.hired + current.hired,
                left: prev.left + current.left,
                total: current.total || prev.total
            });
            return null;
        }
        return {
            total: current.total,
            hired: prev.hired + current.hired,
            left: prev.left + current.left
        };
    }, null);
    return result;
}
function getLabelsByPediod(data, period, year) {
    if (period !== 12) {
        return data.map(function(item) {
            return item.date;
        });
    }
    var periodNum = 3;
    var result = [];
    // @ts-ignore
    data.reduce(function(prev, current, index) {
        var date = dayjs_min_default()(current.date);
        var month = date.get("month") + 1;
        var quarter = getQuarter(month);
        if (prev === null) {
            if (index === data.length - 1) {
                result.push("".concat(date.format("YYYY"), ".").concat(quarter, "Q"));
                return null;
            }
            return current;
        }
        if (month % periodNum === 0 || index === data.length - 1) {
            result.push("".concat(date.format("YYYY"), ".").concat(quarter, "Q"));
            return null;
        }
        return {
            // @ts-ignore
            hired: prev.hired + current.hired,
            // @ts-ignore
            left: prev.left + current.left
        };
    }, null);
    return getSliceData(result, year);
}
/**
 * 이번달 기준으로 1년, 3년, 5년치의 템플릿 데이터를 반환
 * @param year
 * @returns
 */ function getDateArrayTemplate(year) {
    var today = dayjs_min_default()();
    var months = year * 12;
    var result = [];
    for(var i = 1; i <= months; i++){
        var date = today.subtract(months - i, "month");
        result.push({
            date: date.format("YYYY-MM-01"),
            total: null,
            hired: null,
            left: null
        });
    }
    return result;
}
/**
 * 실제 데이터와 template을 합병한 결과 반환
 * @param year
 * @param data
 * @returns
 */ function getMergedDateArray(year, data) {
    var template = getDateArrayTemplate(year);
    data.forEach(function(dateObj) {
        var date = dateObj.date;
        var hired = dateObj.hired, total = dateObj.total, left = dateObj.left;
        var targetIndex = template.findIndex(function(obj) {
            return obj.date === date;
        });
        if (targetIndex >= 0) {
            template[targetIndex]["hired"] = hired;
            template[targetIndex]["total"] = total;
            template[targetIndex]["left"] = left;
        }
    });
    return template;
}
/**
 * 객체의 total값 유무에 따라 데이터가 유효한지 판단
 * @param data
 * @returns
 */ function getIsEmptyData(data) {
    return data.every(function(obj) {
        return !obj.total;
    });
}

// EXTERNAL MODULE: ./src/lib/styles/Theme/colors.ts
var colors = __webpack_require__(18978);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/constants.ts

var LINE_STYLE = {
    backgroundColor: colors/* default.magenta500 */.Z.magenta500,
    borderColor: colors/* default.magenta500 */.Z.magenta500,
    borderWidth: 1
};
var POINT_STYLE = {
    pointStyle: "circle",
    pointBorderColor: colors/* default.magenta500 */.Z.magenta500,
    pointRadius: 3.5,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 4,
    pointHoverBackgroundColor: colors/* default.white100 */.Z.white100
};
var DEFAULT_CHART_STYLE = {
    borderWidth: 0
};
var DEFAULT_OPTIONS = {
    animation: {
        duration: 100
    },
    interaction: {
        intersect: false,
        mode: "index"
    },
    plugins: {
        legend: {
            display: false
        },
        datalabels: {
            labels: {
                value: {
                    display: false
                }
            }
        }
    },
    parsing: {
        xAxis: "hired",
        yAxis: "left"
    },
    scales: {
        y: {
            ticks: {
                display: false
            },
            grid: {
                drawBorder: false,
                color: colors/* default.gray300 */.Z.gray300
            }
        },
        x: {
            ticks: {
                autoSkip: true,
                color: colors/* default.gray700 */.Z.gray700,
                font: {
                    size: 10,
                    weight: "500",
                    family: "Pretendard"
                }
            },
            grid: {
                display: false
            }
        }
    }
};
var TOOLTIP_LINE_PLUGINS = {
    id: "tooltipLine",
    // @ts-ignore
    beforeDraw: function(chart) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
            var ctx = chart.ctx;
            ctx.save();
            var activePoint = chart.tooltip._active[0];
            ctx.beginPath();
            ctx.setLineDash([
                2,
                2
            ]);
            ctx.moveTo(activePoint.element.x, chart.chartArea.top);
            ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = colors/* default.gray600 */.Z.gray600;
            ctx.stroke();
            ctx.restore();
        }
    }
};
var TOOLTIP_CONNECT_DASH = {
    // @ts-ignore
    afterDraw: function(chart) {
        var ctx = chart.ctx;
        ctx.save();
        var datasets = chart.data.datasets;
        var ref = datasets[0], lineChartData = ref.data;
        ctx.strokeStyle = colors/* default.magenta500 */.Z.magenta500;
        var xFrom = null;
        var yFrom = null;
        var dirty = false;
        var data = chart.getDatasetMeta(0).data;
        if (!data || data.length === 0) {
            return true;
        }
        // @ts-ignore
        data.forEach(function(obj, index) {
            var ref;
            if (index === lineChartData.length - 1) {
                return;
            }
            var x = obj.x, y = obj.y, skip = obj.skip;
            var isNextSkiped = (ref = data[index + 1]) === null || ref === void 0 ? void 0 : ref.skip;
            if (!skip && isNextSkiped) {
                xFrom = x;
                yFrom = y;
                dirty = true;
            }
            if (skip && !isNextSkiped && dirty) {
                var ref1, ref2;
                var targetX = (ref1 = data[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.x;
                var targetY = (ref2 = data[index + 1]) === null || ref2 === void 0 ? void 0 : ref2.y;
                ctx.lineWidth = 1;
                ctx.setLineDash([
                    2,
                    2
                ]);
                ctx.beginPath();
                ctx.moveTo(xFrom, yFrom);
                ctx.lineTo(targetX, targetY);
                ctx.stroke();
                xFrom = null;
                yFrom = null;
            }
        });
        ctx.restore();
    }
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/hooks.ts









function useChartProps(param) {
    var originData = param.originData, year = param.year, externalTooltipHandler = param.externalTooltipHandler;
    var ref = (0,react.useState)(), isInteracted = ref[0], setIsInteracted = ref[1];
    var displayMode = useGetDisplayMode(year);
    var datasetsData = useGetDatasetsData(originData, year);
    var labels = useGetLabels(originData, year);
    var ref1 = (0,react.useState)(POINT_STYLE), pointStyle = ref1[0], setPointStyle = ref1[1];
    (0,react.useEffect)(function() {
        if (year === 5) {
            setPointStyle((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, POINT_STYLE), {
                pointRadius: 2.5,
                pointHoverRdius: 3.5,
                pointHoverBorderWidth: 2.5
            }));
        } else {
            setPointStyle(POINT_STYLE);
        }
    }, [
        year
    ]);
    var data = (0,react.useMemo)(function() {
        return {
            labels: labels,
            datasets: [
                (0,src_object_spread/* default */.Z)({
                    type: "line",
                    label: "전체인원",
                    data: datasetsData,
                    parsing: {
                        xAxisKey: "date",
                        yAxisKey: "total"
                    }
                }, LINE_STYLE, pointStyle),
                (0,src_object_spread/* default */.Z)({
                    type: "bar",
                    label: "입사자",
                    data: datasetsData,
                    parsing: {
                        xAxisKey: "date",
                        yAxisKey: "hired"
                    },
                    backgroundColor: "#F8DDC7"
                }, DEFAULT_CHART_STYLE, getBarChartSizeProps(year, true)),
                (0,src_object_spread/* default */.Z)({
                    type: "bar",
                    label: "퇴사자",
                    data: datasetsData,
                    parsing: {
                        xAxisKey: "date",
                        yAxisKey: "left"
                    },
                    backgroundColor: "#87519B"
                }, DEFAULT_CHART_STYLE, getBarChartSizeProps(year)), 
            ]
        };
    }, [
        datasetsData,
        year,
        labels
    ]);
    var options = (0,react.useMemo)(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS), {
            onHover: function() {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
            },
            onClick: function(ctx) {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
                var _dataPoints = (0,_sliced_to_array/* default */.Z)(ctx.chart.tooltip.dataPoints, 3), totalPoint = _dataPoints[0], hiredPoint = _dataPoints[1], leftPoint = _dataPoints[2];
                if (totalPoint && hiredPoint && leftPoint) {
                    var total = totalPoint.formattedValue;
                    var hired = hiredPoint.formattedValue;
                    var left = leftPoint.formattedValue;
                    var date = totalPoint.label;
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__personnel__graph__click", {
                        date: date,
                        totalCount: total,
                        entrantCount: hired,
                        leaverCount: left
                    });
                }
            },
            plugins: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS.plugins), {
                tooltip: {
                    enabled: false,
                    external: externalTooltipHandler
                }
            }),
            scales: {
                x: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS.scales.x), {
                    grid: (0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS.scales.x.grid),
                    ticks: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS.scales.x.ticks), {
                        // @ts-ignore
                        callback: function(value, index) {
                            if (!displayMode) {
                                return undefined;
                            }
                            var currentLabel = labels[index];
                            var thisMonth = dayjs_min_default()().get("month") + 1;
                            var quarter = getQuarter(thisMonth);
                            var date = dayjs_min_default()(currentLabel);
                            var month = date.get("month") + 1;
                            if (displayMode.labelsPeriod === 3 && Math.abs(thisMonth - month) % 3 === 0) {
                                return date.format("YYYY.MM");
                            }
                            if (displayMode.labelsPeriod === 6 && Math.abs(thisMonth - month) % 6 === 0) {
                                return date.format("YYYY.MM");
                            }
                            //  이 경우는 데이터도 쿼터별로 그룹핑 됨 (getDataByQuarter함수 참고)
                            if (displayMode.labelsPeriod === 12) {
                                if (labels[index].indexOf("".concat(quarter, "Q")) >= 0) {
                                    return labels[index];
                                }
                            }
                            return undefined;
                        }
                    })
                }),
                y: (0,src_object_spread/* default */.Z)({}, DEFAULT_OPTIONS.scales.y)
            }
        });
    }, [
        displayMode,
        labels,
        externalTooltipHandler
    ]);
    var plugins = [
        TOOLTIP_LINE_PLUGINS,
        TOOLTIP_CONNECT_DASH
    ];
    return {
        data: data,
        options: options,
        plugins: plugins,
        isInteracted: isInteracted
    };
}
function useGetDatasetsData(originData, year) {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        if (isMobile && year !== 1) {
            setData(getDataByQuarter(originData, year));
            return;
        }
        setData(getSliceData(originData, year));
    }, [
        originData,
        isMobile,
        year
    ]);
    return data;
}
function useGetLabels(originData, year) {
    var ref = (0,react.useState)([]), labels = ref[0], setLabels = ref[1];
    var displayMode = useGetDisplayMode(year);
    (0,react.useEffect)(function() {
        if (displayMode === null || displayMode === void 0 ? void 0 : displayMode.labelsPeriod) {
            var slicedData = getSliceData(originData, year);
            setLabels(getLabelsByPediod(slicedData, displayMode === null || displayMode === void 0 ? void 0 : displayMode.labelsPeriod, year));
        }
    }, [
        originData,
        displayMode
    ]);
    return labels;
}
/**
 *
 * @param year
 * @returns
 */ function useGetDisplayMode(year) {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), displayMode = ref[0], setDisplayMode = ref[1];
    (0,react.useEffect)(function() {
        if (year === 1) {
            setDisplayMode({
                labelsPeriod: 3,
                datasetDisplayMode: "month"
            });
            return;
        }
        if (isMobile) {
            setDisplayMode({
                labelsPeriod: 12,
                datasetDisplayMode: "quarter"
            });
            return;
        }
        setDisplayMode({
            labelsPeriod: 6,
            datasetDisplayMode: "month"
        });
    }, [
        year,
        isMobile
    ]);
    return displayMode;
}

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/Legends/constants.ts
var LEGEND_LIST = [
    {
        id: "전체인원",
        type: "total"
    },
    {
        id: "입사자",
        type: "hired"
    },
    {
        id: "퇴사자",
        type: "left"
    }, 
];

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/Legends/style.ts

function Legends_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          background: #f8ddc7;\n        }\n      "
    ]);
    Legends_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Legends_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          background: #87519b;\n        }\n      "
    ]);
    Legends_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Legends_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          width: 15px;\n          height: 3px;\n          background: #e27893;\n        }\n      "
    ]);
    Legends_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Legends_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n\n  ",
        " {\n    margin-top: 20px;\n  }\n"
    ]);
    Legends_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Legends_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 14px;\n  align-items: center;\n  color: ",
        ";\n  ",
        ";\n\n  &::before {\n    content: '';\n    display: block;\n    width: 9px;\n    height: 9px;\n    margin-right: 7px;\n  }\n\n  ",
        " {\n    margin-right: 44px;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  ",
        "\n"
    ]);
    Legends_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


function getCssByType(type) {
    switch(type){
        case "hired":
            return (0,styled_components_browser_esm/* css */.iv)(Legends_style_templateObject());
        case "left":
            return (0,styled_components_browser_esm/* css */.iv)(Legends_style_templateObject1());
        default:
            return (0,styled_components_browser_esm/* css */.iv)(Legends_style_templateObject2());
    }
}
var Legends_style_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b8ce319f-0"
})(Legends_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Legend = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b8ce319f-1"
})(Legends_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, (0,helper/* getFontStyle */.p)("midium120_C1"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var type = param.type;
    return getCssByType(type);
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/Legends/index.tsx



function Legends() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Legends_style_Wrapper, {
        children: LEGEND_LIST.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend, {
                type: item.type,
                children: item.id
            }, "employee-chart-legend-".concat(item.type));
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/TooltipEmployee/helper.ts

function helper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translate3d(-100%, -50%, 0);\n      margin-left: -15px;\n\n      &::before {\n        left: auto;\n        right: -7px;\n        border-top: 6px solid transparent;\n        border-bottom: 6px solid transparent;\n        border-left: 7px solid ",
        ";\n      }\n    "
    ]);
    helper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function helper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, -50%, 0);\n    margin-left: 15px;\n\n    &::before {\n      left: -7px;\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      border-right: 7px solid ",
        ";\n    }\n  "
    ]);
    helper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


function getCssByXAlign(xAlign) {
    if (xAlign === "right") {
        return (0,styled_components_browser_esm/* css */.iv)(helper_templateObject(), function(param) {
            var theme = param.theme;
            return theme.colors.magenta700;
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(helper_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}
function getDateString(date) {
    if (!date) {
        return null;
    }
    if (date.indexOf("Q") >= 0) {
        return date;
    }
    return dayjs_min_default()(date).format("YYYY.MM");
}

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/TooltipEmployee/style.ts

function TooltipEmployee_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-width: 150px;\n  background: ",
        ";\n  padding: 10px;\n  border-radius: 4px;\n  pointer-events: none;\n  transition: left 0.1s ease, top 0.1s ease, opacity 0.1s ease;\n\n  &::before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translate3d(0, -50%, 0);\n  }\n\n  ",
        ";\n"
    ]);
    TooltipEmployee_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipEmployee_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipEmployee_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TooltipEmployee_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 3px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipEmployee_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TooltipEmployee_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipEmployee_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TooltipEmployee_style_Wrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return {
        style: {
            left: "".concat($x, "px"),
            top: "".concat($y, "px"),
            opacity: $opacity
        }
    };
}).withConfig({
    componentId: "sc-b5a3872c-0"
})(TooltipEmployee_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var xAlign = param.xAlign;
    return getCssByXAlign(xAlign);
});
var style_Date = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5a3872c-1"
})(TooltipEmployee_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C2"));
var Total = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5a3872c-2"
})(TooltipEmployee_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_B3"));
var HiredAndLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5a3872c-3"
})(TooltipEmployee_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C1"));

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/TooltipEmployee/index.tsx



function TooltipEmployee(param) {
    var date = param.date, total = param.total, hired = param.hired, left = param.left, xAlign = param.xAlign, $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipEmployee_style_Wrapper, {
        $x: $x,
        $y: $y,
        xAlign: xAlign,
        $opacity: $opacity,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Date, {
                children: getDateString(date)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Total, {
                children: [
                    "전체: ",
                    total,
                    "명"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiredAndLeft, {
                children: [
                    "입사 ",
                    hired,
                    "명 / 퇴사: ",
                    left,
                    "명"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/ChartContents/style.ts

function ChartContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n"
    ]);
    ChartContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 610px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n\n  ",
        " {\n    width: 580px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ChartContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: ",
        ";\n  transform: translate3d(-50%, -50%, 0);\n  margin-top: -25px;\n  ",
        "\n\n  ",
        " {\n    margin-top: -15px;\n  }\n"
    ]);
    ChartContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ChartContents_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-0"
})(ChartContents_style_templateObject());
var ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-1"
})(ChartContents_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-2"
})(ChartContents_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/ChartContents/index.tsx


















chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL, chart/* Legend */.De, chart/* PointElement */.od, chart/* LineElement */.jn, chart/* Tooltip */.u);
function ChartContents(param) {
    var companyId = param.companyId;
    var wrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(3), year = ref[0], setYear = ref[1];
    var ref1 = (0,react.useState)(), tooltipProps = ref1[0], setTooltipProps = ref1[1];
    var ref2 = (0,react.useState)(), isEmptyData = ref2[0], setIsEmptyData = ref2[1];
    var ref3 = useGetCompanyEmployeeChartData(companyId), originData = ref3.data;
    var ref4 = (0,react.useState)([]), employeeChartData = ref4[0], setEmployeeChartData = ref4[1];
    var isDisplyGuide = useDisplayTrigger(wrapperRef);
    (0,react.useEffect)(function() {
        if (originData) {
            var mergedData = getMergedDateArray(year, originData);
            setEmployeeChartData(mergedData);
            setIsEmptyData(getIsEmptyData(mergedData));
        }
    }, [
        originData,
        year
    ]);
    var externalTooltipHandler = (0,react.useCallback)(function(context) {
        if (context.tooltip.opacity === 0) {
            // @ts-ignore
            setTooltipProps(function(prevState) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                    $opacity: 0
                });
            });
            return;
        }
        var tooltip = context.tooltip;
        var xAlign = tooltip.xAlign, dataPoints = tooltip.dataPoints;
        var _element = dataPoints[0].element, x = _element.x, y = _element.y;
        var _title = (0,_sliced_to_array/* default */.Z)(tooltip.title, 1), date = _title[0];
        if (dataPoints[2] === undefined) {
            setTooltipProps(undefined);
            return;
        }
        var ref = dataPoints[0], total = ref.formattedValue;
        var ref1 = dataPoints[1], hired = ref1.formattedValue;
        var ref2 = dataPoints[2], left = ref2.formattedValue;
        var newTooltipProps = {
            $x: x,
            $y: y,
            $opacity: 1,
            xAlign: xAlign,
            total: total,
            hired: hired,
            left: left,
            date: date
        };
        if (!(0,isEqual/* isEqual */.X)(tooltipProps, newTooltipProps)) setTooltipProps(newTooltipProps);
    }, [
        year,
        tooltipProps,
        employeeChartData
    ]);
    var ref5 = useChartProps({
        originData: employeeChartData,
        year: year,
        externalTooltipHandler: externalTooltipHandler
    }), data = ref5.data, options = ref5.options, plugins = ref5.plugins, isInteracted = ref5.isInteracted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartContents_style_Wrapper, {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legends, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartContainer, {
                children: [
                    employeeChartData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Line */.x1, {
                                data: data,
                                options: options,
                                plugins: plugins
                            }),
                            tooltipProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipEmployee, (0,src_object_spread/* default */.Z)({}, tooltipProps))
                        ]
                    }),
                    isEmptyData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoData, {
                        children: [
                            "최근 정보가 없습니다.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 기간을 변경해보세요."
                        ]
                    }),
                    isDisplyGuide && !isInteracted && /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideMessage, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                currentYear: year,
                onClick: function(year) {
                    return setYear(year);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constant/env.ts
var env = __webpack_require__(34572);
// EXTERNAL MODULE: ./src/hooks/useMoveOneIdPage.tsx
var useMoveOneIdPage = __webpack_require__(20774);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/SignupNudgeEmployeeChart/style.ts

function SignupNudgeEmployeeChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  cursor: pointer;\n"
    ]);
    SignupNudgeEmployeeChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SignupNudgeEmployeeChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 606px;\n  height: 269px;\n  margin: 0 auto;\n\n  ",
        " {\n    width: 100%;\n    height: 0;\n    padding-bottom: 58%;\n  }\n"
    ]);
    SignupNudgeEmployeeChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SignupNudgeEmployeeChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n"
    ]);
    SignupNudgeEmployeeChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SignupNudgeEmployeeChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  min-width: 224px;\n  padding: 16px 32px;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    SignupNudgeEmployeeChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SignupNudgeEmployeeChart_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  ",
        ";\n"
    ]);
    SignupNudgeEmployeeChart_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SignupNudgeEmployeeChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fdfba55-0"
})(SignupNudgeEmployeeChart_style_templateObject());
var VideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fdfba55-1"
})(SignupNudgeEmployeeChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-3fdfba55-2"
})(SignupNudgeEmployeeChart_style_templateObject2());
var MessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fdfba55-3"
})(SignupNudgeEmployeeChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fdfba55-4"
})(SignupNudgeEmployeeChart_style_templateObject4(), (0,helper/* getFontStyle */.p)("midium150_C1"));

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/SignupNudgeEmployeeChart/index.tsx












function SignupNudgeEmployeeChart(param) {
    var companyId = param.companyId;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var data = (0,useCompanyInfo/* default */.Z)(companyId).data;
    var videoAssetName = (0,react.useMemo)(function() {
        if (isMobile) {
            return "video-chart-personnel-m";
        }
        return "video-chart-personnel";
    }, [
        isMobile
    ]);
    var handleClick = function() {
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__personnel__login__click", {
            companyHash: data === null || data === void 0 ? void 0 : data.PK_NM_HASH,
            companyName: data === null || data === void 0 ? void 0 : data.name,
            graphType: "인원 월별"
        });
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#employee-linechart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeEmployeeChart_style_Wrapper, {
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legends, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoWrapper, {
                children: [
                    videoAssetName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Video, {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        playsInline: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".webm"),
                                type: "video/webm"
                            }, "/images/".concat(videoAssetName, ".webm")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".mp4"),
                                type: "video/mp4"
                            }, "/images/".concat(videoAssetName, ".mp4"))
                        ]
                    }, videoAssetName),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message, {
                                children: [
                                    data === null || data === void 0 ? void 0 : data.name,
                                    "의",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "평균인원 변동 추이가 궁금하다면?"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "magenta",
                                size: "sm",
                                children: "로그인"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
                currentYear: 3
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/style.ts

function EmployeeChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n  scroll-margin-top: 200px;\n"
    ]);
    EmployeeChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmployeeChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 610px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n\n  ",
        " {\n    width: 580px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    EmployeeChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmployeeChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: ",
        ";\n  transform: translate3d(-50%, -50%, 0);\n  margin-top: -25px;\n  ",
        "\n\n  ",
        " {\n    margin-top: -15px;\n  }\n"
    ]);
    EmployeeChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var EmployeeChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-0"
})(EmployeeChart_style_templateObject());
var style_ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-1"
})(EmployeeChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-2"
})(EmployeeChart_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeChart/index.tsx








function EmployeeChart(param) {
    var companyId = param.companyId;
    var router = (0,next_router.useRouter)();
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var wrapperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (wrapperRef.current && hash === "employee-linechart") {
            if (window) {
                router.replace(path);
                wrapperRef.current.scrollIntoView();
            }
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeChart_style_Wrapper, {
        ref: wrapperRef,
        children: !isActiveUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupNudgeEmployeeChart, {
            companyId: companyId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartContents, {
            companyId: companyId
        })
    });
};

;// CONCATENATED MODULE: ./src/types/company.ts
var COMPANY_SOURCE = {
    // 알리오 > 클린아이 > 금감원 > 국민연금 > 고용보험
    CORP: "기업 제공",
    ALIO: "알리오",
    EYE: "클린아이",
    FSS: "금감원",
    NPS: "국민연금"
};
var SalesSource = {
    CORP: "기업 제공",
    FSS: "금감원",
    NICE: "NICE"
};
var COMPANY_TYPE = {
    KOSPI: "코스피",
    KOSDAQ: "코스닥",
    KONEX: "코넥스",
    CORP: "일반기업",
    DEFAULT: "공공기관"
};
var WIKI_CATEGORY_TITLE;
(function(WIKI_CATEGORY_TITLE) {
    WIKI_CATEGORY_TITLE["HIGHSCHOOL"] = "고졸";
    WIKI_CATEGORY_TITLE["COLLEGE"] = "초대졸";
    WIKI_CATEGORY_TITLE["UNIVERSITY"] = "대졸";
    WIKI_CATEGORY_TITLE["MASTER"] = "대학원졸";
    WIKI_CATEGORY_TITLE["JIDR"] = "2~4년";
    WIKI_CATEGORY_TITLE["GJ"] = "5~7년";
    WIKI_CATEGORY_TITLE["CJ"] = "8~10년";
    WIKI_CATEGORY_TITLE["BJ"] = "10년 초과";
})(WIKI_CATEGORY_TITLE || (WIKI_CATEGORY_TITLE = {}));

// EXTERNAL MODULE: ./src/utils/common/number.ts
var number = __webpack_require__(5989);
// EXTERNAL MODULE: ./src/utils/formatted/number.ts
var formatted_number = __webpack_require__(23230);
;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyEmployee.ts







var useCompanyEmployee_getUrl = function(companyHash) {
    return "/api/company/".concat(companyHash, "/employee");
};
function useGetCompanyEmplyee(isClosed, companyHash) {
    var ref = (0,react.useState)([]), source = ref[0], setSource = ref[1];
    var ref1 = (0,index_production.useQuery)([
        queryKeys/* default.companyEmployee */.Z.companyEmployee,
        companyHash
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanyEmployee_getUrl(companyHash));
    }, {
        enabled: !isClosed && !!companyHash
    }), data = ref1.data, status = ref1.status;
    (0,react.useEffect)(function() {
        if (data) {
            var tempOptions = getAcitveSource(data === null || data === void 0 ? void 0 : data.employees);
            var tempSource = Object.values(COMPANY_SOURCE).map(function(option) {
                return {
                    value: option,
                    disabled: tempOptions.indexOf(option) < 0,
                    selected: COMPANY_SOURCE[data.defaultSource] === option
                };
            });
            setSource(tempSource[0].disabled ? tempSource.slice(1) : tempSource);
        }
    }, [
        data
    ]);
    return {
        status: status,
        data: data,
        defaultSource: data === null || data === void 0 ? void 0 : data.defaultSource,
        source: source
    };
}
var getAcitveSource = function(data) {
    var tempOptions = [];
    var keys = Object.keys(data || {});
    keys.forEach(function(source) {
        return COMPANY_SOURCE[source] && tempOptions.push(COMPANY_SOURCE[source]);
    });
    return tempOptions;
};
var getRankRate = function(type, employee) {
    if (employee.rateType === "INDUSTRY") {
        return {
            type: type,
            employee: employee.employee,
            avgRate: (0,formatted_number/* getNumberWithRange */.ii)(employee.industryRate, 0.01, 1),
            totalAvgRate: (0,formatted_number/* getNumberWithRange */.ii)(employee.industryAvgRate, 0, 1),
            rate: employee.rate,
            employeeCount: employee.industryEmployee
        };
    }
    return {
        type: type,
        employee: employee.employee,
        avgRate: (0,formatted_number/* getNumberWithRange */.ii)(employee.totalRate, 0.01, 1),
        totalAvgRate: (0,formatted_number/* getNumberWithRange */.ii)(employee.totalAvgRate, 0, 1),
        rate: employee.rate,
        employeeCount: employee.totalEmployee
    };
};
var getDisplayPercent = function(rate, type) {
    var percent = (0,formatted_number/* parseToPercent */.lz)(rate.avgRate || 0, 0);
    // 퇴사율이 === 0 일 때, 무조건 1%
    // -> 이유 : 그룹 구간값으로 내려오도록 api 작업되어 있어서 0이 아닌 그룹 구간값이 내려옴(ex 8%). 하지만 0은 무조건 최상위 구간이므로 1% 로 표시
    if (type === "left" && rate.rate === 0) {
        return 1;
    }
    return percent === 0 ? 1 : percent;
};
var getRankRateSection = function(rate) {
    var ref;
    if (rate.type === "total") {
        var ref1;
        return {
            main: "".concat(!(0,number/* isNumber */.h)(rate.employee) ? "정보없음" : "".concat((ref1 = rate.employee) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString(), " 명")),
            mainBrace: "",
            description: "상위 ".concat(!(0,number/* isNumber */.h)(rate.avgRate) ? " - " : getDisplayPercent(rate, rate.type), "% "),
            descriptionBrace: "(평균 : ".concat(!(0,number/* isNumber */.h)(rate.employeeCount) || rate.employeeCount === null ? " - " : Math.round(rate.employeeCount).toLocaleString(), "명)")
        };
    }
    return {
        main: "".concat(!(0,number/* isNumber */.h)(rate.rate) ? " - " : (0,formatted_number/* parseToPercent */.lz)(rate.rate || 0, 0), "%"),
        mainBrace: !(0,number/* isNumber */.h)(rate.employee) ? "(정보없음)" : "(".concat((ref = rate.employee) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " 명)"),
        description: "상위 ".concat(!(0,number/* isNumber */.h)(rate.avgRate) ? " - " : getDisplayPercent(rate, rate.type), "% "),
        descriptionBrace: "(평균 : ".concat(!(0,number/* isNumber */.h)(rate.totalAvgRate) ? " - " : (0,formatted_number/* parseToPercent */.lz)(rate.totalAvgRate || 0), "%)")
    };
};

// EXTERNAL MODULE: ./src/utils/common/object.ts
var object = __webpack_require__(5406);
// EXTERNAL MODULE: ./src/utils/lodash/isServer/index.ts
var isServer = __webpack_require__(48086);
;// CONCATENATED MODULE: ./src/features/company/BlockedInfo.tsx

function BlockedInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: 46px auto 40px;\n\n  & > img {\n    width: 80px;\n    margin-bottom: 13px;\n  }\n"
    ]);
    BlockedInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function BlockedInfo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockedInfo_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://image.wanted.co.kr/kreditjob/www/lock.png",
                alt: "sad face"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                typography: "bold150_B2",
                children: "아쉽게도 기업이 공개를 원하지 않습니다."
            })
        ]
    });
}
/* harmony default export */ var company_BlockedInfo = (BlockedInfo);
var BlockedInfo_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f23256c5-0"
})(BlockedInfo_templateObject());

;// CONCATENATED MODULE: ./src/features/company/Card/style.ts

function Card_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 794px;\n  box-sizing: border-box;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  scroll-margin-top: 130px;\n  background-color: ",
        ";\n\n  ",
        " {\n    width: 100%;\n    max-width: none;\n  }\n\n  ",
        " {\n    position: relative;\n    border-width: 0;\n  }\n"
    ]);
    Card_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Card_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 32px 32px 0 32px;\n\n  ",
        " {\n    padding: 30px 20px 0 20px;\n  }\n"
    ]);
    Card_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Card_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 32px 32px 32px;\n\n  ",
        " {\n    padding: 0 20px 30px 20px;\n  }\n"
    ]);
    Card_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Card_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: -22px;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    Card_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Card_style_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6f79a6d3-0"
})(Card_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f79a6d3-1"
})(Card_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CardConent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f79a6d3-2"
})(Card_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var BadgeNew = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f79a6d3-3"
})(Card_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta500;
}, (0,helper/* getFontStyle */.p)("midium120_C2"));

;// CONCATENATED MODULE: ./src/features/company/Card/index.tsx



function Card(param) {
    var title = param.title, rightCardHeader = param.rightCardHeader, children = param.children, sectionId = param.sectionId, registerRef = param.registerRef, isNew = param.isNew, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_style_Wrapper, {
        ref: function(element) {
            return element && registerRef && registerRef(element, sectionId);
        },
        id: sectionId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle, {
                        children: [
                            title,
                            isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeNew, {
                                children: "new"
                            })
                        ]
                    }),
                    rightCardHeader
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardConent, {
                style: style,
                children: children
            })
        ]
    });
}
/* harmony default export */ var company_Card = (Card);

// EXTERNAL MODULE: ./src/components/common/TinyDropDown/index.tsx + 10 modules
var TinyDropDown = __webpack_require__(22807);
;// CONCATENATED MODULE: ./src/features/company/DropDownSource.tsx

function DropDownSource_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    DropDownSource_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DropDownSource_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n  color: ",
        ";\n"
    ]);
    DropDownSource_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DropDownSource_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    DropDownSource_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function DropDownSource(param) {
    var value = param.value, emptyValue = param.emptyValue, options = param.options, _isShowTooltip = param.isShowTooltip, isShowTooltip = _isShowTooltip === void 0 ? true : _isShowTooltip, tooltipText = param.tooltipText, tooltipHelperText = param.tooltipHelperText, onChange = param.onChange;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownSource_Wrapper, {
        children: [
            isShowTooltip && tooltipText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                tooltipText: tooltipText,
                position: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                    width: 15,
                    color: theme.colors.gray700
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipHelperText, {
                typography: "midium150_B3",
                children: tooltipHelperText
            }),
            emptyValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyValue, {
                typography: "midium150_B3",
                children: emptyValue
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TinyDropDown/* default */.Z, {
                $width: "80px",
                value: value,
                options: options,
                onChange: onChange
            })
        ]
    });
};
var DropDownSource_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-852f9d79-0"
})(DropDownSource_templateObject());
var TooltipHelperText = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-852f9d79-1"
})(DropDownSource_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var EmptyValue = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-852f9d79-2"
})(DropDownSource_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/ButtonGroup/style.ts

function EmployeeBarChart_ButtonGroup_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  margin-top: 30px;\n"
    ]);
    EmployeeBarChart_ButtonGroup_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmployeeBarChart_ButtonGroup_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-right: 1px solid ",
        ";\n      "
    ]);
    EmployeeBarChart_ButtonGroup_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmployeeBarChart_ButtonGroup_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-left: 1px solid ",
        ";\n      "
    ]);
    EmployeeBarChart_ButtonGroup_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmployeeBarChart_ButtonGroup_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    EmployeeBarChart_ButtonGroup_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmployeeBarChart_ButtonGroup_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    EmployeeBarChart_ButtonGroup_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    ButtonGroup_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 80px;\n  height: 32px;\n  background: none;\n  padding: 0;\n  border-width: 0;\n  ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n\n  &:first-child {\n    border-radius: 16px 0px 0px 16px;\n\n    ",
        "\n  }\n\n  &:nth-child(2) {\n    border-left: none;\n    border-right: none;\n  }\n  &:last-child {\n    border-radius: 0px 16px 16px 0px;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var EmployeeBarChart_ButtonGroup_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f199047f-0"
})(EmployeeBarChart_ButtonGroup_style_templateObject());
var EmployeeBarChart_ButtonGroup_style_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f199047f-1"
})(style_templateObject6(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var year = param.year;
    return year === 2020 && (0,styled_components_browser_esm/* css */.iv)(EmployeeBarChart_ButtonGroup_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var year = param.year;
    return year === 2020 && (0,styled_components_browser_esm/* css */.iv)(EmployeeBarChart_ButtonGroup_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 2019 && (0,styled_components_browser_esm/* css */.iv)(EmployeeBarChart_ButtonGroup_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 2021 && (0,styled_components_browser_esm/* css */.iv)(EmployeeBarChart_ButtonGroup_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 2020 && (0,styled_components_browser_esm/* css */.iv)(ButtonGroup_style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/ButtonGroup/index.tsx



var ButtonGroup_YEARS = [
    2019,
    2020,
    2021
];
function ButtonGroup_ButtonGroup(param) {
    var currentYear = param.currentYear, onClick = param.onClick;
    var handleClick = function(year) {
        if (onClick) {
            (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__serviceYear__filter__click", {
                year: year
            });
            onClick(year);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeBarChart_ButtonGroup_style_Wrapper, {
        children: ButtonGroup_YEARS.map(function(year) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeBarChart_ButtonGroup_style_Button, {
                active: currentYear === year,
                year: currentYear,
                "data-attribute-id": "company__personnel__filter__click",
                "data-year": "".concat(year, "년"),
                onClick: function() {
                    return handleClick(year);
                },
                children: "".concat(year, "년")
            }, "employee-chart-button-".concat(year));
        })
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(9172);
;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyEmployeeAvgService.ts





var useCompanyEmployeeAvgService_url = function(PK_NM_HASH) {
    return "/api/company/".concat(PK_NM_HASH, "/avgServiceYear");
};
function useGetCompanyEmployeeAvgService() {
    var PK_NM_HASH = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyInfo/* default */.Z)(PK_NM_HASH), companyInfo = ref.data;
    return (0,index_production.useQuery)([
        queryKeys/* default.companyEmployeeAvgService */.Z.companyEmployeeAvgService,
        PK_NM_HASH
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanyEmployeeAvgService_url(PK_NM_HASH));
    }, {
        enabled: !!PK_NM_HASH,
        select: function(response) {
            var data = new Map(response.map(function(item) {
                if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryCode) === "ETC") {
                    return [
                        item.date,
                        {
                            avgServiceYear: item.avgServiceYear,
                            allAvgYear: item.allAvgYear
                        }, 
                    ];
                }
                return [
                    item.date,
                    item
                ];
            }));
            return data;
        }
    });
}
/* harmony default export */ var useCompanyEmployeeAvgService = (useGetCompanyEmployeeAvgService);

// EXTERNAL MODULE: ./src/utils/lodash/is/index.ts
var is = __webpack_require__(8892);
// EXTERNAL MODULE: ./src/lib/styles/Theme/index.ts + 3 modules
var Theme = __webpack_require__(6965);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/constant.ts

var constant_DEFAULT_OPTIONS = {
    maintainAspectRatio: false,
    devicePixelRatio: 2,
    animation: {
        duration: 0
    },
    interaction: {
        intersect: false,
        mode: "index"
    },
    plugins: {
        legend: {
            display: false
        },
        tooltip: {
            enabled: false
        },
        datalabels: {
            labels: {
                value: {
                    color: Theme/* default.colors.gray800 */.Z.colors.gray800,
                    align: "end",
                    anchor: "end",
                    font: {
                        weight: "500",
                        lineHeight: "12px",
                        size: "10px",
                        family: "Pretendard"
                    },
                    formatter: function(value, isActiveUser) {
                        if (!isActiveUser) {
                            return "??년";
                        }
                        if (value === 0) {
                            return "데이터 없음";
                        }
                        return "".concat(value, "년");
                    }
                }
            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    weight: "500",
                    lineHeight: "12px",
                    size: "10px",
                    family: "Pretendard"
                },
                color: Theme/* default.colors.gray700 */.Z.colors.gray700
            }
        },
        y: {
            grid: {
                drawBorder: false,
                display: false
            },
            ticks: {
                display: false
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/hooks.ts









function useChart(param) {
    var year = param.year;
    var _Math;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var chartData = useChartData(year);
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var labels = chartData.length === 3 ? [
        year,
        "업계 평균",
        "전체 평균"
    ] : [
        year,
        "전체 평균"
    ];
    var scales = constant_DEFAULT_OPTIONS.scales, plugins = constant_DEFAULT_OPTIONS.plugins, res = (0,_object_without_properties/* default */.Z)(constant_DEFAULT_OPTIONS, [
        "scales",
        "plugins"
    ]);
    var options = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, res), {
        plugins: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plugins), {
            datalabels: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plugins.datalabels), {
                labels: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plugins.datalabels.labels), {
                    value: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plugins.datalabels.labels.value), {
                        formatter: function(value) {
                            return plugins.datalabels.labels.value.formatter(value, isActiveUser);
                        }
                    })
                })
            })
        }),
        scales: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, scales), {
            y: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, scales.y), {
                max: (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(chartData)) * 1.4
            })
        })
    });
    var data = {
        labels: labels,
        datasets: [
            {
                backgroundColor: [
                    theme.colors.greypurple300,
                    theme.colors.gray400,
                    theme.colors.gray400
                ],
                borderColor: [
                    theme.colors.greypurple300,
                    theme.colors.gray400,
                    theme.colors.gray400
                ],
                borderWidth: 1,
                barThickness: 30,
                borderRadius: 3,
                data: chartData
            }, 
        ]
    };
    return {
        options: options,
        data: data
    };
}
function useChartData(year) {
    // react-query
    var ref = useCompanyEmployeeAvgService(), employeeAvgService = ref.data;
    var yearData = employeeAvgService === null || employeeAvgService === void 0 ? void 0 : employeeAvgService.get(String(year));
    if ((0,is/* isNil */.kK)(yearData === null || yearData === void 0 ? void 0 : yearData.sectionAvgYear)) {
        var ref1, ref2;
        return [
            (ref1 = yearData === null || yearData === void 0 ? void 0 : yearData.avgServiceYear) !== null && ref1 !== void 0 ? ref1 : 0,
            (ref2 = yearData === null || yearData === void 0 ? void 0 : yearData.allAvgYear) !== null && ref2 !== void 0 ? ref2 : 0
        ];
    }
    var ref3, ref4, ref5;
    return [
        (ref3 = yearData === null || yearData === void 0 ? void 0 : yearData.avgServiceYear) !== null && ref3 !== void 0 ? ref3 : 0,
        (ref4 = yearData === null || yearData === void 0 ? void 0 : yearData.sectionAvgYear) !== null && ref4 !== void 0 ? ref4 : 0,
        (ref5 = yearData === null || yearData === void 0 ? void 0 : yearData.allAvgYear) !== null && ref5 !== void 0 ? ref5 : 0
    ];
}

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/Chart/index.tsx






chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL, chart/* Legend */.De);
function BarChart(param) {
    var year = param.year;
    var ref = useChart({
        year: year
    }), data = ref.data, options = ref.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        layout: true,
        initial: {
            opacity: 0.8
        },
        animate: {
            opacity: 1
        },
        transition: {
            duration: 0.3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
            data: data,
            options: options
        })
    }, year);
}
/* harmony default export */ var Chart = (BarChart);

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/style.ts

function EmployeeBarChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-top: 20px;\n      "
    ]);
    EmployeeBarChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    scroll-margin-top: 250px;\n    ",
        ";\n  "
    ]);
    EmployeeBarChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    ",
        " {\n      width: 100%;\n    }\n  "
    ]);
    EmployeeBarChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    ",
        " {\n      width: 400px;\n    }\n  "
    ]);
    EmployeeBarChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    width: fit-content;\n    transform: translate3d(-50%, -50%, 0);\n    padding: 16px 24px;\n    background-color: #fff;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  "
    ]);
    EmployeeBarChart_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    white-space: nowrap;\n    text-align: center;\n  "
    ]);
    EmployeeBarChart_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EmployeeBarChart_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    width: 400px;\n    height: 240px;\n    margin: 0 auto;\n\n    ",
        " {\n      width: 100%;\n      height: 0;\n      padding-bottom: 80%;\n    }\n  "
    ]);
    EmployeeBarChart_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var style_S = {
    StyledEmployeeBarChart: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-bbd61c06-0"
    })(EmployeeBarChart_style_templateObject1(), function(param) {
        var isActiveUser = param.isActiveUser;
        return isActiveUser && (0,styled_components_browser_esm/* css */.iv)(EmployeeBarChart_style_templateObject());
    }),
    SignupNudgeWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-bbd61c06-1"
    })(EmployeeBarChart_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    ChartContent: (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
        componentId: "sc-bbd61c06-2"
    })(EmployeeBarChart_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.media.pc;
    }),
    MessageWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-bbd61c06-3"
    })(EmployeeBarChart_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.gray400;
    }),
    Message: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-bbd61c06-4"
    })(EmployeeBarChart_style_templateObject5()),
    VideoWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-bbd61c06-5"
    })(EmployeeBarChart_style_templateObject6(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Video: styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
        componentId: "sc-bbd61c06-6"
    })(_templateObject7())
};

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/ChartContent/index.tsx





function ChartContent() {
    var ref = (0,react.useState)(2021), year = ref[0], setYear = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_S.ChartContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart, {
                    year: year
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup_ButtonGroup, {
                currentYear: year,
                onClick: function(year) {
                    return setYear(year);
                }
            })
        ]
    });
}
/* harmony default export */ var EmployeeBarChart_ChartContent = (ChartContent);

// EXTERNAL MODULE: ./src/hooks/useGetIndustryByCode.ts
var useGetIndustryByCode = __webpack_require__(398);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/SignupNudgeChart/index.tsx













function SignupNudgeChart() {
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var data = (0,useCompanyInfo/* default */.Z)(companyId).data;
    var videoAssetName = (0,react.useMemo)(function() {
        if (isMobile) {
            return "video-barchart-years-m";
        }
        return "video-barchart-years";
    }, [
        isMobile
    ]);
    var getIndustryByCode = (0,useGetIndustryByCode/* default */.Z)().getIndustryByCode;
    var ref = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref.data;
    var handleClick = function() {
        var ref;
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__avgServiceYear__login__click", {
            companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
            companyType: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.category,
            companyIndustry: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryCode) ? (ref = getIndustryByCode(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryCode)) === null || ref === void 0 ? void 0 : ref.name : "",
            companyHash: companyId
        });
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#employee-barchart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_S.SignupNudgeWrapper, {
        onClick: function() {
            return handleClick();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_S.VideoWrapper, {
                children: [
                    videoAssetName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_S.Video, {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        playsInline: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".webm"),
                                type: "video/webm"
                            }, "/images/".concat(videoAssetName, ".webm")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".mp4"),
                                type: "video/mp4"
                            }, "/images/".concat(videoAssetName, ".mp4"))
                        ]
                    }, videoAssetName),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_S.MessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_S.Message, {
                                typography: "midium150_C1",
                                children: [
                                    data === null || data === void 0 ? void 0 : data.name,
                                    "의 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "평균 근속연수 변동 추이가 궁금하다면?"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "magenta",
                                size: "sm",
                                children: "로그인"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup_ButtonGroup, {
                currentYear: 2021
            })
        ]
    });
}
/* harmony default export */ var EmployeeBarChart_SignupNudgeChart = (SignupNudgeChart);

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeBarChart/index.tsx








function EmployeeBarChart() {
    var router = (0,next_router.useRouter)();
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var wrapperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (wrapperRef.current && hash === "employee-barchart") {
            if (window) {
                router.replace(path);
                wrapperRef.current.scrollIntoView();
            }
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_S.StyledEmployeeBarChart, {
        isActiveUser: isActiveUser,
        ref: wrapperRef,
        children: isActiveUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeBarChart_ChartContent, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeBarChart_SignupNudgeChart, {})
    });
}
/* harmony default export */ var EmployeeInfo_EmployeeBarChart = (EmployeeBarChart);

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/style.ts

function EmployeeInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n\n  & > span:not(:last-child) {\n    margin-right: 5px;\n  }\n\n  &:nth-last-child(1) {\n    flex-direction: column;\n    gap: 8px;\n  }\n"
    ]);
    EmployeeInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 244px;\n\n  ",
        " {\n    min-width: 214px;\n  }\n\n  & > hr {\n    width: 30px;\n    margin: 16px auto 18px;\n    border-top: 1px solid ",
        ";\n\n    ",
        " {\n      margin: 12px auto 15px;\n    }\n  }\n\n  & > ",
        ":last-child {\n    margin-top: 7px;\n  }\n\n  .emphasize {\n    color: ",
        ";\n    ",
        ";\n  }\n\n  .grayColor {\n    color: ",
        ";\n  }\n"
    ]);
    EmployeeInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 20px;\n  margin-top: 30px;\n\n  ",
        " {\n    width: 100%;\n    max-width: 640px;\n    margin-left: auto;\n    margin-right: auto;\n    justify-content: center;\n  }\n\n  & > ",
        " {\n    margin-top: 20px;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    margin-top: 60px;\n\n    & > ",
        " {\n      margin-top: 0;\n      margin-bottom: 30px;\n    }\n\n    & > ",
        ":not(:last-child) {\n      margin-bottom: 60px;\n    }\n  }\n"
    ]);
    EmployeeInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  padding: 20px;\n  margin: 30px 0;\n  color: ",
        ";\n  ",
        ";\n  text-align: center;\n\n  word-break: keep-all;\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    EmployeeInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 60px;\n"
    ]);
    EmployeeInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n"
    ]);
    EmployeeInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EmployeeInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-left: 5px;\n"
    ]);
    EmployeeInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 40px 60px;\n\n  ",
        " {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  ",
        " {\n    padding: 20px;\n  }\n"
    ]);
    style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var style_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-0"
})(EmployeeInfo_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var EmployeeInfoCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-1"
})(EmployeeInfo_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, style_Row, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, (0,helper/* getFontStyle */.p)("bold150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var EmployeeRateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-2"
})(EmployeeInfo_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, EmployeeInfoCard, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, EmployeeInfoCard, EmployeeInfoCard);
var Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-3"
})(EmployeeInfo_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("midium120_B2"), function(param) {
    var theme = param.theme;
    return theme.colors.blue500;
});
var EmployeeChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-4"
})(EmployeeInfo_style_templateObject4());
var cssTitleChart = (0,styled_components_browser_esm/* css */.iv)(EmployeeInfo_style_templateObject5());
var TooltipWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-5"
})(EmployeeInfo_style_templateObject6());
var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f3777c5-6"
})(style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeRate/index.tsx








function EmployeeRate(param) {
    var title = param.title, tooltipText = param.tooltipText, employee = param.employee, type = param.type;
    var employeeRateText = (0,react.useMemo)(function() {
        var rate = getRankRate(type, employee);
        var rateText = getRankRateSection(rate);
        return rateText;
    }, [
        type,
        employee
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmployeeInfoCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                        typography: "midium120_B3",
                        children: title
                    }),
                    tooltipText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        width: 255,
                        tooltipText: tooltipText,
                        position: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                            width: 15,
                            color: Theme/* default.colors.gray700 */.Z.colors.gray700
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                        typography: "bold120_T1",
                        children: employeeRateText.main
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                        typography: "bold120_B2",
                        children: employeeRateText.mainBrace
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                        typography: "midium150_C1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "grayColor",
                                children: employee.rateType === "INDUSTRY" ? "동종업계" : "전체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                className: "emphasize",
                                children: [
                                    " ",
                                    employeeRateText.description,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                        typography: "midium150_C1",
                        children: employeeRateText.descriptionBrace
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var EmployeeInfo_EmployeeRate = (EmployeeRate);

// EXTERNAL MODULE: ./src/utils/company/company.ts
var company = __webpack_require__(52466);
;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/EmployeeSummary/index.tsx



function getEmployeeType(employee) {
    return {
        rateType: employee.rateType,
        rate: employee.rateType === "INDUSTRY" ? employee.industryRate : employee.totalRate
    };
}
function EmployeeSummary(param) {
    var employee = param.employee;
    var employeeType = getEmployeeType(employee);
    var rankingGroup = (0,company/* getRankingGroup */.lN)(employeeType.rate);
    if (!employeeType.rate) return null;
    if (!rankingGroup) {
        return null;
    }
    var text = "인원 규모가 ".concat(employeeType.rateType === "INDUSTRY" ? "동종업계" : "전체", "에서 <span>").concat(company/* RankingGroupText */.MT[rankingGroup], "</span>인 기업이에요");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}
/* harmony default export */ var EmployeeInfo_EmployeeSummary = (EmployeeSummary);

;// CONCATENATED MODULE: ./src/features/company/EmployeeInfo/index.tsx



























var emptyEmployee = {
    employee: null,
    industryAvgRate: null,
    industryEmployee: null,
    industryRate: null,
    rate: null,
    rateType: null,
    totalAvgRate: null,
    totalEmployee: null,
    totalRate: null
};
var EMPTY_COMPANY_EMPLOYEE = {
    hired: emptyEmployee,
    left: emptyEmployee,
    total: emptyEmployee,
    updatedAt: ""
};
function EmployeeInfo(param) {
    var registerRef = param.registerRef, companyStates = param.companyStates;
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var ref = useGetCompanyEmplyee(companyStates.closed, companyId), data = ref.data, defaultSource = ref.defaultSource, status = ref.status, source = ref.source;
    var ref1 = (0,react.useState)(), selectedSource = ref1[0], setSelectedSource = ref1[1];
    var employee = (0,react.useMemo)(function() {
        var sourceKey = selectedSource ? (0,object/* getKeyByValue */.V9)(COMPANY_SOURCE, selectedSource) : defaultSource;
        if (!(data === null || data === void 0 ? void 0 : data.employees) || !sourceKey) {
            return EMPTY_COMPANY_EMPLOYEE;
        }
        return data === null || data === void 0 ? void 0 : data.employees[sourceKey];
    }, [
        data,
        selectedSource
    ]);
    var onChange = function(value) {
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salarySource__click", {
            gnbKind: "인원 수",
            from: selectedSource || defaultSource,
            to: value
        });
        setSelectedSource(value);
    };
    (0,react.useEffect)(function() {
        if (isServer/* isClient */.C) {
            if (defaultSource) setSelectedSource(COMPANY_SOURCE[defaultSource]);
        }
    }, [
        defaultSource
    ]);
    var cardProps = {
        registerRef: registerRef,
        title: "인원",
        sectionId: COMPANY_DETAIL_MENU.EMPLOYEE
    };
    if ((companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed) || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted)) {
        return null;
    }
    if (status === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
        }));
    }
    if (!(companyStates === null || companyStates === void 0 ? void 0 : companyStates.employee)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(company_BlockedInfo, {})
        }));
    }
    if (status === "loading" || !employee) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
        rightCardHeader: !((companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted) || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownSource, {
            value: selectedSource || defaultSource,
            options: source,
            emptyValue: !(selectedSource || defaultSource) ? "정보없음" : undefined,
            tooltipHelperText: employee.updatedAt ? "".concat(dayjs_min_default()(employee.updatedAt).format("YYYY.MM"), " 기준 :") : "인원출처 :",
            tooltipText: "출처의 데이터를 기반으로 추정된 값으로, 참고 자료로만 활용하시길 바랍니다.",
            onChange: onChange
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInfo_EmployeeSummary, {
                employee: employee.total
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmployeeRateWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInfo_EmployeeRate, {
                        title: "총 인원",
                        employee: employee.total,
                        type: "total"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInfo_EmployeeRate, {
                        title: "최근 1년 퇴사율",
                        tooltipText: "퇴사율 = 최근 1년 국민연금 상실자 총합/</br>최근 1년 월 평균 재직인원",
                        employee: employee.left,
                        type: "left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInfo_EmployeeRate, {
                        title: "최근 1년 인원증가율",
                        tooltipText: "인원증가율 = 최근 1년 국민연금 취득자 총합/</br>최근 1년 월 평균 재직인원",
                        employee: employee.hired,
                        type: "hired"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmployeeChartWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySectionTitle, {
                        inlineCss: cssTitleChart,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Badge, {
                                bgColor: theme.colors.magenta700,
                                fontColor: theme.colors.magenta100,
                                children: "NEW"
                            }),
                            "평균 근속연수 (금감원)",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                width: 280,
                                tooltipText: "업계 평균: 크레딧잡 내 근속 연수 데이터가 있는 동일 업종 기업의 평균입니다. \n              <br/>전체 평균: 크레딧잡 내 근속 연수 데이터가 있는 전체 기업의 평균입니다. \n              <br/><br/>\n              *업종에 따라 업계 평균이 보이지 않을 수 있습니다.",
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInfo_EmployeeBarChart, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmployeeChartWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySectionTitle, {
                        inlineCss: cssTitleChart,
                        children: [
                            "월별그래프 (국민연금)",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                width: 215,
                                tooltipText: "국민연금 데이터를 기반으로 산출된<br/>그래프입니다. 선택하신 인원출처가<br/>다를 경우 결과가 상이할 수 있습니다.",
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeChart, {
                            companyId: companyId
                        })
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var company_EmployeeInfo = (EmployeeInfo);

// EXTERNAL MODULE: ./src/constant/layout.ts
var layout = __webpack_require__(96549);
;// CONCATENATED MODULE: ./src/features/company/ErrorPage.tsx

function ErrorPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  padding: calc(180px + ",
        "px) 0 180px;\n  background-color: ",
        ";\n"
    ]);
    ErrorPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ErrorPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 10px 0 0;\n  color: ",
        ";\n"
    ]);
    ErrorPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function ErrorPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorPage_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://image.wanted.co.kr/kreditjob/www/ico-error.png",
                alt: "sad face"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorPage_Text, {
                children: [
                    "예상하지 못한 에러가 발생했습니다.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "잠시 후 다시 시도해주세요."
                ]
            })
        ]
    });
};
var ErrorPage_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-139e1f76-0"
})(ErrorPage_templateObject(), layout/* HEADER_HEIGHT */.Mz, function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
});
var ErrorPage_Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-139e1f76-1"
})(ErrorPage_templateObject1(), (0,helper/* getFontStyle */.p)("bold150_B2"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});

// EXTERNAL MODULE: ./src/components/SSRSafeSuspense/index.tsx + 1 modules
var SSRSafeSuspense = __webpack_require__(3279);
// EXTERNAL MODULE: ./src/components/CompanyLogo/index.tsx + 3 modules
var CompanyLogo = __webpack_require__(43277);
;// CONCATENATED MODULE: ./src/features/company/Header/style.ts

function Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 80px;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > img {\n    width: ",
        ";\n    height: ",
        ";\n  }\n\n  ",
        " {\n    width: 48px;\n    height: 48px;\n\n    & > img {\n      width: ",
        ";\n    }\n  }\n"
    ]);
    Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 80px;\n  margin-right: 30px;\n\n  & > img {\n    width: 40px;\n    height: 25px;\n  }\n\n  ",
        " {\n    width: 48px;\n    height: 48px;\n\n    margin: 30px 0 0 0;\n\n    & > img {\n      width: 32px;\n    }\n  }\n"
    ]);
    Header_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex: 1;\n\n  ",
        " {\n    text-align: center;\n\n    & > span:first-child {\n      ",
        "\n    }\n  }\n\n  & svg {\n    margin-bottom: 2px;\n  }\n"
    ]);
    Header_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > svg > path {\n    fill: #d63461;\n    stroke: #d63461;\n  }\n"
    ]);
    Header_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: none;\n  box-sizing: border-box;\n  border-radius: 100px;\n  padding: 9.5px 30px;\n  margin-left: auto;\n  align-items: center;\n  display: flex;\n  color: ",
        ";\n\n  & > svg {\n    margin-right: 12px;\n  }\n\n  ",
        "\n"
    ]);
    Header_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 10px;\n  margin-left: auto;\n"
    ]);
    Header_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Header_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        "px;\n  min-height: 140px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    width: 100%;\n    max-width: none;\n    padding: 0 32px;\n    margin: inherit;\n  }\n\n  & > ",
        " {\n    margin-right: 30px;\n  }\n\n  & > ",
        " a {\n    color: #7ac8c1;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    min-height: 246px;\n\n    & > ",
        " {\n      margin: 30px 0 0 0;\n    }\n\n    & > ",
        " > span {\n      margin: 12px 0 6px 0;\n    }\n\n    & > ",
        " {\n      margin: 20px 0 30px 0;\n    }\n  }\n"
    ]);
    Header_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Header_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 2px;\n  margin-bottom: 4px;\n  align-items: center;\n\n  svg {\n    margin-right: 5px;\n  }\n\n  img {\n    width: 2px;\n    height: 2px;\n    margin-left: 8px;\n    margin-right: 9.5px;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    margin-bottom: 8px;\n  }\n"
    ]);
    Header_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus {\n    text-decoration: none;\n    color: #444;\n    outline: none;\n  }\n\n  height: 100%;\n  align-items: center;\n  display: flex;\n  cursor: pointer;\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: ",
        "px;\n      content: '';\n      display: block;\n      width: 100%;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: ",
        "px;\n  left: 0;\n  right: 0;\n  background: #fff;\n  z-index: 999;\n  border-top: none;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  border-top: 1px solid #ebebeb;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.08);\n\n  ",
        "\n\n  & > div {\n    overflow-x: hidden;\n    overflow-y: hidden;\n    overscroll-behavior: contain;\n    mouse-wheel: horizontal;\n\n    max-width: ",
        "px;\n    display: flex;\n    margin: auto;\n    align-items: center;\n    height: 100%;\n    gap: 60px;\n\n    ",
        " {\n      width: 100%;\n      max-width: none;\n      padding: 0 32px;\n    }\n\n    ",
        " {\n      gap: 0;\n      padding: 0 16px;\n      gap: 32px;\n    }\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      visibility: hidden;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  width: 100%;\n  min-height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}




var Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-0"
})(Header_style_templateObject(), function(props) {
    return props.hasLogo ? "70px" : "40px";
}, function(props) {
    return !props.hasLogo && "25px";
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(props) {
    return props.hasLogo ? "40px" : "32px";
});
var logoCss = (0,styled_components_browser_esm/* css */.iv)(Header_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CompanyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-1"
})(Header_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, (0,helper/* getFontStyle */.p)("bold150_H5"));
var Active = (0,styled_components_browser_esm/* css */.iv)(Header_style_templateObject3());
var Header_style_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-87308efc-2"
})(Header_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, function(props) {
    return props.isActive && Active;
});
var ActionButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-3"
})(Header_style_templateObject5());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-4"
})(Header_style_templateObject6(), layout/* DESKTOP_WIDTH */.JH, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, Logo, CompanyInfo, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, Logo, CompanyInfo, ActionButtons);
var CompanyInfoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-5"
})(Header_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var TextItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-6"
})(_templateObject8());
var Menu = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-87308efc-7"
})(_templateObject9(), function(props) {
    return props.isSelected ? "color:   #d63461 !important;" : "color: #444;";
}, function(props) {
    return props.isSelected ? "border-bottom: 3px solid" : "border-bottom: 3px solid #fff";
});
var StickyEmptyBlock = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-87308efc-8"
})(_templateObject11(), function(props) {
    return !props.isSticky && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), layout/* HEADER_HEIGHT */.Mz);
});
var Sticky = (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), layout/* HEADER_HEIGHT */.Mz);
var MenuWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-87308efc-9"
})(_templateObject13(), layout/* HEADER_HEIGHT */.Mz, function(props) {
    return !props.isSticky && Sticky;
}, layout/* DESKTOP_WIDTH */.JH, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ActionButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87308efc-10"
})(_templateObject15(), function(props) {
    return props.isVisibility && (0,styled_components_browser_esm/* css */.iv)(_templateObject14());
});
var Header_style_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-87308efc-11"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
});
var ButtonText = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-87308efc-12"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});

// EXTERNAL MODULE: ./src/components/Icon/LinkIcon.tsx
var LinkIcon = __webpack_require__(95813);
// EXTERNAL MODULE: ./src/components/Icon/ScrapIcon.tsx
var ScrapIcon = __webpack_require__(84964);
;// CONCATENATED MODULE: ./src/components/Icon/ShareIcon.tsx

function ShareIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 16,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 12.4c-.633 0-1.2.25-1.633.642L5.425 9.583C5.467 9.392 5.5 9.2 5.5 9c0-.2-.033-.392-.075-.583L11.3 4.992a2.49 2.49 0 0 0 1.7.675c1.383 0 2.5-1.117 2.5-2.5 0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5c0 .2.033.391.075.583L4.7 7.175A2.49 2.49 0 0 0 3 6.5 2.497 2.497 0 0 0 .5 9c0 1.383 1.117 2.5 2.5 2.5a2.49 2.49 0 0 0 1.7-.675l5.933 3.467a2.355 2.355 0 0 0-.066.541A2.436 2.436 0 0 0 13 17.267a2.436 2.436 0 0 0 2.433-2.434A2.436 2.436 0 0 0 13 12.4Zm0-10.067c.458 0 .833.375.833.834A.836.836 0 0 1 13 4a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834Zm-10 7.5A.836.836 0 0 1 2.167 9c0-.458.375-.833.833-.833.458 0 .833.375.833.833A.836.836 0 0 1 3 9.833Zm10 5.85a.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833Z",
            fill: "#333"
        })
    });
}
/* harmony default export */ var Icon_ShareIcon = (ShareIcon);

// EXTERNAL MODULE: ./src/components/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(22509);
// EXTERNAL MODULE: ./src/hooks/query/bookmark/useBookmark.ts
var useBookmark = __webpack_require__(4887);
// EXTERNAL MODULE: ./src/hooks/query/bookmark/useDeleteBookmarks.ts
var useDeleteBookmarks = __webpack_require__(72777);
// EXTERNAL MODULE: ./src/hooks/query/bookmark/usePostBookmarks.ts
var usePostBookmarks = __webpack_require__(51286);
// EXTERNAL MODULE: ./src/store/toast/index.tsx + 1 modules
var toast = __webpack_require__(8546);
// EXTERNAL MODULE: ./src/utils/common/copyToClipboard/index.ts
var copyToClipboard = __webpack_require__(28554);
;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/ActionButton/style.ts

function ActionButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > svg > path {\n    fill: #d63461;\n    stroke: #d63461;\n  }\n"
    ]);
    ActionButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActionButton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n    margin-left: auto;\n\n    ",
        " {\n      margin: 20px 0 30px 0;\n    }\n  "
    ]);
    ActionButton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActionButton_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n  "
    ]);
    ActionButton_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ActionButton_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    border: none;\n    box-sizing: border-box;\n    border-radius: 100px;\n    padding: 9.5px 30px;\n    margin-left: auto;\n    align-items: center;\n    display: flex;\n\n    & > svg {\n      margin-right: 12px;\n    }\n\n    ",
        ";\n    ",
        "\n  "
    ]);
    ActionButton_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var style_Active = (0,styled_components_browser_esm/* css */.iv)(ActionButton_style_templateObject());
var ActionButton_style_S = {
    Wrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-346366a7-0"
    })(ActionButton_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    ButtonText: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-346366a7-1"
    })(ActionButton_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.gray900;
    }),
    Button: styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
        componentId: "sc-346366a7-2"
    })(ActionButton_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.gray300;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.gray800;
    }, function(props) {
        return props.isActive && style_Active;
    })
};

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/ActionButton/index.tsx

















function ActionButton(param) {
    var companyInfo = param.companyInfo;
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var ref = (0,useBookmark/* default */.Z)({
        isActiveUser: isActiveUser
    }), bookmarks = ref.data;
    var toastShow = (0,toast/* useToastStore */.E)().toastShow;
    var getIndustryByCode = (0,useGetIndustryByCode/* default */.Z)().getIndustryByCode;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,usePostBookmarks/* default */.Z)(), addBookmark = ref2.mutate, addBookmarkLoading = ref2.isLoading;
    var ref3 = (0,useDeleteBookmarks/* default */.Z)(), deleteBookmark = ref3.mutate, deleteBookmarkLoading = ref3.isLoading;
    var movieOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var ref4;
    var isBookmarked = !!(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.map(function(bookmark) {
        return bookmark.PK_NM_HASH;
    }).includes((ref4 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH) !== null && ref4 !== void 0 ? ref4 : ""));
    var handleBookMark = function() {
        if (companyInfo) {
            if (isActiveUser) {
                if (!addBookmarkLoading && !deleteBookmarkLoading) {
                    var ref;
                    if (isBookmarked) {
                        deleteBookmark(companyInfo.PK_NM_HASH);
                    } else {
                        addBookmark(companyInfo.PK_NM_HASH);
                    }
                    var ref1;
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__bookmark__click", {
                        companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        companyType: (ref1 = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.category) !== null && ref1 !== void 0 ? ref1 : "",
                        companyIndustry: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryCode) ? (ref = getIndustryByCode(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.industryCode)) === null || ref === void 0 ? void 0 : ref.name : "",
                        isChecked: !isBookmarked
                    });
                }
            } else {
                (0,thirdPartyEvent/* setGtmDataLayer */.id)("signupLogin__popup__view", {
                    companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                    companyHash: companyInfo.PK_NM_HASH,
                    clickType: "bookmark"
                });
                setIsOpen(true);
            }
        }
    };
    var handleToast = function() {
        (0,copyToClipboard/* default */.ZP)(window.location.href + "?utm_medium=share");
        toastShow("링크가 복사되었습니다.", {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkIcon/* default */.Z, {})
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton_style_S.Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton_style_S.Button, {
                        isActive: isBookmarked,
                        onClick: handleBookMark,
                        className: "bookmark",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapIcon/* default */.Z, {
                                fill: theme.colors.gray300,
                                strokeWidth: "2",
                                stroke: theme.colors.gray900
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton_style_S.ButtonText, {
                                typography: "bold150_B3",
                                children: "스크랩"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton_style_S.Button, {
                        isActive: false,
                        onClick: handleToast,
                        "data-attribute-id": "company__share__click",
                        "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        "data-company-industry": companyInfo && getIndustryByCode(companyInfo.industryCode) || "",
                        "data-company-type": companyInfo && companyInfo.category || "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_ShareIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton_style_S.ButtonText, {
                                typography: "bold150_B3",
                                children: "공유하기"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isOpen: isOpen,
                title: "로그인 하시겠습니까?",
                subTitle: "스크랩을 이용하려면 로그인이 필요합니다. 스크랩 후 여러 기업을 한 번에 비교해보세요.",
                confirmButtonVariant: "dark",
                cancelButtonText: "취소",
                confirmButtonText: "로그인/회원가입",
                handleConfirm: function() {
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("signupLogin__popup__click", {
                        companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        companyHash: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                        clickType: "bookmark"
                    });
                    movieOneIdPage();
                    setIsOpen(false);
                },
                handleCancel: function() {
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("signupLogin__popup__cancel", {
                        companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        companyHash: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                        clickType: "bookmark"
                    });
                    setIsOpen(false);
                },
                handleClose: function() {
                    return setIsOpen(false);
                }
            })
        ]
    });
}
/* harmony default export */ var CompanyInfo_ActionButton = (ActionButton);

// EXTERNAL MODULE: ./src/components/Icon/ArrowLine.tsx
var ArrowLine = __webpack_require__(7927);
;// CONCATENATED MODULE: ./src/components/Icon/BuildingIcon.tsx



function BuildingIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: props.width,
        height: props.height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 2.583V.25H.167v10.5h11.666V2.583H6Zm-1.167 7h-3.5V8.417h3.5v1.166Zm0-2.333h-3.5V6.083h3.5V7.25Zm0-2.333h-3.5V3.75h3.5v1.167Zm0-2.334h-3.5V1.417h3.5v1.166Zm5.834 7H6V3.75h4.667v5.833ZM9.5 4.917H7.167v1.166H9.5V4.917Zm0 2.333H7.167v1.167H9.5V7.25Z",
            fill: props.fill
        })
    }));
}
/* harmony default export */ var Icon_BuildingIcon = (BuildingIcon);

;// CONCATENATED MODULE: ./src/components/Icon/ClockIcon.tsx



function ClockIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: props.width,
        height: props.height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 .667C2.792.667.167 3.292.167 6.5S2.792 12.333 6 12.333s5.833-2.625 5.833-5.833S9.208.667 6 .667Zm0 10.5A4.673 4.673 0 0 1 1.333 6.5 4.673 4.673 0 0 1 6 1.833 4.673 4.673 0 0 1 10.667 6.5 4.673 4.673 0 0 1 6 11.167Zm.292-7.584h-.875v3.5L8.45 8.95l.467-.758-2.625-1.575V3.583Z",
            fill: props.fill
        })
    }));
}
/* harmony default export */ var Icon_ClockIcon = (ClockIcon);

;// CONCATENATED MODULE: ./src/components/Icon/CompanyIndustryIcon.tsx



function CompanyIndustryIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: props.width,
        height: props.height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.667 2.583H8.333V1.417L7.167.25H4.833L3.667 1.417v1.166H1.333A1.17 1.17 0 0 0 .167 3.75v2.917c0 .437.233.805.583 1.009v1.907c0 .648.52 1.167 1.167 1.167h8.166c.648 0 1.167-.52 1.167-1.167V7.67c.344-.204.583-.577.583-1.003V3.75a1.17 1.17 0 0 0-1.166-1.167ZM4.833 1.417h2.334v1.166H4.833V1.417Zm-3.5 2.333h9.334v2.917H7.75v-1.75h-3.5v1.75H1.333V3.75Zm5.25 3.5H5.417V6.083h1.166V7.25Zm3.5 2.333H1.917v-1.75H4.25v.584h3.5v-.584h2.333v1.75Z",
            fill: props.fill
        })
    }));
}
/* harmony default export */ var Icon_CompanyIndustryIcon = (CompanyIndustryIcon);

;// CONCATENATED MODULE: ./src/components/Icon/LocationIcon.tsx



function LocationIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: props.width,
        height: props.height,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 1.667A4.08 4.08 0 0 0 2.917 5.75C2.917 8.813 7 13.333 7 13.333s4.083-4.52 4.083-7.583A4.08 4.08 0 0 0 7 1.667ZM4.083 5.75a2.918 2.918 0 0 1 5.834 0c0 1.68-1.68 4.194-2.917 5.763-1.213-1.557-2.917-4.1-2.917-5.763Z",
                fill: props.fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 7.208a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916Z",
                fill: props.fill
            })
        ]
    }));
}
/* harmony default export */ var Icon_LocationIcon = (LocationIcon);

// EXTERNAL MODULE: ./src/utils/locationFormat/index.ts + 1 modules
var locationFormat = __webpack_require__(23133);
;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/CompanyDescription/hooks.tsx

var getCompanyYear = function(year, companyStates) {
    if (companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed) {
        return "".concat(year, " ~ ").concat(dayjs_min_default()(companyStates.closedAt).format("YYYY"));
    }
    return year;
};

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/CompanyDescription/style.ts

function CompanyDescription_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    flex: 1;\n\n    ",
        " {\n      text-align: center;\n\n      & > span:first-child {\n        ",
        "\n      }\n    }\n\n    & a {\n      color: ",
        ";\n    }\n\n    & svg {\n      margin-bottom: 2px;\n    }\n  "
    ]);
    CompanyDescription_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyDescription_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 12px 0px 6px;\n  "
    ]);
    CompanyDescription_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyDescription_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 2px;\n    margin-bottom: 4px;\n    align-items: center;\n\n    svg {\n      margin-right: 5px;\n    }\n\n    img {\n      width: 2px;\n      height: 2px;\n      margin-left: 8px;\n      margin-right: 9.5px;\n    }\n\n    ",
        " {\n      flex-direction: column;\n      margin-bottom: 8px;\n    }\n\n    ",
        " {\n      align-items: flex-start;\n    }\n  "
    ]);
    CompanyDescription_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyDescription_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n  "
    ]);
    CompanyDescription_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CompanyDescription_style_S = {
    Wrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-ab4d41ac-0"
    })(CompanyDescription_style_templateObject(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, (0,helper/* getFontStyle */.p)("bold150_H5"), function(param) {
        var theme = param.theme;
        return theme.colors.greymint300;
    }),
    CompanyName: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-ab4d41ac-1"
    })(CompanyDescription_style_templateObject1()),
    CompanyInfoItem: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-ab4d41ac-2"
    })(CompanyDescription_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.media.with("mobile", "tablet");
    }, function(param) {
        var theme = param.theme;
        return theme.media.tablet;
    }),
    TextItem: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-ab4d41ac-3"
    })(CompanyDescription_style_templateObject3())
};

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/CompanyDescription/index.tsx














function CompanyDescription(param) {
    var companyInfo = param.companyInfo, companyStates = param.companyStates;
    var ref;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    var getIndustryByCode = (0,useGetIndustryByCode/* default */.Z)().getIndustryByCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDescription_style_S.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDescription_style_S.CompanyName, {
                typography: "bold150_H".concat(isDesktop ? "4" : "5"),
                children: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDescription_style_S.CompanyInfoItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDescription_style_S.TextItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                typography: "midium150_".concat(isDesktop ? "C1" : "B3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_BuildingIcon, {
                                        width: 12,
                                        height: 11,
                                        fill: theme.colors.gray700
                                    }),
                                    companyInfo && (COMPANY_TYPE[companyInfo.category] || companyInfo.category)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ellipse.svg",
                                alt: "ellipse"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                typography: "midium150_".concat(isDesktop ? "C1" : "B3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_CompanyIndustryIcon, {
                                        width: 12,
                                        height: 11,
                                        fill: theme.colors.gray700
                                    }),
                                    companyInfo && ((ref = getIndustryByCode(companyInfo.industryCode)) === null || ref === void 0 ? void 0 : ref.name)
                                ]
                            }),
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ellipse.svg",
                                alt: "ellipse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyDescription_style_S.TextItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                typography: "midium150_".concat(isDesktop ? "C1" : "B3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_ClockIcon, {
                                        width: 12,
                                        height: 13,
                                        fill: theme.colors.gray700
                                    }),
                                    companyInfo && (companyInfo.age || companyInfo.foundedYear) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: "".concat(Number(companyInfo.age.toFixed()) > 0 ? "".concat(companyInfo.age.toFixed(), "년") : "1년 미만", " (").concat(getCompanyYear(companyInfo.foundedYear, companyStates), ")")
                                    }) : "정보없음"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ellipse.svg",
                                alt: "ellipse"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                typography: "midium150_".concat(isDesktop ? "C1" : "B3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_LocationIcon, {
                                        width: 14,
                                        height: 15,
                                        fill: theme.colors.gray700
                                    }),
                                    companyInfo && (0,locationFormat/* getShortenedAddress */.r)(companyInfo.locationCode, companyInfo.location)
                                ]
                            })
                        ]
                    })
                ]
            }),
            (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.niceId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "data-attribute-id": "company__nice__seeMore",
                    "data-company-id": companyInfo.id,
                    "data-company-name": companyInfo.name,
                    "data-company-type": companyInfo.category,
                    href: "https://www.nicebizinfo.com/ep/EP0100M002GE.nice?kiscode=".concat(companyInfo.niceId, "&siteid=kreditjob"),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                        typography: "midium150_".concat(isDesktop ? "C1" : "B3"),
                        children: [
                            "NICE기업 정보 더 보기",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLine/* default */.Z, {
                                width: 5,
                                height: 7,
                                color: theme.colors.greymint300,
                                style: {
                                    marginLeft: "2px"
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var CompanyInfo_CompanyDescription = (CompanyDescription);

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/index.tsx







function CompanyInfo_CompanyInfo() {
    var ref = (0,useCompanyInfo/* useSuspensedCompanyInfo */.N)(), companyInfo = ref.data;
    var ref1 = (0,useCompanyStates/* useSuspensedCompanyStates */.s)(), companyStates = ref1.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo/* default */.Z, {
                PK_NM_HASH: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                logoCss: logoCss
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfo_CompanyDescription, {
                companyInfo: companyInfo,
                companyStates: companyStates
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfo_ActionButton, {
                companyInfo: companyInfo
            })
        ]
    });
}
/* harmony default export */ var Header_CompanyInfo = (CompanyInfo_CompanyInfo);

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/Skeleton/style.ts

function Skeleton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 4px;\n"
    ]);
    Skeleton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n\n    ",
        " {\n      flex-direction: column;\n      align-items: center;\n    }\n  "
    ]);
    Skeleton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 30px;\n    width: 80px;\n    height: 80px;\n\n    ",
        ";\n\n    ",
        " {\n      width: 48px;\n      height: 48px;\n    }\n  "
    ]);
    Skeleton_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 240px;\n    height: 16px;\n\n    ",
        ";\n  "
    ]);
    Skeleton_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 120px;\n    height: 24px;\n\n    ",
        ";\n  "
    ]);
    Skeleton_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 8px;\n    margin-left: 30px;\n\n    ",
        " {\n      align-items: center;\n      margin: 0;\n      margin-top: 12px;\n    }\n  "
    ]);
    Skeleton_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Skeleton_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    margin-left: auto;\n\n    button {\n      padding: 9px 30px;\n      gap: 4px;\n\n      width: 120px;\n      height: 40px;\n      ",
        ";\n      border-radius: 20px;\n    }\n\n    ",
        " {\n      margin: 0;\n      margin-top: 50px;\n      margin-bottom: 30px;\n    }\n  "
    ]);
    Skeleton_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var colorCss = (0,styled_components_browser_esm/* css */.iv)(Skeleton_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});
var Skeleton_style_S = {
    Warpper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-0"
    })(Skeleton_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Logo: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-1"
    })(Skeleton_style_templateObject2(), colorCss, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Info: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-2"
    })(Skeleton_style_templateObject3(), colorCss),
    Name: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-3"
    })(Skeleton_style_templateObject4(), colorCss),
    Content: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-4"
    })(Skeleton_style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    ButtonGroup: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-6bd87fe3-5"
    })(Skeleton_style_templateObject6(), colorCss, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    })
};

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyInfo/Skeleton/index.tsx



function CompanyHeaderSkeleton() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_style_S.Warpper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_style_S.Logo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_style_S.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_style_S.Name, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_style_S.Info, {}),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_style_S.Info, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_style_S.ButtonGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {})
                ]
            })
        ]
    });
}
/* harmony default export */ var Skeleton = (CompanyHeaderSkeleton);

;// CONCATENATED MODULE: ./src/features/company/hooks/useDraggable.tsx

function isTouchEvent(e) {
    return e.changedTouches !== undefined;
}
function useDraggable() {
    var sliderRef = (0,react.useRef)(null);
    var mouseDown = false;
    var startX;
    var scrollLeft;
    var startDragging = function(e) {
        if (!sliderRef || !sliderRef.current) return;
        mouseDown = true;
        var pageX = isTouchEvent(e) ? e.changedTouches[0].pageX : e.pageX;
        startX = pageX - sliderRef.current.offsetLeft;
        scrollLeft = sliderRef.current.scrollLeft;
    };
    var stopDragging = function() {
        mouseDown = false;
    };
    var inDragging = function(e) {
        e.preventDefault();
        if (!sliderRef || !sliderRef.current || !mouseDown) return;
        var pageX = isTouchEvent(e) ? e.changedTouches[0].pageX : e.pageX;
        var x = pageX - sliderRef.current.offsetLeft;
        var scroll = x - startX;
        sliderRef.current.scrollLeft = scrollLeft - scroll;
    };
    return {
        sliderRef: sliderRef,
        startDragging: startDragging,
        stopDragging: stopDragging,
        inDragging: inDragging
    };
}
/* harmony default export */ var hooks_useDraggable = (useDraggable);

;// CONCATENATED MODULE: ./src/features/company/Header/DetailNav/style.ts

function DetailNav_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: #d63461 !important;\n      border-bottom: 3px solid;\n    "
    ]);
    DetailNav_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailNav_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::after {\n          content: 'new';\n          position: absolute;\n          top: 1px;\n          right: -22px;\n          color: ",
        ";\n          ",
        "\n        }\n      "
    ]);
    DetailNav_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailNav_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  align-items: center;\n  display: flex;\n  cursor: pointer;\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  color: ",
        ";\n  border-bottom: 3px solid ",
        ";\n\n  ",
        "\n\n  &:focus {\n    text-decoration: none;\n    color: ",
        ";\n    outline: none;\n  }\n\n  span {\n    position: relative;\n\n    ",
        "\n  }\n"
    ]);
    DetailNav_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var style_Menu = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-9c59eb32-0"
})(DetailNav_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected && (0,styled_components_browser_esm/* css */.iv)(DetailNav_style_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, function(param) {
    var isNew = param.isNew;
    return isNew && (0,styled_components_browser_esm/* css */.iv)(DetailNav_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, (0,helper/* getFontStyle */.p)("midium120_C2"));
});

;// CONCATENATED MODULE: ./src/features/company/Header/DetailNav/index.tsx





function DetailNav(param) {
    var selectedMenu = param.selectedMenu, isClosedCompany = param.isClosedCompany;
    var variant = react_ab_test.emitter.getActiveVariant("abTest_company_community");
    var menuList = variant === "A" ? COMPANY_DETAIL_MENU_OBJ_LIST : COMPANY_DETAIL_MENU_OBJ_LIST_B;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: menuList.map(function(menuItem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailNavItem, {
                menuId: menuItem.id,
                text: menuItem.text,
                isSelected: selectedMenu === menuItem.id,
                isClosedCompany: isClosedCompany,
                isNew: menuItem.isNew
            }, "company-detail-menu-".concat(menuItem.id));
        })
    });
};
function DetailNavItem(param) {
    var menuId = param.menuId, text = param.text, isSelected = param.isSelected, isClosedCompany = param.isClosedCompany, isNew = param.isNew;
    if (isClosedCompany && (menuId === COMPANY_DETAIL_MENU.SALARY || menuId === COMPANY_DETAIL_MENU.SALES || menuId === COMPANY_DETAIL_MENU.EMPLOYEE)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Menu, {
        tabIndex: 0,
        "data-attribute-id": "company__gnb",
        "data-gnb-kind": text,
        href: "#".concat(menuId),
        isSelected: isSelected,
        isNew: isNew,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
            typography: "bold150_B2",
            children: text
        })
    });
}

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyMenu/index.tsx











function CompanyMenu(param) {
    var selectedMenu = param.selectedMenu;
    var ref = (0,react.useState)(selectedMenu), menu = ref[0], setMenu = ref[1];
    var ref1 = (0,useCompanyInfo/* useSuspensedCompanyInfo */.N)(), companyInfo = ref1.data;
    var ref2 = (0,useCompanyStates/* useSuspensedCompanyStates */.s)(), companyStates = ref2.data;
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    // sticky
    var ref3 = (0,react.useRef)(null);
    var entry = (0,useIntersectionObserver/* default */.Z)(ref3, {
        rootMargin: "-".concat(layout/* HEADER_HEIGHT */.Mz, "px"),
        threshold: 0
    });
    // menuslider
    var ref4 = hooks_useDraggable(), sliderRef = ref4.sliderRef, inDragging = ref4.inDragging, startDragging = ref4.startDragging, stopDragging = ref4.stopDragging;
    var handleScrollBehavior = function(e) {
        var ref;
        e.preventDefault();
        if (!e.target || !document) return;
        var scrollTargetId = e.target.getAttribute("href") || ((ref = e.target.parentElement) === null || ref === void 0 ? void 0 : ref.getAttribute("href"));
        if (!scrollTargetId || !scrollTargetId.split("#")[1]) return;
        var scrollTarget = document.querySelector(scrollTargetId || "");
        setMenu(scrollTargetId.split("#")[1]);
        if (!scrollTarget) return;
        scrollTarget.scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyEmptyBlock, {
                isSticky: (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) || false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                isSticky: (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) || false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: handleScrollBehavior,
                    ref: sliderRef,
                    onTouchStart: startDragging,
                    onTouchMove: inDragging,
                    onTouchEnd: stopDragging,
                    onMouseMove: inDragging,
                    onMouseDown: startDragging,
                    onMouseUp: stopDragging,
                    onMouseOver: stopDragging,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailNav, {
                            isClosedCompany: companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed,
                            selectedMenu: menu
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtonGroup, {
                            isVisibility: !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting),
                            children: isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfo_ActionButton, {
                                companyInfo: companyInfo
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Header_CompanyMenu = (CompanyMenu);

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyMenu/Skeleton/style.ts

function CompanyMenu_Skeleton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 4px;\n"
    ]);
    CompanyMenu_Skeleton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyMenu_Skeleton_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 30px;\n    margin: 0 auto;\n    align-items: center;\n\n    padding-bottom: 20px;\n\n    ",
        " {\n      width: 1136px;\n    }\n    ",
        " {\n      padding-left: 32px;\n      padding-right: 32px;\n    }\n\n    ",
        " {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n    div {\n      width: 55px;\n      height: 35px;\n\n      ",
        ";\n    }\n  "
    ]);
    CompanyMenu_Skeleton_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var style_colorCss = (0,styled_components_browser_esm/* css */.iv)(CompanyMenu_Skeleton_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});
var CompanyMenu_Skeleton_style_S = {
    Wrapper: styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
        componentId: "sc-125da85a-0"
    })(CompanyMenu_Skeleton_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.media.pc;
    }, function(param) {
        var theme = param.theme;
        return theme.media.tablet;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, style_colorCss)
};

;// CONCATENATED MODULE: ./src/features/company/Header/CompanyMenu/Skeleton/index.tsx



function CompanyMenuSkeleton() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyMenu_Skeleton_style_S.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
}
/* harmony default export */ var CompanyMenu_Skeleton = (CompanyMenuSkeleton);

;// CONCATENATED MODULE: ./src/features/company/Header/index.tsx








function Header(param) {
    var selectedMenu = param.selectedMenu;
    var ref = (0,useCompanyStates/* useSuspensedCompanyStates */.s)(), companyStates = ref.data;
    if (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_style_Wrapper, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSRSafeSuspense/* default */.Z, {
                    pendingFallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {}),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CompanyInfo, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SSRSafeSuspense/* default */.Z, {
                pendingFallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyMenu_Skeleton, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CompanyMenu, {
                    selectedMenu: selectedMenu
                })
            })
        ]
    });
}
/* harmony default export */ var company_Header = (Header);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/hooks/useIntersectionObservers.tsx

function useIntersectionObservers(elementRefs, param, callback) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin, _freezeOnceVisible = param.freezeOnceVisible, freezeOnceVisible = _freezeOnceVisible === void 0 ? false : _freezeOnceVisible;
    var frozen = freezeOnceVisible;
    var ref = (0,react.useState)(), entry = ref[0], setEntry = ref[1];
    var updateEntry = (0,react.useCallback)(function(entries) {
        callback(entries);
        setEntry(entries);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var nodes = elementRefs === null || elementRefs === void 0 ? void 0 : (ref = elementRefs.current) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item;
        }); // DOM Ref
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !(nodes === null || nodes === void 0 ? void 0 : nodes.length)) return;
        var observerParams = {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        };
        var observer = new IntersectionObserver(updateEntry, observerParams);
        ((elementRefs === null || elementRefs === void 0 ? void 0 : elementRefs.current) || []).map(function(node) {
            if (node) {
                observer.observe(node);
            }
        });
        return function() {
            observer.disconnect();
        };
    // eslint-disable-next-line
    }, [
        JSON.stringify(Object.keys(elementRefs.current || {})),
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen, 
    ]);
    return entry;
}
/* harmony default export */ var hooks_useIntersectionObservers = (useIntersectionObservers);

;// CONCATENATED MODULE: ./src/features/company/hooks/useCardObserver.tsx






var findMenuIndex = function(id) {
    var menuOrder = Object.values(COMPANY_DETAIL_MENU);
    return menuOrder.findIndex(function(element) {
        return element === id;
    });
};
var options = {
    rootMargin: "-110px",
    threshold: 0
};
function useCardObserver() {
    var refs = (0,react.useRef)([]);
    var ref = (0,react.useState)({}), menu = ref[0], setMenus = ref[1];
    var ref1 = (0,react.useState)(COMPANY_DETAIL_MENU.COMPANY_SUMMARY), selectedMenu = ref1[0], setSelectedMenu = ref1[1];
    var updateEntry = (0,react.useCallback)(function(entries) {
        entries.map(function(entry) {
            setMenus(function(prev) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, entry.target.id, entry.isIntersecting));
            });
        });
    }, []);
    var entries = hooks_useIntersectionObservers(refs, options, updateEntry);
    var registerRef = (0,react.useCallback)(function(element, id) {
        var index = findMenuIndex(id);
        if (!refs.current[index]) {
            refs.current[index] = element;
        }
    }, []);
    var getSelectedMenu = function(menus) {
        var menuOrder = Object.values(COMPANY_DETAIL_MENU);
        var filtertedMenu = Object.keys(menus).map(function(key) {
            return menus[key] && key;
        }).filter(function(value) {
            return value;
        });
        if (filtertedMenu.length < 0) return COMPANY_DETAIL_MENU.COMPANY_SUMMARY;
        // @ts-ignore
        var index = findMenuIndex(filtertedMenu[0]);
        filtertedMenu.map(function(key) {
            if (findMenuIndex(key) <= index) {
                index = findMenuIndex(key);
            }
        });
        return menuOrder[index];
    };
    var resetRefs = function() {
        refs.current = [];
    };
    (0,react.useEffect)(function() {
        // @ts-ignore
        setSelectedMenu(function(prev) {
            return getSelectedMenu(menu) || prev;
        });
    }, [
        entries,
        menu
    ]);
    return {
        entries: entries,
        selectedMenu: selectedMenu,
        registerRef: registerRef,
        resetRefs: resetRefs
    };
}
/* harmony default export */ var hooks_useCardObserver = (useCardObserver);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/Pencil.tsx
var Pencil = __webpack_require__(33148);
// EXTERNAL MODULE: ./src/hooks/query/review/useGetInterview.ts
var useGetInterview = __webpack_require__(65008);
// EXTERNAL MODULE: ./src/components/Image/index.tsx + 1 modules
var Image = __webpack_require__(78982);
;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/BarChart/helper.ts
function getWidthByRank(rank) {
    switch(rank){
        case 1:
            return 80;
        case 2:
            return 70;
        case 3:
            return 60;
        case 4:
            return 50;
        default:
            return 40;
    }
}
function getEmojiImagePath(questionType) {
    switch(questionType){
        case "매끄러운 진행":
            return "ico-emoji-process1";
        case "구체적인 안내":
            return "ico-emoji-process2";
        case "일정한 템포":
            return "ico-emoji-process3";
        case "정시 시작":
            return "ico-emoji-process4";
        case "구체적인 질문":
            return "ico-emoji-question1";
        case "적절한 피드백":
            return "ico-emoji-question2";
        case "차별적인 질문":
            return "ico-emoji-question3";
        case "답변 준비 시간 제공":
            return "ico-emoji-question4";
        case "친절한 태도":
            return "ico-emoji-attitude1";
        case "부정적인 태도":
            return "ico-emoji-attitude2";
        case "답변에 도움":
            return "ico-emoji-attitude3";
        case "면접자 긴장 해소":
            return "ico-emoji-attitude4";
        case "적절한 분위기":
            return "ico-emoji-atmosphere1";
        case "쾌적한 환경":
            return "ico-emoji-atmosphere2";
        case "방해 요소":
            return "ico-emoji-atmosphere3";
        case "릴렉스된 분위기":
            return "ico-emoji-atmosphere4";
        default:
            return "ico-emoji-process1";
    }
}

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/BarChart/style.ts

function BarChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n  color: ",
        ";\n  text-align: center;\n  ",
        ";\n"
    ]);
    BarChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding-top: 16px;\n"
    ]);
    BarChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 360px;\n  width: 100%;\n  height: 37px;\n  position: relative;\n  background: ",
        ";\n  border-radius: 4px;\n"
    ]);
    BarChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  width: ",
        "%;\n"
    ]);
    BarChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0.3;\n  width: 40%;\n"
    ]);
    BarChart_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0 8px;\n  position: absolute;\n  top: 8px;\n  left: 12px;\n  color: #fff;\n  z-index: 5;\n  ",
        ";\n"
    ]);
    BarChart_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BarChart_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BarChart_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    BarChart_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 17px;\n"
    ]);
    style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var TotalCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f890c2d-0"
})(BarChart_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));
var BarChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f890c2d-1"
})(BarChart_style_templateObject1());
var style_BarChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f890c2d-2"
})(BarChart_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});
var BarValueIndicator = (0,styled_components_browser_esm/* default */.ZP)(style_BarChart).withConfig({
    componentId: "sc-6f890c2d-3"
})(BarChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple300;
}, function(param) {
    var rank = param.rank;
    return getWidthByRank(rank);
});
var BarValueIndicatorZeroCount = (0,styled_components_browser_esm/* default */.ZP)(BarValueIndicator).withConfig({
    componentId: "sc-6f890c2d-4"
})(BarChart_style_templateObject4());
var LabelChart = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-6f890c2d-5"
})(BarChart_style_templateObject5(), (0,helper/* getFontStyle */.p)("bold150_B3"));
var LabelChartZeroCount = (0,styled_components_browser_esm/* default */.ZP)(LabelChart).withConfig({
    componentId: "sc-6f890c2d-6"
})(BarChart_style_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple400;
});
var LabelChartEmpty = (0,styled_components_browser_esm/* default */.ZP)(LabelChart).withConfig({
    componentId: "sc-6f890c2d-7"
})(BarChart_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.gray650;
});
var CountChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f890c2d-8"
})(style_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple300;
}, (0,helper/* getFontStyle */.p)("bold150_B3"));
var CountChartEmpty = (0,styled_components_browser_esm/* default */.ZP)(CountChart).withConfig({
    componentId: "sc-6f890c2d-9"
})(style_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});
var EmojiWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f890c2d-10"
})(style_templateObject10());

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/BarChart/index.tsx





function BarChart_BarChart(param) {
    var item = param.item, isEmpty = param.isEmpty;
    if (isEmpty) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_BarChart, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelChartEmpty, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji, {
                            questionName: item.content
                        }),
                        item.content
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountChartEmpty, {
                    children: item.count
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BarChart, {
        children: item.count === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelChartZeroCount, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji, {
                            questionName: item.content
                        }),
                        item.content
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BarValueIndicatorZeroCount, {
                    role: "img",
                    rank: item.rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountChart, {
                    children: item.count
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelChart, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji, {
                            questionName: item.content
                        }),
                        item.content
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BarValueIndicator, {
                    role: "img",
                    rank: item.rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountChart, {
                    children: item.count
                })
            ]
        })
    });
};
function Emoji(param) {
    var questionName = param.questionName;
    var imageName = getEmojiImagePath(questionName);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Picture */.t, {
            src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/").concat(imageName, ".png"),
            resolution2xSrc: "".concat(env/* STATIC_ADDRESS */.LV, "/images/").concat(imageName, "@2x.png"),
            width: 16,
            height: 17
        })
    });
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/Tabs/style.ts

function Tabs_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    Tabs_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tabs_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: 32px;\n  color: ",
        ";\n  text-align: center;\n  ",
        ";\n  line-height: 32px;\n"
    ]);
    Tabs_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tabs_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 80px;\n  width: 80px;\n  height: 32px;\n  border: 1px solid ",
        ";\n  border-right-width: 0;\n\n  &.active {\n    border-color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  &.active > ",
        " {\n    color: ",
        ";\n  }\n\n  &.active + & {\n    border-left-color: ",
        ";\n  }\n\n  &:first-child {\n    border-radius: 16px 0px 0px 16px;\n  }\n\n  &:last-child {\n    border-right-width: 1px;\n    border-radius: 0px 16px 16px 0px;\n  }\n"
    ]);
    Tabs_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TabsWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-37e6af1e-0"
})(Tabs_style_templateObject());
var TabItemAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-37e6af1e-1"
})(Tabs_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));
var TabItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-37e6af1e-2"
})(Tabs_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta500;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, TabItemAnchor, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta500;
});

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/Tabs/index.tsx



function Tabs(param) {
    var tabs = param.tabs, activeMenu = param.activeMenu, onClick = param.onClick;
    var handleClick = function(tabId) {
        if (onClick) {
            onClick(tabId);
        }
    };
    var getIsSelected = function(tabId, index) {
        if (!activeMenu && index === 0) {
            return true;
        }
        return tabId === activeMenu;
    };
    if (!tabs) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsWrapper, {
        role: "tablist",
        children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                role: "tab",
                id: item.id,
                className: classnames_default()({
                    active: getIsSelected(item.id, index)
                }),
                onClick: function() {
                    return handleClick(item.id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItemAnchor, {
                    children: item.content
                })
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/ChartContents/helper.ts


function helper_getWidthByRank(rank) {
    switch(rank){
        case 1:
            return 80;
        case 2:
            return 70;
        case 3:
            return 60;
        case 4:
            return 50;
        default:
            return 40;
    }
}
function getRankedReviewList(reviewList) {
    var rank = 1;
    var prevCount = null;
    var sorted = reviewList.sort(function(a, b) {
        return b.count - a.count;
    });
    var rankedReviewList = sorted.map(function(item, index) {
        if (prevCount !== item.count) {
            rank = index + 1;
        }
        prevCount = item.count;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
            rank: rank
        });
    });
    return rankedReviewList;
}

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/ChartContents/style.ts

function InterviewReviewInfo_ChartContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 32px 0 16px;\n  color: ",
        ";\n  text-align: center;\n  ",
        ";\n"
    ]);
    InterviewReviewInfo_ChartContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_ChartContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    InterviewReviewInfo_ChartContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_ChartContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    InterviewReviewInfo_ChartContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n  height: 37px;\n  position: relative;\n  background: ",
        ";\n  border-radius: 4px;\n"
    ]);
    ChartContents_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  width: ",
        "%;\n"
    ]);
    ChartContents_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0.3;\n  width: 40%;\n"
    ]);
    ChartContents_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 8px;\n  left: 12px;\n  color: #fff;\n  z-index: 5;\n  ",
        ";\n"
    ]);
    ChartContents_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    ChartContents_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    ChartContents_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    ChartContents_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ChartContents_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    ChartContents_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var style_TotalCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94c265b5-0"
})(InterviewReviewInfo_ChartContents_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));
var EmptyMessage = (0,styled_components_browser_esm/* default */.ZP)(style_TotalCount).withConfig({
    componentId: "sc-94c265b5-1"
})(InterviewReviewInfo_ChartContents_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});
var style_BarChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94c265b5-2"
})(InterviewReviewInfo_ChartContents_style_templateObject2());
var ChartContents_style_BarChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94c265b5-3"
})(ChartContents_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});
var style_BarValueIndicator = (0,styled_components_browser_esm/* default */.ZP)(ChartContents_style_BarChart).withConfig({
    componentId: "sc-94c265b5-4"
})(ChartContents_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple300;
}, function(param) {
    var rank = param.rank;
    return helper_getWidthByRank(rank);
});
var style_BarValueIndicatorZeroCount = (0,styled_components_browser_esm/* default */.ZP)(style_BarValueIndicator).withConfig({
    componentId: "sc-94c265b5-5"
})(ChartContents_style_templateObject5());
var style_LabelChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94c265b5-6"
})(ChartContents_style_templateObject6(), (0,helper/* getFontStyle */.p)("bold150_B3"));
var style_LabelChartZeroCount = (0,styled_components_browser_esm/* default */.ZP)(style_LabelChart).withConfig({
    componentId: "sc-94c265b5-7"
})(ChartContents_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple400;
});
var style_LabelChartEmpty = (0,styled_components_browser_esm/* default */.ZP)(style_LabelChart).withConfig({
    componentId: "sc-94c265b5-8"
})(ChartContents_style_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.gray650;
});
var style_CountChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94c265b5-9"
})(ChartContents_style_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple300;
}, (0,helper/* getFontStyle */.p)("bold150_B3"));
var style_CountChartEmpty = (0,styled_components_browser_esm/* default */.ZP)(style_CountChart).withConfig({
    componentId: "sc-94c265b5-10"
})(ChartContents_style_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/ChartContents/index.tsx








function ChartContents_ChartContents() {
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useGetInterview/* default */.Z)(companyHash), data = ref.data, status = ref.status;
    var ref1 = (0,useGetInterview/* useGetInterviewReviewTabs */.X)(companyHash), tabs = ref1.data;
    var ref2 = (0,react.useState)(), selectedTabId = ref2[0], setSelectedTabId = ref2[1];
    var ref3 = (0,react.useState)(), selectedChartList = ref3[0], setSelectedChartList = ref3[1];
    var handleClickTab = function(tabId) {
        setSelectedTabId(tabId);
        if (data === null || data === void 0 ? void 0 : data.reviews) {
            setSelectedChartList(getRankedReviewList(data === null || data === void 0 ? void 0 : data.reviews[tabId].data));
        }
    };
    (0,react.useEffect)(function() {
        setSelectedTabId(data === null || data === void 0 ? void 0 : data.defaultSource);
        if ((data === null || data === void 0 ? void 0 : data.reviews) && (data === null || data === void 0 ? void 0 : data.defaultSource)) {
            setSelectedChartList(getRankedReviewList(data === null || data === void 0 ? void 0 : data.reviews[data === null || data === void 0 ? void 0 : data.defaultSource].data));
        }
    }, [
        data
    ]);
    if (status !== "success") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                tabs: tabs,
                activeMenu: selectedTabId,
                onClick: handleClickTab
            }),
            data.totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyMessage, {
                children: "작성된 면접 리뷰가 없습니다."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_TotalCount, {
                children: [
                    "총 참여수 ",
                    data.totalCount,
                    "명"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BarChartWrapper, {
                children: selectedChartList === null || selectedChartList === void 0 ? void 0 : selectedChartList.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BarChart_BarChart, {
                        item: item,
                        isEmpty: data.totalCount === 0
                    }, "".concat(selectedTabId, "-").concat(index));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/hooks.ts


function hooks_useDisplayTrigger(ref) {
    var _$ref = (0,react.useState)(), isDisplayed = _$ref[0], setIsDisplayed = _$ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && !isDisplayed) {
            setIsDisplayed(true);
        }
    }, [
        entry,
        isDisplayed
    ]);
    return isDisplayed || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
}

;// CONCATENATED MODULE: ./src/features/company/NudgeLoginDialog/style.ts

function NudgeLoginDialog_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  display: inline-block;\n  padding: 16px 32px;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  ",
        ";\n"
    ]);
    NudgeLoginDialog_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NudgeLoginDialog_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  text-align: center;\n"
    ]);
    NudgeLoginDialog_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NudgeLoginDialog_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  color: ",
        ";\n  white-space: nowrap;\n  margin-bottom: 8px;\n  ",
        ";\n"
    ]);
    NudgeLoginDialog_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NudgeLoginDialog_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n"
    ]);
    NudgeLoginDialog_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var style_MessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7df7dd3b-0"
})(NudgeLoginDialog_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var inlineCss = param.inlineCss;
    return inlineCss;
});
var style_Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7df7dd3b-1"
})(NudgeLoginDialog_style_templateObject1(), (0,helper/* getFontStyle */.p)("midium150_C1"));
var SubMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7df7dd3b-2"
})(NudgeLoginDialog_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_C2"));
var style_ButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7df7dd3b-3"
})(NudgeLoginDialog_style_templateObject3());

;// CONCATENATED MODULE: ./src/features/company/NudgeLoginDialog/index.tsx



function NudgeLoginDialog(param) {
    var message = param.message, subMessage = param.subMessage, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "로그인" : _buttonText, inlineCss = param.inlineCss, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_MessageWrapper, {
        inlineCss: inlineCss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Message, {
                children: message
            }),
            subMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMessage, {
                children: subMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_ButtonGroup, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "magenta",
                    size: "sm",
                    onClick: onClick,
                    children: buttonText
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/NudgeLogin/constants.ts
var DUMMY_TABS = [
    {
        id: "process",
        content: "진행 방식"
    },
    {
        id: "question",
        content: "질문 내용"
    },
    {
        id: "attitude",
        content: "면접관 태도"
    },
    {
        id: "atmosphere",
        content: "분위기"
    }, 
];

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/NudgeLogin/style.ts

function NudgeLogin_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  text-align: center;\n"
    ]);
    NudgeLogin_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NudgeLogin_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 32px;\n"
    ]);
    NudgeLogin_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NudgeLogin_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 152px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  z-index: 1;\n  white-space: pre;\n"
    ]);
    NudgeLogin_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NudgeLogin_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    NudgeLogin_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var NudgeLogin_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372a9eb0-0"
})(NudgeLogin_style_templateObject());
var style_TabsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372a9eb0-1"
})(NudgeLogin_style_templateObject1());
var cssNudgeDialog = (0,styled_components_browser_esm/* css */.iv)(NudgeLogin_style_templateObject2());
var style_VideoWrapper = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-372a9eb0-2"
})(NudgeLogin_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/NudgeLogin/index.tsx











function NudgeLogin() {
    var router = (0,next_router.useRouter)();
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref.data;
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var handleClick = function() {
        if (isActiveUser) {
            return router.push("/review/interview?companyHash=".concat(companyHash, "&beforeUrl=").concat(env/* WEB_URL */.h$).concat(router.asPath, "#interview-review-chart"));
        }
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#interview-review-chart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NudgeLogin_style_Wrapper, {
        onClick: handleClick,
        "data-attribute-id": "company__interviewReview__write__click",
        "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
        "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
        "data-is-blur": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NudgeLoginDialog, {
                inlineCss: cssNudgeDialog,
                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        "의",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "면접이 궁금하다면?"
                    ]
                }),
                buttonText: "리뷰하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_TabsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                    tabs: DUMMY_TABS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_VideoWrapper, {
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-interview.webm"),
                        type: "video/webm"
                    }, "/images/video-chart-review-interview.webm"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-interview.mp4"),
                        type: "video/mp4"
                    }, "/images/video-chart-review-interview.mp4")
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/style.ts

function InterviewReviewInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translate3d(-100%, 3px, 0);\n  }\n  50% {\n    transform: translate3d(-100%, -3px, 0);\n  }\n  100% {\n    transform: translate3d(-100%, 0, 0);\n  }\n"
    ]);
    InterviewReviewInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translate3d(-50%, 3px, 0);\n  }\n  50% {\n    transform: translate3d(-50%, -3px, 0);\n  }\n  100% {\n    transform: translate3d(-50%, 0, 0);\n  }\n"
    ]);
    InterviewReviewInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-top: 24px;\n  padding: 40px 20px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    InterviewReviewInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    InterviewReviewInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 150ms 2 linear;\n      animation-delay: 500ms;\n\n      ",
        " {\n        animation-name: ",
        ";\n      }\n    "
    ]);
    InterviewReviewInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: -10px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  color: ",
        ";\n  transform: translate3d(-100%, 0, 0);\n  white-space: pre;\n  text-align: center;\n  z-index: 10;\n  ",
        ";\n\n  ",
        " {\n    top: auto;\n    bottom: -67px;\n    left: 50%;\n    transform: translate3d(-50%, 0, 0);\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: -8px;\n    width: 0;\n    height: 0;\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 8px solid ",
        ";\n    transform: translate3d(0, -50%, 0);\n\n    ",
        " {\n      top: -14px;\n      right: auto;\n      left: 50%;\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      border-bottom: 8px solid ",
        ";\n      transform: translate3d(-50%, 0, 0);\n    }\n  }\n\n  ",
        "\n"
    ]);
    InterviewReviewInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    InterviewReviewInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function InterviewReviewInfo_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 6px;\n\n  > svg {\n    vertical-align: top;\n  }\n"
    ]);
    InterviewReviewInfo_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var ShakeKeyframe = (0,styled_components_browser_esm/* keyframes */.F4)(InterviewReviewInfo_style_templateObject());
var ShakeKeyframeForMobile = (0,styled_components_browser_esm/* keyframes */.F4)(InterviewReviewInfo_style_templateObject1());
var InterviewReviewInfo_style_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e8f381-0"
})(InterviewReviewInfo_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var RightCardHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e8f381-1"
})(InterviewReviewInfo_style_templateObject3());
var style_Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e8f381-2"
})(InterviewReviewInfo_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var animStart = param.animStart, theme = param.theme;
    return animStart && (0,styled_components_browser_esm/* css */.iv)(InterviewReviewInfo_style_templateObject4(), ShakeKeyframe, theme.media.mobile, ShakeKeyframeForMobile);
});
var BreakLineOnlyMobile = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-77e8f381-3"
})(InterviewReviewInfo_style_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ButtonWriteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77e8f381-4"
})(InterviewReviewInfo_style_templateObject7());

;// CONCATENATED MODULE: ./src/features/company/InterviewReviewInfo/index.tsx



















function InterviewReviewInfo(param) {
    var registerRef = param.registerRef;
    var ref = (0,useMyInfoQuery/* default */.Z)(), isActiveUser = ref.isActiveUser, userInfo = ref.data;
    var router = (0,next_router.useRouter)();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var wrapperRef = (0,react.useRef)(null);
    var isDisplay = hooks_useDisplayTrigger(wrapperRef);
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref1.data;
    var ref2 = (0,useGetInterview/* default */.Z)(companyHash), data = ref2.data, isLoading = ref2.isLoading;
    // useEffect(() => {
    //   setGtmDataLayer('')
    // }, [])
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (wrapperRef.current && hash === "company-review-chart" && isServer/* isClient */.C) {
            router.replace(path);
            wrapperRef.current.scrollIntoView();
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, {
        title: "면접 리뷰",
        sectionId: COMPANY_DETAIL_MENU.INTERVIEW_REVIEW,
        isNew: true,
        registerRef: registerRef,
        rightCardHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isActiveUser && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.interviewReview) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightCardHeaderWrapper, {
                children: [
                    !isLoading && (data === null || data === void 0 ? void 0 : data.totalCount) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Tooltip, {
                        animStart: isDisplay,
                        children: [
                            "기업의 첫 리뷰를 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakLineOnlyMobile, {}),
                            "작성해주세요!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/review/interview?companyHash=".concat(companyHash, "&beforeUrl=/company/").concat(companyHash, "#interview-review-chart"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            "data-attribute-id": "company__interviewReview__write__click",
                            "data-is-blur": "false",
                            "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                            "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                            variant: !isLoading && (data === null || data === void 0 ? void 0 : data.totalCount) === 0 ? "magenta" : "light",
                            size: "sm",
                            as: "a",
                            leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWriteWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {
                                    color: !isLoading && (data === null || data === void 0 ? void 0 : data.totalCount) === 0 ? theme.colors.white100 : theme.colors.gray800,
                                    width: 12,
                                    height: 12
                                })
                            }),
                            children: "리뷰 작성"
                        })
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InterviewReviewInfo_style_Contents, {
            ref: wrapperRef,
            children: isActiveUser && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.interviewReview) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartContents_ChartContents, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NudgeLogin, {})
        })
    });
};

// EXTERNAL MODULE: ./src/features/board/ModalJobdomEditor/index.tsx + 6 modules
var ModalJobdomEditor = __webpack_require__(93247);
// EXTERNAL MODULE: ./src/hooks/query/jobdom/useJobdom.ts
var useJobdom = __webpack_require__(54909);
// EXTERNAL MODULE: ./src/store/jobdom.ts
var jobdom = __webpack_require__(92589);
;// CONCATENATED MODULE: ./src/components/Icon/Outlink.tsx


function Outlink(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, color = param.color;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: width,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.25 12.25H1.75V1.75H7V0.25H1.75C0.9175 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.9175 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V7H12.25V12.25ZM8.5 0.25V1.75H11.1925L3.82 9.1225L4.8775 10.18L12.25 2.8075V5.5H13.75V0.25H8.5Z",
            fill: color || theme.colors.gray900
        })
    });
};

// EXTERNAL MODULE: ./src/store/enviroment.ts
var enviroment = __webpack_require__(60716);
;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/ButtonMore/style.ts

function ButtonMore_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 7px;\n"
    ]);
    ButtonMore_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceeb89ab-0"
})(ButtonMore_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/ButtonMore/index.tsx










function ButtonMore(_param) {
    var postId = _param.postId, postCount = _param.postCount, props = (0,_object_without_properties/* default */.Z)(_param, [
        "postId",
        "postCount"
    ]);
    var router = (0,next_router.useRouter)();
    var isApp = (0,enviroment/* default */.Z)().isApp;
    var buttonInfo = (0,react.useMemo)(function() {
        if (!postCount) {
            return null;
        }
        if (postCount > 3) {
            return {
                text: "".concat(postCount, "개의 JOB담 더보기"),
                link: "/board?PK_NM_HASH=".concat(postId)
            };
        }
        return {
            text: "다른 회사 JOB담 보기",
            link: "/board"
        };
    }, [
        postCount,
        postId
    ]);
    if (!buttonInfo) {
        return null;
    }
    var handleClick = function() {
        if (isApp) {
            router.push(buttonInfo.link);
            return;
        }
        window.open(buttonInfo.link);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        variant: "light",
        size: "md",
        leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinkIcon, {}),
        onClick: handleClick
    }, props), {
        children: buttonInfo.text
    }));
};
function OutlinkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Outlink, {})
    });
}

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/ButtonWriteBoard/style.ts

function ButtonWriteBoard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 6px;\n\n  > svg {\n    vertical-align: top;\n  }\n"
    ]);
    ButtonWriteBoard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14edc416-0"
})(ButtonWriteBoard_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/ButtonWriteBoard/index.tsx









function ButtonWriteBoard() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref.data;
    var refetch = (0,useJobdom/* useGetJobdomByCompanyQuery */.Be)(companyId).refetch;
    var ref1 = (0,jobdom/* default */.Z)(), setModalJobEditor = ref1.setModalJobEditor, resetModalJobEditor = ref1.resetModalJobEditor;
    var handleClick = function() {
        setModalJobEditor({
            open: true,
            mode: "write",
            companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
            PK_NM_HASH: companyId !== null && companyId !== void 0 ? companyId : "",
            onSuccess: function() {
                refetch();
                resetModalJobEditor();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "light",
        size: "sm",
        leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilIcon, {}),
        "data-attribute-id": "company__board__write__click",
        onClick: handleClick,
        children: "글쓰기"
    });
};
function PencilIcon() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_IconWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {
            color: theme.colors.gray800,
            width: 12,
            height: 12
        })
    });
}

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/EmptyJobdom/style.ts

function EmptyJobdom_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 60px 0;\n  text-align: center;\n"
    ]);
    EmptyJobdom_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyJobdom_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    EmptyJobdom_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptyJobdom_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n"
    ]);
    EmptyJobdom_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var EmptyJobdom_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-479ccdf3-0"
})(EmptyJobdom_style_templateObject());
var Img = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-479ccdf3-1"
})(EmptyJobdom_style_templateObject1());
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-479ccdf3-2"
})(EmptyJobdom_style_templateObject2());

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/EmptyJobdom/index.tsx




function EmptyJobdom() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyJobdom_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                src: "https://image.wanted.co.kr/kreditjob/www/pencil.png",
                alt: "pencil"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                    typography: "bold150_B2",
                    children: "아직 등록된 글이 없습니다."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                typography: "midium150_B3",
                as: "div",
                dangerouslySetInnerHTML: {
                    __html: isMobile ? "이 기업의 연봉, 스톡옵션, 성과급 등에 대한</br>이야기를 남겨주세요." : "이 기업의 연봉, 스톡옵션, 성과급 등에 대한 이야기를 남겨주세요."
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Icon/ThumbsDown.tsx
var ThumbsDown = __webpack_require__(63985);
// EXTERNAL MODULE: ./src/components/Icon/ThumbsUp.tsx
var ThumbsUp = __webpack_require__(2953);
// EXTERNAL MODULE: ./src/components/Icon/View.tsx
var View = __webpack_require__(6089);
// EXTERNAL MODULE: ./src/utils/common/getOneIdUrl.ts
var getOneIdUrl = __webpack_require__(18251);
// EXTERNAL MODULE: ./src/utils/common/jobdomViewCount.ts
var jobdomViewCount = __webpack_require__(2609);
;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/JobdomItem/style.ts

function JobdomItem_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    JobdomItem_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 20px 0;\n"
    ]);
    JobdomItem_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  margin-bottom: 20px;\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    JobdomItem_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    JobdomItem_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -1px;\n"
    ]);
    JobdomItem_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 1px;\n"
    ]);
    JobdomItem_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: auto;\n    "
    ]);
    JobdomItem_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0 20px;\n\n  ",
        "\n"
    ]);
    JobdomItem_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    JobdomItem_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n  background: none;\n  border-width: 0;\n"
    ]);
    JobdomItem_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function JobdomItem_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-left: 10px;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 8px;\n  padding: 2px 3px;\n  border-radius: 2px;\n\n  &::after {\n    content: '';\n    display: block;\n    width: 0;\n    height: 0;\n    border-left: 1px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid #e6e6e6;\n    position: absolute;\n    bottom: -5px;\n    left: 4px;\n  }\n"
    ]);
    JobdomItem_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var JobdomItem_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-0"
})(JobdomItem_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var Anchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a54896e3-1"
})(JobdomItem_style_templateObject1());
var style_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-2"
})(JobdomItem_style_templateObject2(), (0,helper/* getFontStyle */.p)("midium150_B3"), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-3"
})(JobdomItem_style_templateObject3());
var ThumbsUpWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-4"
})(JobdomItem_style_templateObject4());
var ThumbsDownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-5"
})(JobdomItem_style_templateObject5());
var ItemGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-6"
})(JobdomItem_style_templateObject7(), function(param) {
    var align = param.align;
    return align === "right" && (0,styled_components_browser_esm/* css */.iv)(JobdomItem_style_templateObject6());
});
var InfoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-7"
})(JobdomItem_style_templateObject8(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var JobdomItem_style_IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a54896e3-8"
})(JobdomItem_style_templateObject9());
var Comment = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-a54896e3-9"
})(JobdomItem_style_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/JobdomItem/index.tsx















function JobdomItem(param) {
    var contentId = param.contentId, companyId = param.companyId, PK_NM_HASH = param.PK_NM_HASH, companyName = param.companyName, author = param.author, subject = param.subject, createdAt = param.createdAt, likesCount = param.likesCount, unlikesCount = param.unlikesCount, viewCount = param.viewCount, commentCount = param.commentCount, onClickReaction = param.onClickReaction;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var router = (0,next_router.useRouter)();
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var ref = (0,useJobdom/* useJobdomLikeMutation */.a4)(onClickReaction), handleLike = ref.mutate;
    var ref1 = (0,useJobdom/* useJobdomDislikeMutation */.C4)(onClickReaction), handleDislike = ref1.mutate;
    var ref2 = (0,react.useState)(), clickedLike = ref2[0], setClickedLike = ref2[1];
    var ref3 = (0,react.useState)(), clickedDislike = ref3[0], setClickedDislike = ref3[1];
    var getReactionIconColor = function(value) {
        return value ? theme.colors.gray900 : theme.colors.gray500;
    };
    var handleClickItem = function(url) {
        var viewCount = (0,jobdomViewCount/* getJobdomViewCount */.XS)();
        var isUnavailable = !isActiveUser && viewCount >= 1;
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__board__content__click", {
            companyName: companyName,
            companyHash: PK_NM_HASH,
            contentId: contentId,
            landingUrl: isUnavailable ? (0,getOneIdUrl/* default */.Z)({
                beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath)
            }) : "".concat(env/* WEB_URL */.h$).concat(url)
        });
        if (isUnavailable) {
            moveOneIdPage({
                beforeUrl: url,
                messageKey: "kreditjob_company_bookmark_title"
            });
            return;
        }
        router.push(url);
    };
    var handleClickLike = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        var type = "minus";
        if (!clickedLike) {
            type = "plus";
        }
        setClickedLike(type === "plus");
        handleLike({
            jobdomNumber: contentId,
            type: type
        });
    }, [
        contentId,
        clickedLike,
        handleLike
    ]);
    var handleClickDislike = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        var type = "minus";
        if (!clickedDislike) {
            type = "plus";
        }
        setClickedDislike(type === "plus");
        handleDislike({
            jobdomNumber: contentId,
            type: type
        });
    }, [
        contentId,
        clickedDislike,
        handleDislike
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomItem_style_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor, {
            onClick: function() {
                return handleClickItem("/board/".concat(contentId));
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Content, {
                    children: [
                        subject,
                        commentCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, {
                            typography: "bold120_C2",
                            children: commentCount
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemGroup, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomItem_style_IconWrapper, {
                                            onClick: handleClickLike,
                                            as: "button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsUpWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsUp/* default */.Z, {
                                                    width: 14,
                                                    height: 13,
                                                    color: getReactionIconColor(clickedLike)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: likesCount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomItem_style_IconWrapper, {
                                            onClick: handleClickDislike,
                                            as: "button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsDownWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsDown/* default */.Z, {
                                                    width: 14,
                                                    height: 13,
                                                    color: getReactionIconColor(clickedDislike)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: unlikesCount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomItem_style_IconWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(View/* default */.Z, {
                                                width: 14,
                                                height: 10,
                                                color: theme.colors.gray500
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: viewCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemGroup, {
                            align: "right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoItem, {
                                    children: author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoItem, {
                                    children: createdAt
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/JobdomContainer/style.ts

function JobdomContainer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 20px;\n"
    ]);
    JobdomContainer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobdomContainer_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 45px;\n  background: linear-gradient(359deg, #ffffff 5.47%, rgba(255, 255, 255, 0) 99.01%);\n  border-radius: 4px;\n\n  ",
        " {\n    height: 70px;\n  }\n"
    ]);
    JobdomContainer_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var StyledJobdomContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce96e113-0"
})(JobdomContainer_style_templateObject());
var Shadow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce96e113-1"
})(JobdomContainer_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/JobdomContainer/index.tsx




function JobdomContainer(param) {
    var posts = param.posts, postCount = param.postCount, PK_NM_HASH = param.PK_NM_HASH, companyName = param.companyName, companyId = param.companyId, onClickReaction = param.onClickReaction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledJobdomContainer, {
        children: [
            posts.map(function(param) {
                var id = param.id, name = param.name, subject = param.subject, viewCount = param.viewCount, likesCount = param.likesCount, unlikesCount = param.unlikesCount, commentCount = param.commentCount, createdAt = param.createdAt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomItem, {
                    contentId: id,
                    companyId: companyId,
                    PK_NM_HASH: PK_NM_HASH,
                    companyName: companyName,
                    subject: subject,
                    viewCount: viewCount,
                    likesCount: likesCount,
                    unlikesCount: unlikesCount,
                    author: name,
                    commentCount: commentCount,
                    createdAt: dayjs_min_default()(createdAt).format("YYYY-MM-DD"),
                    onClickReaction: onClickReaction
                }, id);
            }),
            postCount > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shadow, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/style.ts

function JobdomInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 20px;\n  text-align: center;\n"
    ]);
    JobdomInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8fdd5bd2-0"
})(JobdomInfo_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/JobdomInfo/index.tsx



















function JobdomInfo(param) {
    var registerRef = param.registerRef;
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useJobdom/* useGetJobdomByCompanyQuery */.Be)(companyId), posts = ref.data, statusPosts = ref.status, refetchPosts = ref.refetch;
    var ref1 = (0,useCompanyStates/* default */.Z)(companyId), companyStates = ref1.data, statusCompanyStates = ref1.status;
    var ref2 = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref2.data, statusCompanyInfo = ref2.status;
    var ref3 = (0,jobdom/* default */.Z)(), modalJobdomEditor = ref3.modalJobdomEditor, resetModalJobEditor = ref3.resetModalJobEditor;
    var handlwClickReaction = function() {
        refetchPosts();
    };
    var cardProps = {
        sectionId: COMPANY_DETAIL_MENU.COMMUNITY,
        title: "JOB담",
        registerRef: registerRef
    };
    if (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted) {
        return null;
    }
    if (statusPosts === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
        }));
    }
    if (statusPosts === "loading" || !companyInfo) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        }));
    }
    if (statusPosts !== "success" || statusCompanyStates !== "success" || statusCompanyInfo !== "success" || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
        rightCardHeader: (companyStates === null || companyStates === void 0 ? void 0 : companyStates.board) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWriteBoard, {}),
        children: !(companyStates === null || companyStates === void 0 ? void 0 : companyStates.board) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(company_BlockedInfo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                posts.rows.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyJobdom, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomContainer, {
                            posts: posts.rows,
                            postCount: posts.count,
                            companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                            companyId: companyInfo.id,
                            PK_NM_HASH: companyId,
                            onClickReaction: handlwClickReaction
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(style_ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore, {
                                postId: companyId,
                                postCount: posts.count,
                                "data-attribute-id": "company__board__seeMore",
                                "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                                "data-board-count": posts === null || posts === void 0 ? void 0 : posts.count
                            })
                        })
                    ]
                }),
                modalJobdomEditor.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalJobdomEditor/* default */.Z, {
                    isOpen: true,
                    handleClose: function() {
                        return resetModalJobEditor();
                    },
                    defaultValues: modalJobdomEditor
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/features/company/ManageCompanyInfo/style.ts

function ManageCompanyInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 794px;\n  text-align: center;\n  padding: 50px 0;\n\n  ",
        " {\n    max-width: inherit;\n  }\n\n  ",
        " {\n    max-width: inherit;\n    padding: 44px 0 60px;\n  }\n"
    ]);
    ManageCompanyInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManageCompanyInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 15px;\n  color: ",
        ";\n  text-align: center;\n  ",
        ";\n"
    ]);
    ManageCompanyInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ManageCompanyInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  margin-left: 6px;\n"
    ]);
    ManageCompanyInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ManageCompanyInfo_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-60515009-0"
})(ManageCompanyInfo_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Heading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-60515009-1"
})(ManageCompanyInfo_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold120_B2"));
var ArrowIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-60515009-2"
})(ManageCompanyInfo_style_templateObject2());

;// CONCATENATED MODULE: ./src/features/company/ManageCompanyInfo/index.tsx








function ManageCompanyInfo() {
    var router = (0,next_router.useRouter)();
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyStates/* default */.Z)(companyId), companyStates = ref.data, statusCompanyStates = ref.status;
    var ref1 = (0,react.useState)(), isBlockedComapny = ref1[0], setIsBlockedComapny = ref1[1];
    // const [isOpen, setIsOpen] = useState(false);
    var handleClick = function() {
        var url = "/block/".concat(companyId).concat(isBlockedComapny ? "?type=unblock" : "");
        router.push(url);
    };
    (0,react.useEffect)(function() {
        setIsBlockedComapny(!(companyStates === null || companyStates === void 0 ? void 0 : companyStates.salary) || !(companyStates === null || companyStates === void 0 ? void 0 : companyStates.employee) || !(companyStates === null || companyStates === void 0 ? void 0 : companyStates.sales));
    }, [
        companyStates
    ]);
    if (statusCompanyStates !== "success" || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ManageCompanyInfo_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                children: "이 기업의 관리자이신가요?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: handleClick,
                variant: "light",
                "data-attribute-id": "company__request__click",
                trailing: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIconWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLine/* default */.Z, {})
                }),
                children: isBlockedComapny ? "블록해제 및 기업정보 수정 요청하기" : "블록 및 기업정보 수정 요청하기"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/query/company/useCompanyCultureReview.ts
var useCompanyCultureReview = __webpack_require__(6016);
;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/style.ts

function ReviewInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translate3d(-100%, 3px, 0);\n  }\n  50% {\n    transform: translate3d(-100%, -3px, 0);\n  }\n  100% {\n    transform: translate3d(-100%, 0, 0);\n  }\n"
    ]);
    ReviewInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translate3d(-50%, 3px, 0);\n  }\n  50% {\n    transform: translate3d(-50%, -3px, 0);\n  }\n  100% {\n    transform: translate3d(-50%, 0, 0);\n  }\n"
    ]);
    ReviewInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 28px;\n  scroll-margin-top: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n"
    ]);
    ReviewInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    ReviewInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 150ms 2 linear;\n      animation-delay: 500ms;\n\n      ",
        " {\n        animation-name: ",
        ";\n      }\n    "
    ]);
    ReviewInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: -10px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  color: ",
        ";\n  transform: translate3d(-100%, 0, 0);\n  white-space: pre;\n  text-align: center;\n  z-index: 10;\n  ",
        ";\n\n  ",
        " {\n    top: auto;\n    bottom: -67px;\n    left: 50%;\n    transform: translate3d(-50%, 0, 0);\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: -8px;\n    width: 0;\n    height: 0;\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 8px solid ",
        ";\n    transform: translate3d(0, -50%, 0);\n\n    ",
        " {\n      top: -14px;\n      right: auto;\n      left: 50%;\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      border-bottom: 8px solid ",
        ";\n      transform: translate3d(-50%, 0, 0);\n    }\n  }\n\n  ",
        "\n"
    ]);
    ReviewInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 6px;\n\n  > svg {\n    vertical-align: top;\n  }\n"
    ]);
    ReviewInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    ReviewInfo_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ReviewInfo_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n"
    ]);
    ReviewInfo_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ReviewInfo_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ",
        ";\n  ",
        ";\n\n  img {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    ReviewInfo_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function style_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 40px 20px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    style_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var style_ShakeKeyframe = (0,styled_components_browser_esm/* keyframes */.F4)(ReviewInfo_style_templateObject());
var style_ShakeKeyframeForMobile = (0,styled_components_browser_esm/* keyframes */.F4)(ReviewInfo_style_templateObject1());
var ReviewInfo_style_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-0"
})(ReviewInfo_style_templateObject2());
var style_RightCardHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-1"
})(ReviewInfo_style_templateObject3());
var ReviewInfo_style_Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-2"
})(ReviewInfo_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var animStart = param.animStart, theme = param.theme;
    return animStart && (0,styled_components_browser_esm/* css */.iv)(ReviewInfo_style_templateObject4(), style_ShakeKeyframe, theme.media.mobile, style_ShakeKeyframeForMobile);
});
var style_ButtonWriteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-3"
})(ReviewInfo_style_templateObject6());
var style_BreakLineOnlyMobile = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c90cf7f8-4"
})(ReviewInfo_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var SectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-5"
})(ReviewInfo_style_templateObject8());
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-6"
})(ReviewInfo_style_templateObject9());
var SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-7"
})(ReviewInfo_style_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B2"));
var SectionContents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90cf7f8-8"
})(style_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ButtonMore/style.ts

function CultureSection_ButtonMore_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    CultureSection_ButtonMore_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonMore_style_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-41ade70f-0"
})(CultureSection_ButtonMore_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ButtonMore/index.tsx




function ButtonMore_ButtonMore(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore_style_Wrapper, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        variant: "light",
        size: "sm"
    }, props), {
        children: "자세히 보기"
    }));
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/BarChart/style.ts

function ChartContents_BarChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n\n      &:hover {\n        background-color: ",
        ";\n      }\n    "
    ]);
    ChartContents_BarChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChartContents_BarChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  margin: 0 auto;\n  background-color: ",
        ";\n  padding: 8px 6px;\n  border-radius: 2px;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n\n  span {\n    color: ",
        ";\n    z-index: 1;\n  }\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ChartContents_BarChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChartContents_BarChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 8px;\n  left: 0;\n  background-color: ",
        ";\n  border-radius: 2px;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  z-index: 2;\n  ",
        ";\n"
    ]);
    ChartContents_BarChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChartContents_BarChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  width: ",
        "%;\n  height: 100%;\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    ChartContents_BarChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var style_ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-488e5145-0"
})(ChartContents_BarChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta500;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta600;
}, function(param) {
    var isEmpty = param.isEmpty;
    return isEmpty && (0,styled_components_browser_esm/* css */.iv)(ChartContents_BarChart_style_templateObject(), function(param) {
        var theme = param.theme;
        return theme.colors.gray200;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.gray200;
    });
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_EmptyMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-488e5145-1"
})(ChartContents_BarChart_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));
var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-488e5145-2"
})(ChartContents_BarChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.greypurple300;
}, function(param) {
    var leftWidth = param.leftWidth;
    return leftWidth;
}, function(param) {
    var theme = param.theme;
    return theme.colors.greypurple400;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/BarChart/index.tsx



function ChartContents_BarChart_BarChart(param) {
    var chartData = param.chartData;
    var isEmpty = chartData.leftData.count + chartData.rightData.count === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_ChartWrapper, {
        isEmpty: isEmpty,
        role: "img",
        "aria-label": "Horizontal Bar Chart",
        children: [
            isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_EmptyMessage, {
                children: "등록된 리뷰가 없습니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
                role: "presentation",
                leftWidth: chartData.leftData.rate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                typography: "midium150_C1",
                children: [
                    chartData.leftData.rate,
                    "% (",
                    chartData.leftData.count,
                    "명)"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                typography: "midium150_C1",
                children: [
                    chartData.rightData.rate,
                    "% (",
                    chartData.rightData.count,
                    "명)"
                ]
            })
        ]
    });
}
/* harmony default export */ var ChartContents_BarChart = (ChartContents_BarChart_BarChart);

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/style.ts

function CultureSection_ChartContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n"
    ]);
    CultureSection_ChartContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CultureSection_ChartContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: 4px;\n  text-align: center;\n  word-break: keep-all;\n"
    ]);
    CultureSection_ChartContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CultureSection_ChartContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    CultureSection_ChartContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CultureSection_ChartContents_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n\n  ",
        " {\n    width: 100%;\n  }\n\n  span {\n    color: ",
        ";\n    ",
        "\n  }\n"
    ]);
    CultureSection_ChartContents_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var ChartSectionWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-dcc8a15-0"
})(CultureSection_ChartContents_style_templateObject());
var ChartTitle = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-dcc8a15-1"
})(CultureSection_ChartContents_style_templateObject1());
var style_ChartContent = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-dcc8a15-2"
})(CultureSection_ChartContents_style_templateObject2());
var style_Legend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dcc8a15-3"
})(CultureSection_ChartContents_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/index.tsx





function CultureSection_ChartContents_ChartContents(param) {
    var isSummary = param.isSummary;
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var data = (0,useCompanyCultureReview/* default */.Z)(companyHash).data;
    var cultureList = isSummary ? data === null || data === void 0 ? void 0 : data.cultureList.slice(0, 4) : data === null || data === void 0 ? void 0 : data.cultureList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartSectionWrapper, {
        children: cultureList === null || cultureList === void 0 ? void 0 : cultureList.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_ChartContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartTitle, {
                        typography: "midium150_B3",
                        children: item.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartContents_BarChart, {
                        chartData: item.chartData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Legend, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.chartData.leftData.legend
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.chartData.rightData.legend
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
}
/* harmony default export */ var CultureSection_ChartContents = (CultureSection_ChartContents_ChartContents);

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/NudgeLoginSection/style.ts

function NudgeLoginSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 226px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  z-index: 1;\n"
    ]);
    NudgeLoginSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NudgeLoginSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    NudgeLoginSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var style_cssNudgeDialog = (0,styled_components_browser_esm/* css */.iv)(NudgeLoginSection_style_templateObject());
var NudgeLoginSection_style_VideoWrapper = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-5c1e2c5d-0"
})(NudgeLoginSection_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ChartContents/NudgeLoginSection/index.tsx












function NudgeLoginSection() {
    var router = (0,next_router.useRouter)();
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,useCompanyCultureReview/* default */.Z)(companyHash), culturlReview = ref.data;
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref1.data;
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var handleClick = function() {
        if (isActiveUser) {
            return router.push("/review/culture?companyHash=".concat(companyHash, "&beforeUrl=").concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"));
        }
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartSectionWrapper, {
        onClick: handleClick,
        "data-attribute-id": "company__review__write__click",
        "data-is-review-exist": (culturlReview === null || culturlReview === void 0 ? void 0 : culturlReview.isAllEmpty) ? "false" : "true",
        "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
        "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
        "data-review-type": "culture",
        "data-is-blur": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NudgeLoginDialog, {
                inlineCss: style_cssNudgeDialog,
                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        "의",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "조직문화가 궁금하다면?"
                    ]
                }),
                buttonText: "리뷰하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NudgeLoginSection_style_VideoWrapper, {
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/barchart-culture").concat(isMobile ? "-m" : "", ".webm"),
                        type: "video/webm"
                    }, "/images/barchart-culture.webm"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/barchart-culture").concat(isMobile ? "-m" : "", ".mp4"),
                        type: "video/mp4"
                    }, "/images/barchart-culture.mp4")
                ]
            })
        ]
    });
}
/* harmony default export */ var ChartContents_NudgeLoginSection = (NudgeLoginSection);

// EXTERNAL MODULE: ./src/components/ModalBase/index.tsx + 1 modules
var ModalBase = __webpack_require__(49900);
;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ModalCultureReview/style.ts

function ModalCultureReview_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    transform: translate3d(0, 0, 0);\n  }\n"
    ]);
    ModalCultureReview_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalCultureReview_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 375px;\n  height: 600px;\n  background: #fff;\n  border-radius: 4px;\n  padding: 56px 24px 48px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ModalCultureReview_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalCultureReview_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n  text-align: center;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    ModalCultureReview_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalCultureReview_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 440px;\n  overflow: auto;\n  padding: 24px 16px;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n\n  ",
        " {\n    height: calc(100vh - 190px);\n  }\n"
    ]);
    ModalCultureReview_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var cssModal = (0,styled_components_browser_esm/* css */.iv)(ModalCultureReview_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ModalCultureReview_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8909a99-0"
})(ModalCultureReview_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ModalCultureReview_style_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-f8909a99-1"
})(ModalCultureReview_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, (0,helper/* getFontStyle */.p)("bold150_H5"));
var ScrollableContents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8909a99-2"
})(ModalCultureReview_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/ModalCultureReview/index.tsx




function ModalCultureReview(param) {
    var isOpen = param.isOpen, handleClose = param.handleClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* default */.Z, {
        isOpen: isOpen,
        handleClose: handleClose,
        hasCloseButton: true,
        maskClosable: true,
        verticalAlign: "center",
        inlineCss: cssModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCultureReview_style_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCultureReview_style_Title, {
                    children: "조직문화"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContents, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CultureSection_ChartContents, {})
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/style.ts

function CultureSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n  margin: 0 auto;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    CultureSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CultureSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n"
    ]);
    CultureSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ChartContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1ae92a3-0"
})(CultureSection_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CultureSection_style_ButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1ae92a3-1"
})(CultureSection_style_templateObject1());

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/CultureSection/index.tsx
















function CultureSection(param) {
    var isDisplay = param.isDisplay;
    var ref = (0,react.useState)(), isOpenModal = ref[0], setIsOpenModal = ref[1];
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref1 = (0,useMyInfoQuery/* default */.Z)(), isActiveUser = ref1.isActiveUser, userInfo = ref1.data;
    var ref2 = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref2.data;
    var ref3 = (0,useCompanyCultureReview/* default */.Z)(companyHash), data = ref3.data, isLoading = ref3.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ico-emoji-raising-hands@2x.png",
                                alt: "emoji"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "조직문화"
                            })
                        ]
                    }),
                    (userInfo === null || userInfo === void 0 ? void 0 : userInfo.cultureReview) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_RightCardHeaderWrapper, {
                        children: [
                            !isLoading && (data === null || data === void 0 ? void 0 : data.isAllEmpty) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewInfo_style_Tooltip, {
                                animStart: isDisplay,
                                children: [
                                    "기업의 첫 리뷰를 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BreakLineOnlyMobile, {}),
                                    "작성해주세요!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/review/culture?companyHash=".concat(companyHash, "&beforeUrl=/company/").concat(companyHash, "#company-review-chart"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-attribute-id": "company__review__write__click",
                                    "data-is-review-exist": (data === null || data === void 0 ? void 0 : data.isAllEmpty) ? "false" : "true",
                                    "data-is-blur": "false",
                                    "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                                    "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                                    "data-review-type": "culture",
                                    variant: !isLoading && (data === null || data === void 0 ? void 0 : data.isAllEmpty) ? "magenta" : "light",
                                    size: "sm",
                                    leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(style_ButtonWriteWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {
                                            color: !isLoading && (data === null || data === void 0 ? void 0 : data.isAllEmpty) ? Theme/* default.colors.white100 */.Z.colors.white100 : Theme/* default.colors.gray800 */.Z.colors.gray800,
                                            width: 12,
                                            height: 12
                                        })
                                    }),
                                    children: "리뷰 작성"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContents, {
                children: isActiveUser && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.cultureReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CultureSection_ChartContents, {
                            isSummary: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CultureSection_style_ButtonGroup, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore_ButtonMore, {
                                onClick: function() {
                                    return setIsOpenModal(true);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCultureReview, {
                            isOpen: isOpenModal,
                            handleClose: function() {
                                return setIsOpenModal(false);
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartContents_NudgeLoginSection, {})
            })
        ]
    });
}
/* harmony default export */ var ReviewInfo_CultureSection = (CultureSection);

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/hooks.ts


function ReviewInfo_hooks_useDisplayTrigger(ref) {
    var _$ref = (0,react.useState)(), isDisplayed = _$ref[0], setIsDisplayed = _$ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && !isDisplayed) {
            setIsDisplayed(true);
        }
    }, [
        entry,
        isDisplayed
    ]);
    return isDisplayed || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
}

;// CONCATENATED MODULE: ./src/hooks/query/review/useGetCompanySkillList.ts



function useGetCompanySkillList(companyHash) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companySkillList */.Z.companySkillList,
        companyHash
    ], function() {
        return (0,fetch/* fetcher */._)("/api/skill/".concat(companyHash));
    }, {
        enabled: !!companyHash,
        cacheTime: 0
    });
};

// EXTERNAL MODULE: ./src/utils/lodash/isEmpty/index.ts
var isEmpty = __webpack_require__(95129);
;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/SkillSection/SkillLIst/style.ts

function SkillLIst_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 0;\n  width: 360px;\n  margin: 0 auto;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SkillLIst_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SkillLIst_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px;\n\n  ",
        " {\n    padding: 0 20px;\n  }\n"
    ]);
    SkillLIst_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SkillLIst_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  border-radius: 999px;\n  padding: 8px 16px;\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    SkillLIst_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SkillLIst_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  background: ",
        ";\n  border-radius: 999px;\n\n  color: ",
        ";\n  padding: 8px 16px;\n\n  ",
        ";\n"
    ]);
    SkillLIst_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SkillLIst_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11fc0f3c-0"
})(SkillLIst_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ItemList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-11fc0f3c-1"
})(SkillLIst_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-11fc0f3c-2"
})(SkillLIst_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));
var SkillLIst_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11fc0f3c-3"
})(SkillLIst_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray650;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/SkillSection/NudgeLoginSection/style.ts

function SkillSection_NudgeLoginSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 226px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  z-index: 1;\n"
    ]);
    SkillSection_NudgeLoginSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var NudgeLoginSection_style_cssNudgeDialog = (0,styled_components_browser_esm/* css */.iv)(SkillSection_NudgeLoginSection_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/SkillSection/NudgeLoginSection/index.tsx










var data = [
    {
        id: 1,
        name: "????"
    },
    {
        id: 2,
        name: "????"
    },
    {
        id: 3,
        name: "????"
    },
    {
        id: 4,
        name: "????"
    },
    {
        id: 5,
        name: "????"
    },
    {
        id: 6,
        name: "????"
    },
    {
        id: 7,
        name: "????"
    },
    {
        id: 8,
        name: "????"
    },
    {
        id: 9,
        name: "????"
    }, 
];
function NudgeLoginSection_NudgeLoginSection() {
    var router = (0,next_router.useRouter)();
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref.data;
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var handleClick = function() {
        if (isActiveUser) {
            return router.push("/review/skill?companyHash=".concat(companyHash, "&beforeUrl=").concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"));
        }
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkillLIst_style_Wrapper, {
        onClick: handleClick,
        "data-attribute-id": "company__review__write__click",
        "data-is-review-exist": "false",
        "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
        "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
        "data-review-type": "skill",
        "data-is-blur": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NudgeLoginDialog, {
                inlineCss: NudgeLoginSection_style_cssNudgeDialog,
                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        "에서",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "사용하는 기술과 툴이 궁금하다면?"
                    ]
                }),
                buttonText: "리뷰하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemList, {
                children: data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        children: item.name
                    }, item.id);
                })
            })
        ]
    });
}
/* harmony default export */ var SkillSection_NudgeLoginSection = (NudgeLoginSection_NudgeLoginSection);

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/SkillSection/SkillLIst/index.tsx





function SkillList() {
    var ref;
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var data = useGetCompanySkillList(companyHash).data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkillLIst_style_Wrapper, {
        children: (0,isEmpty/* isEmpty */.x)(data === null || data === void 0 ? void 0 : data.skills) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkillLIst_style_NoData, {
            children: "아직 등록된 기술&툴 정보가 없습니다"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemList, {
            children: data === null || data === void 0 ? void 0 : (ref = data.skills) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    children: item.title
                }, item.id);
            })
        })
    });
}
/* harmony default export */ var SkillLIst = (SkillList);

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/SkillSection/index.tsx













function SkillSection(param) {
    var isDisplay = param.isDisplay;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useMyInfoQuery/* default */.Z)(), isActiveUser = ref.isActiveUser, userInfo = ref.data;
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref1.data;
    var ref2 = useGetCompanySkillList(companyHash), copmanySkillInfo = ref2.data, isLoading = ref2.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/hammer.svg",
                                alt: "emoji"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "기술&툴"
                            })
                        ]
                    }),
                    (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userSkill) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_RightCardHeaderWrapper, {
                        children: [
                            !isLoading && (0,isEmpty/* isEmpty */.x)(copmanySkillInfo === null || copmanySkillInfo === void 0 ? void 0 : copmanySkillInfo.skills) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewInfo_style_Tooltip, {
                                animStart: isDisplay,
                                children: [
                                    "기업의 첫 리뷰를 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BreakLineOnlyMobile, {}),
                                    "작성해주세요!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/review/skill?companyHash=".concat(companyHash, "&beforeUrl=/company/").concat(companyHash, "#company-review-chart"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-attribute-id": "company__review__write__click",
                                    "data-is-review-exist": (0,isEmpty/* isEmpty */.x)(copmanySkillInfo === null || copmanySkillInfo === void 0 ? void 0 : copmanySkillInfo.skills) ? "false" : "true",
                                    "data-is-blur": "false",
                                    "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                                    "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                                    "data-review-type": "skill",
                                    variant: !isLoading && (0,isEmpty/* isEmpty */.x)(copmanySkillInfo === null || copmanySkillInfo === void 0 ? void 0 : copmanySkillInfo.skills) ? "magenta" : "light",
                                    size: "sm",
                                    leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(style_ButtonWriteWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {
                                            color: !isLoading && (0,isEmpty/* isEmpty */.x)(copmanySkillInfo === null || copmanySkillInfo === void 0 ? void 0 : copmanySkillInfo.skills) ? theme.colors.white100 : theme.colors.gray800,
                                            width: 12,
                                            height: 12
                                        })
                                    }),
                                    children: "리뷰 작성"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContents, {
                children: isActiveUser && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userSkill) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkillLIst, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SkillSection_NudgeLoginSection, {})
            })
        ]
    });
}
/* harmony default export */ var ReviewInfo_SkillSection = (SkillSection);

// EXTERNAL MODULE: ./src/hooks/query/company/useCompanyReviewWorkLife.ts
var useCompanyReviewWorkLife = __webpack_require__(88061);
;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/style.ts

function WorkLifeSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    WorkLifeSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WorkLifeSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WorkLifeSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WorkLifeSection_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    WorkLifeSection_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WorkLifeSection_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 0 40px;\n\n  position: relative;\n  padding: 40px 0;\n\n  ",
        " {\n    justify-content: space-between;\n    padding-left: 22px;\n    padding-right: 22px;\n  }\n\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    WorkLifeSection_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WorkLifeSection_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 280px;\n  text-align: center;\n\n  ",
        " {\n    flex: 0 0 auto;\n    margin-bottom: 40px;\n    padding: 0 16px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    WorkLifeSection_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WorkLifeSection_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  ",
        ";\n  font-weight: 500;\n"
    ]);
    WorkLifeSection_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var WorkLifeSection_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-0"
})(WorkLifeSection_style_templateObject());
var WorkLifeSection_style_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-1"
})(WorkLifeSection_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B2"));
var WorkLifeSection_style_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-2"
})(WorkLifeSection_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var style_ChartSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-3"
})(WorkLifeSection_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ChartSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-4"
})(WorkLifeSection_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Subject = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66dd2a40-5"
})(WorkLifeSection_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));

// EXTERNAL MODULE: ./src/utils/formatted/string.ts
var string = __webpack_require__(52794);
;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/BarChart/hooks.ts



function hooks_useChartProps(param) {
    var chartData = param.chartData;
    var _Math;
    if (!chartData) {
        return {};
    }
    var maxCount = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(chartData.map(function(obj) {
        return obj.count;
    })));
    var maxYAxis = maxCount * 1.5;
    var data = {
        labels: [
            "거의 없음",
            "주 1-2회",
            "주 3-4회",
            "주 5회 이상"
        ],
        datasets: [
            {
                type: "bar",
                data: chartData,
                backgroundColor: Theme/* default.colors.magenta500 */.Z.colors.magenta500,
                hoverBackgroundColor: Theme/* default.colors.magenta500 */.Z.colors.magenta500,
                borderWidth: 0,
                barThickness: 30,
                borderRadius: 2,
                parsing: {
                    xAxisKey: "count",
                    yAxisKey: "count"
                }
            }, 
        ]
    };
    var options = {
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    font: {
                        weight: "500",
                        lineHeight: "12px",
                        size: "10px",
                        family: "Pretendard"
                    },
                    color: Theme/* default.colors.gray700 */.Z.colors.gray700
                }
            },
            y: {
                max: maxYAxis,
                grid: {
                    drawBorder: false,
                    display: false
                },
                ticks: {
                    display: false
                }
            }
        },
        borderWidth: 1,
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            },
            datalabels: {
                labels: {
                    value: {
                        color: Theme/* default.colors.gray800 */.Z.colors.gray800,
                        align: "end",
                        anchor: "end",
                        font: {
                            weight: "500",
                            size: "10px",
                            family: "Pretendard"
                        },
                        formatter: function(barInfo) {
                            if (chartData.every(function(obj) {
                                return obj.count === 0;
                            })) {
                                return null;
                            }
                            if (!(barInfo === null || barInfo === void 0 ? void 0 : barInfo.count)) {
                                return "00(00%)";
                            }
                            return "".concat(barInfo.count, " (").concat((0,string/* getPercentage */.DU)(barInfo.rate), "%)");
                        }
                    }
                }
            }
        }
    };
    return {
        data: data,
        options: options
    };
}

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/BarChart/style.ts

function WorkLifeSection_ChartContents_BarChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 280px;\n  height: 160px;\n  position: relative;\n  margin: 0 auto;\n"
    ]);
    WorkLifeSection_ChartContents_BarChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WorkLifeSection_ChartContents_BarChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  text-align: center;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WorkLifeSection_ChartContents_BarChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var BarChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3661420-0"
})(WorkLifeSection_ChartContents_BarChart_style_templateObject());
var BarChart_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3661420-1"
})(WorkLifeSection_ChartContents_BarChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/BarChart/index.tsx







chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL);
function WorkLifeSection_ChartContents_BarChart_BarChart(param) {
    var chartData = param.chartData, isEmpty = param.isEmpty;
    var chartDataValues = Object.values(chartData !== null && chartData !== void 0 ? chartData : {});
    var ref = hooks_useChartProps({
        chartData: chartDataValues
    }), data = ref.data, options = ref.options;
    if (!chartData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
                data: data,
                options: options
            }),
            isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(BarChart_style_NoData, {
                children: "등록된 리뷰가 없습니다."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/constants.ts

var PIE_CHART_LABELS_INFO = [
    {
        label: "없음",
        backgroundColor: Theme/* default.colors.greynavy100 */.Z.colors.greynavy100
    },
    {
        label: "가끔",
        backgroundColor: Theme/* default.colors.greynavy300 */.Z.colors.greynavy300
    },
    {
        label: "매번",
        backgroundColor: "#363F84"
    }, 
];

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/hooks.ts

function PieChart_hooks_useChartProps(param) {
    var externalTooltipHandler = param.externalTooltipHandler, chartData = param.chartData;
    if (!chartData) {
        return {};
    }
    var data = {
        labels: PIE_CHART_LABELS_INFO.map(function(obj) {
            return obj.label;
        }),
        radius: 60,
        datasets: [
            {
                data: chartData,
                backgroundColor: PIE_CHART_LABELS_INFO.map(function(obj) {
                    return obj.backgroundColor;
                }),
                hoverBackgroundColor: PIE_CHART_LABELS_INFO.map(function(obj) {
                    return obj.backgroundColor;
                })
            }, 
        ]
    };
    var options = {
        borderWidth: 1,
        parsing: {
            key: "count"
        },
        plugins: {
            tooltip: {
                enabled: false,
                external: externalTooltipHandler
            },
            legend: {
                display: false
            },
            datalabels: {
                display: false
            }
        }
    };
    return {
        data: data,
        options: options
    };
}

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/Legends/style.ts

function PieChart_Legends_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 0 16px;\n  margin: 16px 0;\n"
    ]);
    PieChart_Legends_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PieChart_Legends_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  white-space: nowrap;\n\n  &::before {\n    content: '';\n    display: block;\n    width: 9px;\n    height: 9px;\n    margin-right: 4px;\n    background-color: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    PieChart_Legends_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PieChart_Legends_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0f024d5-0"
})(PieChart_Legends_style_templateObject());
var Legends_style_Legend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0f024d5-1"
})(PieChart_Legends_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
}, (0,helper/* getFontStyle */.p)("midium120_C1"));

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/Legends/index.tsx



function Legends_Legends(param) {
    var onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PieChart_Legends_style_Wrapper, {
        children: PIE_CHART_LABELS_INFO.map(function(obj, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Legends_style_Legend, {
                backgroundColor: obj.backgroundColor,
                onMouseEnter: function() {
                    if (onMouseEnter) {
                        onMouseEnter(index);
                    }
                },
                onMouseLeave: function() {
                    if (onMouseLeave) {
                        onMouseLeave(index);
                    }
                },
                children: obj.label
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/style.ts

function PieChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PieChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PieChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 120px;\n  height: 120px;\n  text-align: center;\n  margin: 0 auto;\n"
    ]);
    PieChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PieChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 280px;\n  height: 160px;\n  position: relative;\n  margin: 0 auto;\n"
    ]);
    PieChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PieChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 20px;\n  background: ",
        ";\n  border-radius: 50%;\n\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    PieChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PieChart_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  text-align: center;\n  color: ",
        ";\n  ",
        ";\n\n  ",
        " {\n    top: 90px;\n    transform: translate3d(-50%, 0, 0);\n  }\n"
    ]);
    PieChart_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var PieChart_style_ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d5db7f-0"
})(PieChart_style_templateObject());
var PieWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d5db7f-1"
})(PieChart_style_templateObject1());
var EmptyChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d5db7f-2"
})(PieChart_style_templateObject2());
var DummyPieChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d5db7f-3"
})(PieChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var PieChart_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d5db7f-4"
})(PieChart_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, (0,helper/* getFontStyle */.p)("midium150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/TooltipWeekendWork/style.ts

function TooltipWeekendWork_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: ",
        ";\n    left: ",
        "px;\n    top: ",
        "px;\n  "
    ]);
    TooltipWeekendWork_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipWeekendWork_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: inline-block;\n  padding: 3px 4px 2px;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 4px;\n  color: #fff;\n  white-space: nowrap;\n  pointer-events: none;\n  transition: left 0.3s, top 0.3s;\n  ",
        ";\n\n  ",
        "\n"
    ]);
    TooltipWeekendWork_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var TooltipWeekendWork_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89d8b00c-0"
})(TooltipWeekendWork_style_templateObject1(), (0,helper/* getFontStyle */.p)("midium120_C1"), function(param) {
    var $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return (0,styled_components_browser_esm/* css */.iv)(TooltipWeekendWork_style_templateObject(), $opacity, $x, $y);
});

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/TooltipWeekendWork/index.tsx


function TooltipWeekendWork(param) {
    var $x = param.$x, $y = param.$y, $opacity = param.$opacity, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWeekendWork_style_Wrapper, {
        $x: $x,
        $y: $y,
        $opacity: $opacity,
        children: message
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/PieChart/index.tsx














chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* ArcElement */.qi);
function PieChart(param) {
    var chartData = param.chartData, isEmpty = param.isEmpty;
    var chartDataValues = Object.values(chartData !== null && chartData !== void 0 ? chartData : {});
    var ref = (0,react.useState)({
        $x: 0,
        $y: 0,
        $opacity: 0,
        message: ""
    }), tooltipProps = ref[0], setTooltipProps = ref[1];
    var chartInstance = (0,react.useRef)(null);
    var ref1 = PieChart_hooks_useChartProps({
        chartData: chartDataValues,
        externalTooltipHandler: function(ctx) {
            var _dataPoints = (0,_sliced_to_array/* default */.Z)(ctx.tooltip.dataPoints, 1), pointInfo = _dataPoints[0];
            var newTooltipProps = {
                $x: ctx.tooltip.caretX,
                $y: ctx.tooltip.caretY,
                $opacity: ctx.tooltip.opacity,
                message: "".concat(pointInfo.label, ": ").concat(pointInfo.raw.count, " (").concat((0,string/* getPercentage */.DU)(pointInfo.raw.rate), "%)")
            };
            if (!(0,isEqual/* isEqual */.X)(newTooltipProps, tooltipProps)) {
                setTooltipProps(newTooltipProps);
            }
        },
        setTooltipProps: setTooltipProps
    }), data = ref1.data, options = ref1.options;
    var handleMouseEnterLegend = function(index) {
        if (chartInstance.current) {
            var activeElement = {
                datasetIndex: 0,
                index: index
            };
            var tooltip = chartInstance.current.tooltip;
            chartInstance.current.setActiveElements([
                activeElement
            ]);
            tooltip.setActiveElements([
                activeElement
            ], []);
            chartInstance.current.update();
        }
    };
    var handleMouseLeaveLegend = function(index) {
        if (chartInstance.current) {
            var tooltip = chartInstance.current.tooltip;
            chartInstance.current.setActiveElements([]);
            tooltip.setActiveElements([], []);
        }
    };
    if (!chartData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PieChart_style_ChartWrapper, {
        children: isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyChartWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyPieChart, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PieChart_style_NoData, {
                    children: "등록된 리뷰가 없습니다."
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Legends_Legends, {
                    onMouseEnter: handleMouseEnterLegend,
                    onMouseLeave: handleMouseLeaveLegend
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Pie */.by, {
                            ref: chartInstance,
                            data: data,
                            options: options
                        }),
                        tooltipProps.$opacity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWeekendWork, (0,src_object_spread/* default */.Z)({}, tooltipProps))
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/ChartContents/index.tsx






function WorkLifeSection_ChartContents_ChartContents() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyReviewWorkLife/* default */.Z)(companyId), chartData = ref.data, isEmptyOvertime = ref.isEmptyOvertime, isEmptyWeekend = ref.isEmptyWeekend;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_ChartSectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subject, {
                        children: "야근은 일주일에 몇 번 하시나요?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkLifeSection_ChartContents_BarChart_BarChart, {
                        chartData: chartData === null || chartData === void 0 ? void 0 : chartData.overtime,
                        isEmpty: isEmptyOvertime
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subject, {
                        children: "주말이나 휴일에 출근 하시나요?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PieChart, {
                        chartData: chartData === null || chartData === void 0 ? void 0 : chartData.weekend,
                        isEmpty: isEmptyWeekend
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/NudgeLoginSection/style.ts

function WorkLifeSection_NudgeLoginSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 226px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"
    ]);
    WorkLifeSection_NudgeLoginSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var WorkLifeSection_NudgeLoginSection_style_cssNudgeDialog = (0,styled_components_browser_esm/* css */.iv)(WorkLifeSection_NudgeLoginSection_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/NudgeLoginSection/index.tsx










function WorkLifeSection_NudgeLoginSection_NudgeLoginSection(param) {
    var isActiveUser = param.isActiveUser;
    var router = (0,next_router.useRouter)();
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref.data;
    var isEmpty = (0,useCompanyReviewWorkLife/* default */.Z)(companyId).isEmpty;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var handleClick = function() {
        if (!isActiveUser) {
            moveOneIdPage({
                beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"),
                messageKey: "kreditjob_company_bookmark_title"
            });
        } else {
            router.push("/review/work-life-balance?companyHash=".concat(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH, "&beforeUrl=").concat(env/* WEB_URL */.h$).concat(router.asPath, "#company-review-chart"));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_ChartSectionWrapper, {
        onClick: handleClick,
        style: {
            cursor: "pointer"
        },
        "data-attribute-id": "company__review__write__click",
        "data-is-review-exist": isEmpty ? "false" : "true",
        "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
        "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
        "data-review-type": "work-life-balance",
        "data-is-blur": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NudgeLoginDialog, {
                inlineCss: WorkLifeSection_NudgeLoginSection_style_cssNudgeDialog,
                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                        "의",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "워라밸이 궁금하다면?"
                    ]
                }),
                buttonText: "리뷰하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-barchart.webm"),
                            type: "video/webm"
                        }, "/images/video-chart-review-barchart.webm"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-barchart.mp4"),
                            type: "video/mp4"
                        }, "/images/video-chart-review-barchart.mp4")
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-piechart.webm"),
                            type: "video/webm"
                        }, "/images/video-chart-review-piechart.webm"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(env/* STATIC_ADDRESS */.LV, "/images/video-chart-review-piechart.mp4"),
                            type: "video/mp4"
                        }, "/images/video-chart-review-piechart.mp4")
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/WorkLifeSection/index.tsx












function WorkLifeSection(param) {
    var isDisplay = param.isDisplay;
    var ref = (0,useMyInfoQuery/* default */.Z)(), isActiveUser = ref.isActiveUser, data = ref.data;
    var companyHash = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyHash), companyInfo = ref1.data;
    var ref2 = (0,useCompanyReviewWorkLife/* default */.Z)(companyHash), isEmpty = ref2.isEmpty, isLoading = ref2.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ico-emoji-balance-scale@2x.png",
                                alt: "emoji"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "워라밸"
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.workLifeReview) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_RightCardHeaderWrapper, {
                        children: [
                            !isLoading && isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewInfo_style_Tooltip, {
                                animStart: isDisplay,
                                children: [
                                    "기업의 첫 리뷰를 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BreakLineOnlyMobile, {}),
                                    "작성해주세요!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/review/work-life-balance?companyHash=".concat(companyHash, "&beforeUrl=/company/").concat(companyHash, "#company-review-chart"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-attribute-id": "company__review__write__click",
                                    "data-is-review-exist": isEmpty ? "false" : "true",
                                    "data-is-blur": "false",
                                    "data-company-hash": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                                    "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                                    "data-review-type": "work-life-balance",
                                    variant: !isLoading && isEmpty ? "magenta" : "light",
                                    size: "sm",
                                    as: "a",
                                    leading: /*#__PURE__*/ (0,jsx_runtime.jsx)(style_ButtonWriteWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {
                                            color: !isLoading && isEmpty ? Theme/* default.colors.white100 */.Z.colors.white100 : Theme/* default.colors.gray800 */.Z.colors.gray800,
                                            width: 12,
                                            height: 12
                                        })
                                    }),
                                    children: "리뷰 작성"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContents, {
                children: isActiveUser && (data === null || data === void 0 ? void 0 : data.workLifeReview) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkLifeSection_ChartContents_ChartContents, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkLifeSection_NudgeLoginSection_NudgeLoginSection, {
                    isActiveUser: isActiveUser
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/ReviewInfo/index.tsx











function ReviewInfo(param) {
    var registerRef = param.registerRef;
    var router = (0,next_router.useRouter)();
    var wrapperRef = (0,react.useRef)(null);
    var isDisplay = ReviewInfo_hooks_useDisplayTrigger(wrapperRef);
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (wrapperRef.current && hash === "company-review-chart" && isServer/* isClient */.C) {
            router.replace(path);
            wrapperRef.current.scrollIntoView();
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, {
        title: "다녀본 리뷰",
        sectionId: "company-review",
        registerRef: registerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewInfo_style_Contents, {
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkLifeSection, {
                    isDisplay: isDisplay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewInfo_CultureSection, {
                    isDisplay: isDisplay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewInfo_SkillSection, {
                    isDisplay: isDisplay
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/utils/common/uuid/index.tsx
var uuid = __webpack_require__(38039);
;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryBarGraph/index.tsx



function SalaryBarGraph_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 10px;\n  margin: 0 auto;\n\n  width: 100%;\n\n  canvas {\n    width: 100%;\n    height: 160px;\n  }\n\n  ",
        " {\n    width: 100%;\n\n    canvas {\n      width: 100% !important;\n      height: 160px !important;\n    }\n  }\n"
    ]);
    SalaryBarGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL, chart/* Legend */.De);
function BarGraph(param) {
    var values = param.values, labels = param.labels;
    var ref = GraphCalcurationData({
        labels: labels,
        values: values
    }), data = ref.data, options = ref.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BarGraphWrapper, {
        id: (0,uuid/* generateUUID */.D)(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
            data: data,
            options: options
        })
    });
}
/* harmony default export */ var SalaryBarGraph = (/*#__PURE__*/(0,react.memo)(BarGraph));
function GraphCalcurationData(param) {
    var values = param.values, labels = param.labels;
    var _Math;
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var graphLabel = function() {
        // 산업군이 기타인 경우 OR  산업군이 1000개 미만인 경우 [업체 연봉, 전체 평균 연봉] 2가지 그래프만 노출
        if (labels[1] === "") {
            return [
                labels[0],
                labels[2]
            ];
        }
        return labels;
    };
    var graphData = function() {
        var formattedData = values.map(function(value) {
            return (0,formatted_number/* millionFormattedDeletedComma */.nq)(value);
        });
        if (values[0] === 0) {
            // 선택한 기업에 연봉값이 없을경우 전체 평균(배열에 2번째 인덱스 즉)과 동일한 값으로 설정
            // 위 조건에 해당되면서 산업군이 기타인 경우 OR 산업군이 1000개 미만인 경우
            if (values[1] === 0 || labels[1].length === 0) {
                return {
                    data: [
                        formattedData[2],
                        formattedData[2]
                    ],
                    customData: [
                        "?",
                        formattedData[2]
                    ]
                };
            }
            return {
                data: [
                    formattedData[2],
                    formattedData[1],
                    formattedData[2]
                ],
                customData: [
                    "?",
                    formattedData[1],
                    formattedData[2]
                ]
            };
        }
        // 산업군이 기타인 경우 OR  산업군이 1000개 미만인 경우 [업체 연봉, 전체 평균 연봉] 2가지 그래프만 노출
        if (values[1] === 0 || labels[1].length === 0) {
            return {
                data: [
                    formattedData[0],
                    formattedData[2]
                ],
                customData: [
                    formattedData[0],
                    formattedData[2]
                ]
            };
        }
        return {
            data: formattedData,
            customData: formattedData
        };
    };
    var maxGraphHegiht = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(graphData().data.map(function(str) {
        return Number(str);
    }))) * 2;
    var options = {
        maintainAspectRatio: false,
        devicePixelRatio: 2,
        animation: {
            duration: 0
        },
        interaction: {
            intersect: false,
            mode: "index"
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            },
            datalabels: {
                labels: {
                    value: {
                        color: theme.colors.gray800,
                        align: "end",
                        anchor: "end",
                        font: {
                            weight: "500",
                            lineHeight: "12px",
                            size: "10px",
                            family: "Pretendard"
                        },
                        formatter: function(value, ctx) {
                            var datasets = ctx.dataset;
                            if (datasets.customData !== datasets.data) {
                                var label = datasets.customData[ctx.dataIndex];
                                // 연봉 데이터가 수집중일때는 "?"
                                if (label === "?") return datasets.customData[ctx.dataIndex];
                                return (0,formatted_number/* formattedMoney */.gR)(datasets.customData[ctx.dataIndex]);
                            }
                            return Math.round(value).toLocaleString();
                        }
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    font: {
                        weight: "500",
                        lineHeight: "12px",
                        size: "10px",
                        family: "Pretendard"
                    },
                    color: theme.colors.gray700
                }
            },
            y: {
                grid: {
                    drawBorder: false,
                    display: false
                },
                ticks: {
                    display: false
                },
                max: isNaN(Number(graphData().data[0]) * 2) ? 0 : maxGraphHegiht
            }
        }
    };
    var data = {
        labels: graphLabel(),
        datasets: [
            (0,src_object_spread/* default */.Z)({
                backgroundColor: [
                    theme.colors.magenta700,
                    theme.colors.gray400,
                    theme.colors.gray400
                ],
                borderColor: [
                    theme.colors.magenta700,
                    theme.colors.gray400,
                    theme.colors.gray400
                ],
                borderWidth: 1,
                barThickness: isDesktop ? 30 : 35,
                borderRadius: 3
            }, graphData()), 
        ]
    };
    return {
        data: data,
        options: options
    };
}
var BarGraphWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e91793eb-0"
})(SalaryBarGraph_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/style.ts

function SalaryInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    gap: 16px;\n    grid-template-columns: 1fr 1fr;\n    scroll-margin-top: 130px;\n\n    min-height: 280px;\n    margin-top: 30px;\n\n    ",
        " {\n      grid-template-columns: auto;\n      gap: 0;\n    }\n  "
    ]);
    SalaryInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 32px;\n    color: ",
        ";\n    padding-top: 20px;\n    padding-bottom: 10px;\n  "
    ]);
    SalaryInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n  "
    ]);
    SalaryInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: bold;\n  "
    ]);
    SalaryInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    border-radius: 4px;\n    padding: 20px;\n    margin-top: 30px;\n\n    color: ",
        ";\n    ",
        ";\n    text-align: center;\n\n    span {\n      color: ",
        ";\n    }\n\n    ",
        " {\n      padding: 20px 63px;\n      word-break: keep-all;\n    }\n  "
    ]);
    SalaryInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    list-style: none;\n\n    ",
        " {\n      &:first-child {\n        margin-bottom: 30px;\n      }\n    }\n  "
    ]);
    SalaryInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 32px;\n    box-sizing: border-box;\n    border: 1px solid rgb(235, 235, 235);\n    border-radius: 4px;\n    padding-left: ",
        ";\n    text-align: center;\n\n    ",
        " {\n      width: 100%;\n      max-width: none;\n      position: relative;\n      padding: 30px 20px;\n      padding-left: ",
        ";\n    }\n  "
    ]);
    SalaryInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 30px;\n  "
    ]);
    SalaryInfo_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 30px;\n  "
    ]);
    SalaryInfo_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n  "
    ]);
    SalaryInfo_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    padding: 40px 0;\n\n    ",
        " {\n      padding: 20px;\n    }\n  "
    ]);
    SalaryInfo_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SalaryInfo_style_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    margin-left: 5px;\n  "
    ]);
    SalaryInfo_style_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var SalaryInfo_style_S = {
    SalaryGrpahWrapper: styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
        componentId: "sc-979b9881-0"
    })(SalaryInfo_style_templateObject(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Title: styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
        componentId: "sc-979b9881-1"
    })(SalaryInfo_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.gray900;
    }),
    SubTitle: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-979b9881-2"
    })(SalaryInfo_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.gray700;
    }),
    PointTitle: styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
        componentId: "sc-979b9881-3"
    })(SalaryInfo_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    }),
    Summary: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-4"
    })(SalaryInfo_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.gray200;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.gray900;
    }, (0,helper/* getFontStyle */.p)("midium120_B2"), function(param) {
        var theme = param.theme;
        return theme.colors.blue500;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    SalaryGraph: styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
        componentId: "sc-979b9881-5"
    })(SalaryInfo_style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    GraphCard: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-6"
    })(SalaryInfo_style_templateObject6(), function(props) {
        return props.paddingLeft;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, function(props) {
        return props.paddingLeft;
    }),
    ButtonWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-7"
    })(SalaryInfo_style_templateObject7()),
    SalaryChartContainer: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-8"
    })(SalaryInfo_style_templateObject8()),
    cssTitleBullet: (0,styled_components_browser_esm/* css */.iv)(SalaryInfo_style_templateObject9()),
    SalaryGreyBox: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-9"
    })(SalaryInfo_style_templateObject10(), function(param) {
        var theme = param.theme;
        return theme.colors.gray400;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    TooltipWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-979b9881-10"
    })(SalaryInfo_style_templateObject11())
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/EmptySalary/index.tsx



function EmptySalary(param) {
    var labels = param.labels, values = param.values;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.GraphCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.Title, {
                children: "수집 중.."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.SubTitle, {
                typography: "midium150_C1",
                children: "다른 출처를 선택해보세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryBarGraph, {
                labels: labels,
                values: values
            })
        ]
    });
}
/* harmony default export */ var SalaryInfo_EmptySalary = (EmptySalary);

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/Salary/index.tsx












function Salary(param) {
    var data = param.data, companyName = param.companyName;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.SalaryGrpahWrapper, {
        children: data.map(function(salary) {
            var isSalaryEmpty = Number(salary === null || salary === void 0 ? void 0 : salary.salary) === 0;
            var rate = (0,company/* getSalaryRate */.k3)(salary.rateType === "TOTAL" ? salary.totalRate : salary.industryRate);
            var values = [
                Number(salary.salary),
                Number(salary.industry),
                Number(salary.total)
            ];
            var labels = [
                (0,string/* textEllipsis */.vS)(typeof companyName === "string" ? companyName : "", 5),
                values[1] > 0 && salary.rateType === "INDUSTRY" ? "업계 평균" : "",
                "전체 평균", 
            ];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.SalaryGraph, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySectionTitle, {
                        children: [
                            salary.category === "ALL" ? "전체 평균연봉" : "올해 입사자 평균연봉",
                            salary.category === "HIRED" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                tooltipText: "당해년도에 입사한 신입/경력직을 모두 포함한<br/>평균 연봉입니다. 국민연금은 추정값을 제공하며,<br/>금감원에 대해서는 해당 정보를 제공하지 않습니다.",
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    }),
                    isSalaryEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_EmptySalary, {
                        values: values,
                        labels: labels
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.GraphCard, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.Title, {
                                children: "".concat((0,formatted_number/* millionFormattedtoString */.X6)(salary.salary), "만원")
                            }),
                            rate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.SubTitle, {
                                typography: "midium150_C1",
                                children: [
                                    salary.rateType === "INDUSTRY" ? "동종업계" : "전체",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.PointTitle, {
                                        children: [
                                            " 연봉상위 ".concat(rate),
                                            "%"
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryBarGraph, {
                                labels: labels,
                                values: values
                            })
                        ]
                    })
                ]
            }, (0,uuid/* generateUUID */.D)());
        })
    });
}
/* harmony default export */ var SalaryInfo_Salary = (Salary);

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalarySummary/index.tsx




function SalarySummary(param) {
    var salary = param.salary;
    var salaryType = (0,react.useMemo)(function() {
        return (0,company/* getSalaryType */.PN)(salary);
    }, [
        salary
    ]);
    var rankingGroup = (0,company/* getRankingGroup */.lN)(salaryType.salaryRate);
    if (!(0,company/* getRankingGroup */.lN)(salaryType.salaryRate) || !salary.salary || !rankingGroup) {
        return null;
    }
    var text = "연봉 규모가 ".concat(salary.rateType === "INDUSTRY" ? "동종업계" : "전체", "에서 <span>").concat(company/* RankingGroupText */.MT[rankingGroup], "</span>인 기업이에요");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.Summary, {
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}
/* harmony default export */ var SalaryInfo_SalarySummary = (SalarySummary);

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanySuggestion.ts



var useCompanySuggestion_getUrl = function(id) {
    return "/api/company/".concat(id, "/suggestion");
};
function useCompanySuggestion(id) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companySuggestion */.Z.companySuggestion,
        id
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanySuggestion_getUrl(id));
    }, {
        enabled: !!id
    });
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SuggestionCompany/index.tsx

function SuggestionCompany_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 30px;\n  ",
        " {\n  }\n"
    ]);
    SuggestionCompany_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestionCompany_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  flex-wrap: wrap;\n  gap: 15px;\n  grid-template-columns: 1fr 1fr;\n\n  ",
        " {\n    grid-template-columns: auto;\n  }\n"
    ]);
    SuggestionCompany_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuggestionCompany_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 50%;\n  padding: 10px 16px;\n  border: 1px solid ",
        ";\n\n  ",
        " {\n    flex: 0 0 100%;\n  }\n"
    ]);
    SuggestionCompany_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function SuggestionCompany() {
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = useCompanySuggestion(companyId), data = ref.data, status = ref.status;
    if (status !== "success" || !data) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestionCompany_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySectionTitle, {
                children: "동종업계 최근 조회 기업"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionCompany_CardContainer, {
                children: data === null || data === void 0 ? void 0 : data.map(function(company) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoCard/* default */.Z, {
                        companyId: company.id,
                        location: company.location,
                        locationCode: company.locationCode,
                        companyName: company.name,
                        PK_NM_HASH: company.PK_NM_HASH,
                        href: "/company/".concat(company.PK_NM_HASH),
                        salary: company.salary,
                        inlineCss: SuggestionCompany_cssCard,
                        "data-attribute-id": "company__search__click",
                        "data-search-value": company.name,
                        "data-search-type": "동종업계 최근 조회 기업"
                    }, "suggestion-".concat(company.id));
                })
            })
        ]
    });
};
var SuggestionCompany_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db9ea001-0"
})(SuggestionCompany_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var SuggestionCompany_CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-db9ea001-1"
})(SuggestionCompany_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var SuggestionCompany_cssCard = (0,styled_components_browser_esm/* css */.iv)(SuggestionCompany_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyWikiChart.ts






var useCompanyWikiChart_url = function(companyId) {
    return "/api/company/".concat(companyId, "/salariesByCategories");
};
function useGetWikiSalaryChart(companyId, isSalaryBlocked, selectSource) {
    var query = (0,index_production.useQuery)([
        queryKeys/* default.companyWikiSalary */.Z.companyWikiSalary,
        companyId
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanyWikiChart_url(companyId));
    }, {
        enabled: !isSalaryBlocked
    });
    var transformedWitkSalary = transformWikiSalary(selectSource, query === null || query === void 0 ? void 0 : query.data);
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, query), {
        transformedWitkSalary: transformedWitkSalary
    });
};
function transformWikiSalary(selectSource, data) {
    if (!data) {
        return [];
    }
    var juniorKey = [
        "HIGHSCHOOL",
        "COLLEGE",
        "UNIVERSITY",
        "MASTER"
    ];
    var seniorKey = [
        "JIDR",
        "GJ",
        "CJ",
        "BJ"
    ];
    return [
        juniorKey,
        seniorKey
    ].map(function(keys) {
        return keys.map(function(key) {
            var ref;
            var avg = (ref = data[key][selectSource === "기업 제공" ? "CORP" : "avg"]) !== null && ref !== void 0 ? ref : 0;
            var count = data[key]._cnt;
            var _min, _max;
            return {
                title: WIKI_CATEGORY_TITLE[key],
                data: avg,
                stakeData: {
                    min: (_min = data[key].min) !== null && _min !== void 0 ? _min : 0,
                    max: (_max = data[key].max) !== null && _max !== void 0 ? _max : 0
                },
                showData: {
                    avg: avg >= 10000 ? 10000 : avg,
                    min: data[key].min >= 10000 ? 10000 : data[key].min,
                    max: data[key].max >= 10000 ? 10000 : data[key].max,
                    count: count
                },
                isDataEmpty: !Boolean(avg) && (count === 1 || !Boolean(count))
            };
        });
    });
}

// EXTERNAL MODULE: ./src/features/company/SalaryInfo/hooks.ts
var hooks = __webpack_require__(74203);
;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/ModalNav/style.ts

function ModalNav_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 32px;\n  margin-bottom: 30px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  overflow: hidden;\n"
    ]);
    ModalNav_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalNav_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      a,\n      span {\n        background-color: ",
        ";\n        color: ",
        ";\n\n        &:active,\n        &:hover,\n        &:link,\n        &:visited {\n          color: ",
        ";\n        }\n      }\n\n      &::after {\n        display: none;\n      }\n    "
    ]);
    ModalNav_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalNav_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  list-style: none;\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translate3d(0, -50%, 0);\n    width: 1px;\n    height: 12px;\n    background-color: ",
        ";\n  }\n\n  &:last-child {\n    &::after {\n      display: none;\n    }\n  }\n\n  a,\n  span {\n    display: block;\n    width: 100%;\n    height: 32px;\n    text-align: center;\n    padding-top: 7px;\n    background-color: #fff;\n    padding: 0;\n    border: none;\n    color: ",
        ";\n    ",
        "\n    line-height: 30px;\n\n    &:active,\n    &:hover,\n    &:link,\n    &:visited {\n      color: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    ModalNav_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ModalNav_style_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-d56bf5e6-0"
})(ModalNav_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var ModalNav_style_Menu = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-d56bf5e6-1"
})(ModalNav_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(ModalNav_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.white100;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.white100;
    });
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/ModalNav/index.tsx




function ModalNav(param) {
    var navData = param.navData, activeValue = param.activeValue, onClick = param.onClick, dataAttributes = param.dataAttributes;
    var handleClick = function(nav) {
        if (onClick) {
            onClick(nav);
        }
    };
    if (!navData) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalNav_style_Wrapper, {
        children: navData.map(function(nav, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalNav_style_Menu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                isActive: activeValue === nav.value,
                onClick: function() {
                    return handleClick(nav);
                }
            }, dataAttributes[index]), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: nav.label
                })
            }), index);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/SalariesByCorp/style.ts

function SalariesByCorp_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 15px;\n  padding: 20px 0;\n  border: 1px solid ",
        ";\n  text-align: center;\n  border-radius: 4px;\n"
    ]);
    SalariesByCorp_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalariesByCorp_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 14px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    SalariesByCorp_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var SalariesByCorp_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-331055-0"
})(SalariesByCorp_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var style_Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-331055-1"
})(SalariesByCorp_style_templateObject1());

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/SalariesByCorp/index.tsx




function SalariesByCorp(param) {
    var corpSalary = param.corpSalary, mlSalary = param.mlSalary, companySource = param.companySource;
    if (!mlSalary && !corpSalary && companySource !== "기업 제공") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesByCorp_style_Wrapper, {
            children: [
                companySource === "기업 제공" && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                        typography: "bold120_B3",
                        children: [
                            "기업 제공 ",
                            corpSalary ? "".concat((0,formatted_number/* formattedMoney */.gR)(corpSalary), "만원") : "정보없음"
                        ]
                    })
                }),
                mlSalary && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                        typography: "bold120_B3",
                        children: [
                            "머신러닝 추정 ",
                            (0,formatted_number/* formattedMoney */.gR)(mlSalary),
                            "만원"
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/Summary/style.ts

function Summary_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0 60px;\n  margin-bottom: 30px;\n  background: ",
        ";\n  border-radius: 4px;\n"
    ]);
    Summary_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Summary_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    Summary_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Summary_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de521222-0"
})(Summary_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
});
var style_Salary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de521222-1"
})(Summary_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_H5"));

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/Summary/index.tsx




function Summary_Summary(param) {
    var label = param.label, salary = param.salary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                typography: "bold120_B3",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Salary, {
                children: salary ? "".concat((0,formatted_number/* formattedMoney */.gR)(salary), "만원") : "정보없음"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/TrashCan.tsx


function TrashCan(param) {
    var color = param.color;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "16",
        viewBox: "0 0 12 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.999837 13.8333C0.999837 14.75 1.74984 15.5 2.6665 15.5H9.33317C10.2498 15.5 10.9998 14.75 10.9998 13.8333V5.5C10.9998 4.58333 10.2498 3.83333 9.33317 3.83333H2.6665C1.74984 3.83333 0.999837 4.58333 0.999837 5.5V13.8333ZM3.6415 7.30833C3.9665 6.98333 4.4915 6.98333 4.8165 7.30833L5.99984 8.49167L7.18317 7.30833C7.50817 6.98333 8.03317 6.98333 8.35817 7.30833C8.68317 7.63333 8.68317 8.15833 8.35817 8.48333L7.17484 9.66667L8.35817 10.85C8.68317 11.175 8.68317 11.7 8.35817 12.025C8.03317 12.35 7.50817 12.35 7.18317 12.025L5.99984 10.8417L4.8165 12.025C4.4915 12.35 3.9665 12.35 3.6415 12.025C3.3165 11.7 3.3165 11.175 3.6415 10.85L4.82484 9.66667L3.6415 8.48333C3.3165 8.16667 3.3165 7.63333 3.6415 7.30833ZM8.9165 1.33333L8.32484 0.741667C8.17484 0.591667 7.95817 0.5 7.7415 0.5H4.25817C4.0415 0.5 3.82484 0.591667 3.67484 0.741667L3.08317 1.33333H0.999837C0.541504 1.33333 0.166504 1.70833 0.166504 2.16667C0.166504 2.625 0.541504 3 0.999837 3H10.9998C11.4582 3 11.8332 2.625 11.8332 2.16667C11.8332 1.70833 11.4582 1.33333 10.9998 1.33333H8.9165Z",
            fill: color || theme.colors.yellow500
        })
    });
};

;// CONCATENATED MODULE: ./src/hooks/query/company/useWikiSalaryDelete.ts


function useWikiSalaryDeleteMutation() {
    return (0,index_production.useMutation)(function(param) {
        var wikiId = param.wikiId;
        return (0,client/* del */.IV)("/api/hq/wiki/".concat(wikiId), {});
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/hooks/query/company/useWikiSalaryList.ts






var useWikiSalaryList_getUrl = function(companyId, category, offset, limit) {
    return "/api/company/".concat(companyId, "/salariesWiki?category=").concat(category, "&offset=").concat(offset, "&limit=").concat(limit);
};
function useWikiSalaryList(companyId, categoty) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    return (0,index_production.useInfiniteQuery)([
        queryKeys/* default.wikiSalaryList */.Z.wikiSalaryList,
        companyId,
        categoty
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var pageParam, offset, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pageParam = param.pageParam;
                        offset = !pageParam ? 0 : pageParam * limit;
                        _ctx.next = 4;
                        return (0,fetch/* fetcher */._)(useWikiSalaryList_getUrl(companyId, categoty, offset, limit));
                    case 4:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", (0,src_object_spread/* default */.Z)({}, data));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        enabled: !!companyId,
        staleTime: 60000,
        getNextPageParam: function(nextData, pages) {
            return nextData.rows.length === limit ? pages.length : undefined;
        }
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/WikiSalaryList/hooks.ts

function useInfiniteLoadingDetector(param) {
    var ref = param.ref, _options = param.options, options = _options === void 0 ? {} : _options;
    var ref1 = (0,react.useState)(), isVisible = ref1[0], setVisible = ref1[1];
    (0,react.useEffect)(function() {
        var observer;
        if (ref && ref.current) {
            observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setVisible(true);
                    } else {
                        setVisible(false);
                    }
                });
            }, options);
            observer.observe(ref.current);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        ref
    ]);
    return isVisible;
}
function useGetUserInfo(type, userName, career) {
    if (type === "신입") {
        return "신입 ".concat(userName, "님");
    }
    if (career > 10) {
        return "경력 10년 초과 ".concat(userName, "님");
    }
    return "경력 ".concat(career, "년 ").concat(userName, "님");
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/WikiSalaryList/style.ts

function WikiSalaryList_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  overflow: auto;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    WikiSalaryList_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  min-height: 60px;\n  list-style: none;\n  padding: 12px 20px;\n  border-top: 1px solid ",
        ";\n\n  &:first-child {\n    border-top-width: 0;\n  }\n"
    ]);
    WikiSalaryList_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  list-style: none;\n"
    ]);
    WikiSalaryList_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WikiSalaryList_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WikiSalaryList_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WikiSalaryList_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n"
    ]);
    WikiSalaryList_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    WikiSalaryList_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function WikiSalaryList_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 36px;\n  background: none;\n  border-width: 0;\n  padding: 0;\n  text-align: right;\n"
    ]);
    WikiSalaryList_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var WikiSalaryList_style_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-a01b2e56-0"
})(WikiSalaryList_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var WikiSalaryList_style_Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-a01b2e56-1"
})(WikiSalaryList_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var EntryPoint = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-a01b2e56-2"
})(WikiSalaryList_style_templateObject2());
var UserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a01b2e56-3"
})(WikiSalaryList_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));
var Year = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a01b2e56-4"
})(WikiSalaryList_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_C1"));
var WikiSalaryList_style_Salary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a01b2e56-5"
})(WikiSalaryList_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B3"));
var style_InfoWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-a01b2e56-6"
})(WikiSalaryList_style_templateObject6());
var WikiSalaryList_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a01b2e56-7"
})(WikiSalaryList_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_B3"));
var ButtonDelete = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a01b2e56-8"
})(WikiSalaryList_style_templateObject8());

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/components/WikiSalaryList/index.tsx










function WikiSalaryList(param) {
    var prefix = param.prefix, category = param.category, companyId = param.companyId;
    var ref = useWikiSalaryList(companyId, category), data = ref.data, status = ref.status, refetch = ref.refetch, fetchNextPage = ref.fetchNextPage, hasNextPage = ref.hasNextPage;
    var triggerRef = (0,react.useRef)(null);
    var isVisible = useInfiniteLoadingDetector({
        ref: triggerRef
    });
    (0,react.useEffect)(function() {
        if (isVisible && hasNextPage && status !== "loading") {
            fetchNextPage();
        }
    }, [
        isVisible,
        status,
        category
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WikiSalaryList_style_Wrapper, {
        children: [
            status === "loading" && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_InfoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
            }),
            data === null || data === void 0 ? void 0 : data.pages.map(function(group, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: group.count === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style_InfoWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiSalaryList_style_NoData, {
                            children: "연봉 제보 후 내 연봉랭킹 알아보기!"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: group.rows.map(function(wikiSalary) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiSalariItem, {
                                wikiId: wikiSalary.id,
                                career: wikiSalary.career,
                                userName: wikiSalary.userName,
                                year: wikiSalary.year,
                                salary: wikiSalary.salary,
                                prefix: prefix,
                                onDelete: function() {
                                    return refetch();
                                }
                            }, "wiki-".concat(wikiSalary.id));
                        })
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryPoint, {
                ref: triggerRef
            })
        ]
    });
};
function WikiSalariItem(param) {
    var wikiId = param.wikiId, prefix = param.prefix, career = param.career, userName = param.userName, year = param.year, salary = param.salary, onDelete = param.onDelete;
    var isAdmin = (0,admin/* default */.Z)().isAdmin;
    var mutate = useWikiSalaryDeleteMutation().mutate;
    var userInfo = useGetUserInfo(prefix, userName, career);
    var handleDelete = function() {
        if (isAdmin) {
            if (window.confirm("정말 삭제하시겠습니까?")) {
                mutate({
                    wikiId: wikiId
                }, {
                    onSuccess: function() {
                        alert("삭제완료!");
                        if (onDelete) {
                            onDelete();
                        }
                    }
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WikiSalaryList_style_Item, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo, {
                        children: userInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Year, {
                        children: year ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                year,
                                "년 기준"
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "정보없음"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WikiSalaryList_style_Salary, {
                children: [
                    (0,formatted_number/* formattedMoney */.gR)(salary),
                    "만원"
                ]
            }),
            isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDelete, {
                onClick: handleDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrashCan, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/helper.ts
function getAmplitudeAttrbutes(prefix, navData) {
    var ATTRIBUTE_ID = "company__salary__seeMore__details";
    if (prefix === "경력") {
        return navData.map(function(item) {
            return {
                "data-attribute-id": ATTRIBUTE_ID,
                "data-click-type": "경력 예상연봉",
                "data-career": item.label
            };
        });
    }
    return navData.map(function(item) {
        return {
            "data-attribute-id": ATTRIBUTE_ID,
            "data-click-type": "신입 예상연봉",
            "data-education": item.label
        };
    });
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/style.ts

function ModalSalaryInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"
    ]);
    ModalSalaryInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalSalaryInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-content: stretch;\n  width: 100%;\n  min-width: 375px;\n  height: 628px;\n  padding: 19px;\n"
    ]);
    ModalSalaryInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalSalaryInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n"
    ]);
    ModalSalaryInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalSalaryInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n"
    ]);
    ModalSalaryInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalSalaryInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    ModalSalaryInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalSalaryInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border-width: 0;\n"
    ]);
    ModalSalaryInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var cssModalContent = (0,styled_components_browser_esm/* css */.iv)(ModalSalaryInfo_style_templateObject());
var ModalSalaryInfo_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7dd749ea-0"
})(ModalSalaryInfo_style_templateObject1());
var style_Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7dd749ea-1"
})(ModalSalaryInfo_style_templateObject2());
var TitleGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7dd749ea-2"
})(ModalSalaryInfo_style_templateObject3());
var ModalTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-7dd749ea-3"
})(ModalSalaryInfo_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B2"));
var ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7dd749ea-4"
})(ModalSalaryInfo_style_templateObject5());

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/ModalSalaryInfo/index.tsx












function ModalSalaryInfo(param) {
    var companyId = param.companyId, isOpen = param.isOpen, handleClose = param.handleClose, title = param.title, navData = param.navData, prefix = param.prefix, defaultMenuValue = param.defaultMenuValue, _labelExpectedSalary = param.labelExpectedSalary, labelExpectedSalary = _labelExpectedSalary === void 0 ? "예상연봉" : _labelExpectedSalary, salaryData = param.salaryData, companySource = param.companySource;
    var ref = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref.data;
    var ref1 = (0,react.useState)(defaultMenuValue), currentMenu = ref1[0], setCurrentMenu = ref1[1];
    var handleClickNav = function(param) {
        var value = param.value;
        setCurrentMenu(value);
    };
    var dataAttributes = (0,react.useMemo)(function() {
        return getAmplitudeAttrbutes(prefix, navData);
    }, [
        prefix,
        navData
    ]);
    var handleClickSalaryReport = function() {
        var career = prefix === "신입" ? 1 : 3;
        window.open("/salaryreport/step?company=".concat(companyId, "&career=").concat(career));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* default */.Z, {
        isOpen: isOpen,
        handleClose: handleClose,
        hasCloseButton: true,
        inlineCss: cssModalContent,
        maskClosable: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalSalaryInfo_style_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalNav, {
                    activeValue: currentMenu,
                    navData: navData,
                    onClick: handleClickNav,
                    dataAttributes: dataAttributes
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary_Summary, {
                    label: labelExpectedSalary,
                    salary: salaryData[currentMenu].avg
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySectionTitle, {
                            children: "제보 내역"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "sm",
                            variant: "dark",
                            onClick: handleClickSalaryReport,
                            "data-attribute-id": "company__salary__seeMore__details__salaryRank",
                            "data-company-id": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH,
                            "data-company-name": companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name,
                            children: "제보하기"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SalariesByCorp, {
                    corpSalary: salaryData[currentMenu].CORP,
                    mlSalary: salaryData[currentMenu].KJ,
                    companySource: companySource
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiSalaryList, {
                    prefix: prefix,
                    companyId: companyId,
                    category: currentMenu
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryStakeBarGraph/index.tsx



function SalaryStakeBarGraph_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n\n  canvas {\n    width: 100%;\n    height: 160px;\n  }\n\n  ",
        " {\n    width: 100%;\n\n    canvas {\n      width: 100% !important;\n      height: 160px !important;\n    }\n  }\n"
    ]);
    SalaryStakeBarGraph_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryStakeBarGraph_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  ul {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    list-style: none;\n    margin-top: 17px;\n    margin-right: 12px;\n    margin-bottom: 40px;\n  }\n\n  li {\n    font-size: 10px;\n    font-weight: 700;\n    color: ",
        ";\n    width: 50px;\n    line-height: 12px;\n    margin-bottom: 15px;\n  }\n  position: relative;\n"
    ]);
    SalaryStakeBarGraph_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryStakeBarGraph_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 130px;\n  padding: 6px 0;\n  background-color: ",
        ";\n  border-radius: 4px;\n  color: white;\n  transition: all 0.1s ease;\n  pointer-events: none;\n\n  top: ",
        "px;\n  left: ",
        "px;\n  opacity: ",
        ";\n\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 12px;\n\n  ",
        " {\n    pointer-events: inherit;\n  }\n\n  div {\n    position: relative;\n\n    &:after {\n      content: '';\n      position: absolute;\n      right: calc(50% - 7px);\n\n      left: 0;\n      right: 0;\n      margin: 0 auto;\n      width: 0;\n      height: 0;\n\n      border-top: 10px solid;\n      border-left: 15px solid transparent;\n      border-right: 15px solid transparent;\n      border-top-color: ",
        ";\n    }\n  }\n\n  .avg {\n    font-size: 12px;\n    line-height: 15px;\n  }\n"
    ]);
    SalaryStakeBarGraph_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL, chart/* Tooltip */.u, chart/* Legend */.De);
function StakeBarGraph(param) {
    var graphData = param.graphData, onClickChart = param.onClickChart;
    var chartRef = (0,react.useRef)(null);
    var ref = useGraphData({
        graphData: graphData,
        onClickChart: onClickChart
    }), data = ref.data, options = ref.options, tooltip = ref.tooltip;
    var handleClickTooltip = (0,react.useCallback)(function() {
        if (onClickChart && tooltip.dataIndex !== undefined) {
            onClickChart(null, tooltip.dataIndex);
        }
    }, [
        onClickChart,
        tooltip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeBarGraphWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphWapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Bar */.$Q, {
                    data: data,
                    options: options,
                    ref: chartRef
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphTooltip, {
                    left: tooltip.left,
                    top: tooltip.top,
                    opacity: tooltip.opacity,
                    onClick: handleClickTooltip,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    (0,formatted_number/* formattedMoney */.gR)(tooltip.value.min),
                                    "만원 ~ ",
                                    (0,formatted_number/* formattedMoney */.gR)(tooltip.value.max),
                                    "만원"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "avg",
                                children: [
                                    tooltip.value.avg > 0 ? "평균 ".concat((0,formatted_number/* formattedMoney */.gR)(tooltip.value.avg), "만원") : "정보없음",
                                    " >"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var SalaryStakeBarGraph = (/*#__PURE__*/(0,react.memo)(StakeBarGraph));
function useGraphData(param) {
    var graphData = param.graphData, onClickChart = param.onClickChart;
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)({
        opacity: 0,
        top: 0,
        left: 0,
        dataIndex: undefined,
        value: {
            avg: 0,
            min: 0,
            max: 0
        }
    }), tooltip = ref[0], setTooltip = ref[1];
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var externalTooltipHandler = function(context) {
        var tooltipModel = context.tooltip;
        if (tooltipModel.opacity === 0) {
            setTooltip(function(prev) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                    opacity: 0
                });
            });
            return;
        }
        var dataIndex = tooltipModel.dataPoints[0].dataIndex;
        // @ts-ignore
        var data = tooltipModel.dataPoints[0].dataset.showData[dataIndex];
        // TODO label Data를 array to object로 변경해서 직관성있게 수정
        // @ts-ignore
        var value = {
            avg: data.avg,
            min: data.min,
            max: data.max
        };
        /** 해당 그래프의 WIKI 값의 데이터가 없을때 count = 1, avg = 0 */ // @ts-ignore
        if (data.count < 2) {
            return;
        }
        var newTooltipData = {
            opacity: 1,
            left: tooltipModel.caretX - 65,
            top: tooltipModel.caretY - 65,
            dataIndex: dataIndex,
            value: value
        };
        if (!(0,isEqual/* isEqual */.X)(tooltip, newTooltipData)) setTooltip(newTooltipData);
    };
    var options = {
        maintainAspectRatio: false,
        devicePixelRatio: 2,
        interaction: {
            intersect: false,
            mode: "index"
        },
        onClick: function(event, chartElements) {
            // @ts-ignore
            var datasets = event === null || event === void 0 ? void 0 : event.chart.tooltip.dataPoints;
            if (datasets) {
                if (onClickChart && !isMobile) {
                    onClickChart(event, chartElements[0].index);
                }
            }
        },
        onHover: function(event, chartElement) {
            // @ts-ignore
            var datasets = event === null || event === void 0 ? void 0 : event.chart.tooltip.dataPoints;
            if (datasets) {
                var ref;
                var target = (ref = event.native) === null || ref === void 0 ? void 0 : ref.target;
                target.style.cursor = chartElement[0] ? "pointer" : "default";
            }
        },
        animation: {
            duration: 0
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
                external: function(context) {
                    return externalTooltipHandler(context);
                }
            },
            datalabels: {
                labels: {
                    value: {
                        color: function(ctx) {
                            var datasets = ctx.dataset;
                            var index = ctx.dataIndex;
                            // @ts-ignore
                            var showData = datasets.showData[index];
                            if (showData.count >= 2) {
                                return theme.colors.magenta700;
                            }
                            return theme.colors.gray800;
                        },
                        font: {
                            weight: "500",
                            lineHeight: "12px",
                            size: "12px",
                            family: "Pretendard"
                        },
                        align: "end",
                        textAlign: "center",
                        anchor: "end",
                        formatter: function(value, ctx) {
                            var datasets = ctx.dataset;
                            var index = ctx.dataIndex;
                            // @ts-ignore
                            var showData = datasets.showData[index];
                            if (datasets.order === 2) {
                                if (showData.count >= 2) {
                                    if (showData.avg === 0 && (showData.min > 0 || showData.max > 0)) {
                                        return "";
                                    } else {
                                        return "\xb1 ".concat((0,formatted_number/* formattedMoney */.gR)(showData.avg));
                                    }
                                }
                            }
                            if (datasets.order === 1) {
                                if (showData.count >= 2) {
                                    if (showData.avg === 0 && (showData.min > 0 || showData.max > 0)) {
                                        return "정보없음";
                                    } else {
                                        return " ";
                                    }
                                }
                                if (showData.avg <= 0 && showData.count < 2) {
                                    return "정보없음";
                                }
                                if (showData.avg > 0) {
                                    return (0,formatted_number/* formattedMoney */.gR)(showData.avg);
                                }
                            }
                            return " ";
                        }
                    }
                }
            }
        },
        layout: {
            padding: {
                top: 20
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    font: {
                        weight: "500",
                        lineHeight: "12px",
                        size: "10px",
                        family: "Pretendard"
                    },
                    color: theme.colors.gray700
                }
            },
            y: {
                grid: {
                    drawBorder: false
                },
                ticks: {
                    crossAlign: "center",
                    autoSkip: false,
                    display: true,
                    tickLength: 10,
                    padding: 12,
                    font: {
                        weight: "500",
                        lineHeight: "12px",
                        size: "10px",
                        family: "Pretendard"
                    },
                    color: theme.colors.gray700,
                    callback: function(value) {
                        var fommatedAxisLabel = [
                            2000,
                            4000,
                            6000,
                            8000,
                            10000
                        ];
                        var formattedYScale = function() {
                            if (value >= 10000) {
                                return "1억";
                            } else {
                                return value / 1000 + "천";
                            }
                        };
                        return fommatedAxisLabel.includes(value) ? formattedYScale() : "";
                    },
                    stepSize: 1000
                },
                min: 0,
                max: 10000
            }
        }
    };
    var data = {
        labels: graphData.map(function(wikiSalary) {
            return wikiSalary.title;
        }),
        datasets: [
            {
                backgroundColor: theme.colors.magenta500,
                borderColor: theme.colors.magenta500,
                borderWidth: 1,
                barThickness: 30,
                data: graphData.map(function(wikiSalary) {
                    return [
                        wikiSalary.showData.avg,
                        wikiSalary.showData.avg > 0 ? wikiSalary.showData.avg - 250 : 250, 
                    ];
                }),
                stakeData: graphData.map(function(wikiSalary) {
                    return [
                        wikiSalary.showData.max,
                        wikiSalary.showData.min, 
                    ];
                }),
                showData: graphData.map(function(wikiSalary) {
                    return {
                        isDataEmpty: wikiSalary.isDataEmpty,
                        max: wikiSalary.stakeData.max,
                        min: wikiSalary.stakeData.min,
                        avg: wikiSalary.data,
                        count: wikiSalary.showData.count
                    };
                }),
                pointHitRadius: 20,
                order: 1
            },
            {
                backgroundColor: theme.colors.yellow300,
                borderColor: theme.colors.yellow300,
                borderWidth: 1,
                barThickness: 30,
                data: graphData.map(function(wikiSalary) {
                    return [
                        wikiSalary.showData.max,
                        wikiSalary.showData.min,
                        wikiSalary.showData.avg, 
                    ];
                }),
                showData: graphData.map(function(wikiSalary) {
                    return {
                        isDataEmpty: wikiSalary.isDataEmpty,
                        max: wikiSalary.stakeData.max,
                        min: wikiSalary.stakeData.min,
                        avg: wikiSalary.data,
                        count: wikiSalary.showData.count
                    };
                }),
                order: 2
            }, 
        ]
    };
    return {
        options: options,
        data: data,
        tooltip: tooltip
    };
}
var GraphWapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edc83d7e-0"
})(SalaryStakeBarGraph_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});
var StakeBarGraphWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edc83d7e-1"
})(SalaryStakeBarGraph_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var GraphTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edc83d7e-2"
})(SalaryStakeBarGraph_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(props) {
    return props.top;
}, function(props) {
    return props.left;
}, function(props) {
    return props.opacity;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(props) {
    return props.theme.colors.magenta700;
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/WikiSalary/ButtonDetail.tsx




function ButtonDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  margin-left: 5px;\n"
    ]);
    ButtonDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function ButtonDetail(_param) {
    var onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "light" : _variant, disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClick",
        "variant",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        variant: variant,
        size: "sm",
        disabled: disabled,
        onClick: onClick
    }, props), {
        children: "자세히 보기"
    }));
};
var ButtonDetail_IconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6b973f2d-0"
})(ButtonDetail_templateObject());

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/WikiSalary/SignupNudgeWikiChart/style.ts

function SignupNudgeWikiChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 240px;\n  border: 1px solid ",
        ";\n  padding: 32px;\n  border-radius: 4px;\n  text-align: center;\n  cursor: pointer;\n\n  ",
        " {\n    padding: 32px 16px;\n  }\n"
    ]);
    SignupNudgeWikiChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SignupNudgeWikiChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n"
    ]);
    SignupNudgeWikiChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SignupNudgeWikiChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 32px;\n"
    ]);
    SignupNudgeWikiChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SignupNudgeWikiChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -17px;\n  right: 0;\n  transform: translate3d(0, -100%, 0);\n  padding: 2px 4px;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 2px;\n  ",
        ";\n"
    ]);
    SignupNudgeWikiChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SignupNudgeWikiChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e59f0832-0"
})(SignupNudgeWikiChart_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_Img = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e59f0832-1"
})(SignupNudgeWikiChart_style_templateObject1());
var SignupNudgeWikiChart_style_ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e59f0832-2"
})(SignupNudgeWikiChart_style_templateObject2());
var SignupNudgeWikiChart_style_Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e59f0832-3"
})(SignupNudgeWikiChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium150_C2"));

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/WikiSalary/SignupNudgeWikiChart/index.tsx








function SignupNudgeWikiChart(param) {
    var companyId = param.companyId, type = param.type;
    var router = (0,next_router.useRouter)();
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var data = (0,useCompanyInfo/* default */.Z)(companyId).data;
    var handleClick = function() {
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#wiki-salary"),
            messageKey: "kreditjob_company_bookmark_title"
        });
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salary__graph__click", {
            companyId: data === null || data === void 0 ? void 0 : data.id,
            companyName: data === null || data === void 0 ? void 0 : data.name,
            graphType: type === "rookie" ? "신입 예상 연봉" : "경력 예상 연봉"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeWikiChart_style_Wrapper, {
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupNudgeWikiChart_style_Message, {
                children: "실제 데이터는 예시 화면과 다를 수 있습니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        srcSet: "/images/img-sample-".concat(type, "-salary-chart@2x.png 2x"),
                        media: "(max-width: 767px)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        srcSet: "/images/img-sample-".concat(type, "-salary-chart@2x.png 2x")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Img, {
                        srcSet: "/images/img-sample-".concat(type, "-salary-chart.png 2x"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupNudgeWikiChart_style_ButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDetail, {
                    variant: "magenta"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/WikiSalary/GraphContents/index.tsx










function GraphContents(param) {
    var companyId = param.companyId, data = param.data, graphData = param.graphData, careerType = param.careerType, selectSource = param.selectSource;
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,hooks/* useModalOpen */.oL)(data), isModalOpen = ref.isModalOpen, setIsModalOpen = ref.setIsModalOpen, modalInfo = ref.modalInfo, handleModalOpen = ref.handleModalOpen;
    var ref1 = (0,hooks/* useConstants */.tJ)(), CAREER_EMPLOYEE_NAV_DATA = ref1.CAREER_EMPLOYEE_NAV_DATA, NEW_EMPLOYEE_NAV_DATA = ref1.NEW_EMPLOYEE_NAV_DATA;
    var handleClickChart = function(chartIndex) {
        var type = careerType === "rookie" ? "신입" : "경력";
        var defaultMenuValue = careerType === "rookie" ? NEW_EMPLOYEE_NAV_DATA[chartIndex].value : CAREER_EMPLOYEE_NAV_DATA[chartIndex].value;
        var gtmProperty = {
            graphType: "".concat(type, " 예상 연봉"),
            education: null,
            career: null,
            date: null,
            avgSalary: null
        };
        if (careerType === "rookie") {
            gtmProperty["education"] = NEW_EMPLOYEE_NAV_DATA[chartIndex].label;
        } else {
            gtmProperty["career"] = CAREER_EMPLOYEE_NAV_DATA[chartIndex].label;
        }
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salary__graph__click", gtmProperty);
        handleModalOpen({
            type: type,
            defaultMenuValue: defaultMenuValue
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isActiveUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupNudgeWikiChart, {
                companyId: companyId,
                type: careerType
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.GraphCard, {
                paddingLeft: isMobile ? "8px" : "18px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryStakeBarGraph, {
                        graphData: graphData,
                        onClickChart: function(evt, chartIndex) {
                            return handleClickChart(chartIndex);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDetail, {
                            "data-attribute-id": "company__salary__seeMore",
                            "data-click-type": careerType === "rookie" ? "신입 예상 연봉" : "경력 예상연봉",
                            onClick: function() {
                                return handleModalOpen({
                                    type: careerType === "rookie" ? "신입" : "경력"
                                });
                            }
                        })
                    })
                ]
            }),
            isModalOpen && modalInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSalaryInfo, {
                companyId: companyId,
                navData: modalInfo.navData,
                title: modalInfo.title,
                defaultMenuValue: modalInfo.defaultMenuValue,
                prefix: modalInfo.type,
                isOpen: isModalOpen,
                salaryData: data,
                companySource: selectSource,
                handleClose: function() {
                    return setIsModalOpen(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/WikiSalary/index.tsx










function WikiSalary(param) {
    var id = param.id, isSalaryBlocked = param.isSalaryBlocked, selectSource = param.selectSource;
    var wrapperRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var query = useGetWikiSalaryChart(id, isSalaryBlocked, selectSource);
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (query.isSuccess && wrapperRef.current && hash === "wiki-salary") {
            if (window) {
                router.replace(path);
                wrapperRef.current.scrollIntoView();
            }
        }
    }, [
        query.isSuccess
    ]);
    if (query.isLoading || query.isError || query.isIdle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.SalaryGrpahWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.SalaryGrpahWrapper, {
        ref: wrapperRef,
        children: query.transformedWitkSalary.map(function(graphData, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.SalaryGraph, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySectionTitle, {
                        children: index === 0 ? "신입 예상 연봉" : "경력 예상 연봉"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GraphContents, {
                        companyId: id,
                        data: query.data,
                        selectSource: selectSource,
                        graphData: graphData,
                        careerType: index === 0 ? "rookie" : "career"
                    })
                ]
            }, index);
        })
    }, (0,uuid/* generateUUID */.D)());
}
/* harmony default export */ var SalaryInfo_WikiSalary = (WikiSalary);

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanySalary.ts









var useCompanySalary_url = function(id) {
    return "/api/company/".concat(id, "/salaries");
};
function useGetCompanySalaryQuery(id, isSalaryBlocked, isClosed, selectedOption) {
    var query = (0,index_production.useQuery)([
        queryKeys/* default.companySalary */.Z.companySalary,
        id
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanySalary_url(id));
    }, {
        enabled: !isSalaryBlocked && !isClosed,
        select: function(response) {
            return transformSalary(response, selectedOption);
        }
    });
    return query;
};
var transformSalary = function(data, selectedOption) {
    var tempOptions = useCompanySalary_getAcitveSource(data.salaries);
    var tempSource = Object.values(COMPANY_SOURCE).map(function(option) {
        return {
            value: option,
            disabled: tempOptions.indexOf(option) < 0,
            selected: COMPANY_SOURCE[data.defaultSource] === option
        };
    });
    var sourceOptions = tempSource[0].disabled ? tempSource.slice(1) : tempSource;
    var source = selectedOption ? (0,object/* getKeyByValue */.V9)(COMPANY_SOURCE, selectedOption) : data.defaultSource;
    var activeSalary = getActiveSalary(data, source);
    var ref = (0,_sliced_to_array/* default */.Z)((0,company/* selectSalaryType */.Pp)(activeSalary), 1), salary = ref[0];
    return (0,src_object_spread/* default */.Z)({
        pickedSalary: salary,
        salaryGraphData: activeSalary,
        sourceOptions: sourceOptions
    }, data);
};
var useCompanySalary_getAcitveSource = function(data) {
    var tempOptions = [];
    var keys = Object.keys(data);
    keys.forEach(function(source) {
        return COMPANY_SOURCE[source] && tempOptions.push(COMPANY_SOURCE[source]);
    });
    return tempOptions;
};
var getActiveSalary = function(salaryInfo, source) {
    var activeSalary = salaryInfo.avg.map(function(each, index) {
        if (source) {
            var salaries = salaryInfo.salaries[source][index];
            return (0,src_object_spread/* default */.Z)({}, each, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, salaries), {
                salary: salaries ? salaries.salary : 0,
                updatedAt: salaries ? salaries.updatedAt : null
            }));
        } else {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, each), {
                salary: 0,
                updatedAt: null,
                rateType: "TOTAL",
                totalRate: 0,
                industryRate: 0
            });
        }
    });
    // @ts-ignore
    return activeSalary;
};

;// CONCATENATED MODULE: ./src/hooks/useDropdownSelect.ts

function useDropdownSelect() {
    var ref = (0,react.useState)(), selectedOption = ref[0], setSelectedOption = ref[1];
    var handleSelectChange = function(value) {
        if (value) {
            setSelectedOption(value);
        }
    };
    return {
        selectedOption: selectedOption,
        handleSelectChange: handleSelectChange
    };
}
/* harmony default export */ var hooks_useDropdownSelect = (useDropdownSelect);

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanySalaryChart.ts



var useCompanySalaryChart_url = function(companyId) {
    return "/api/company/".concat(companyId, "/salariesChart");
};
function useCompanySalaryChart(companyId) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companySalaryChart */.Z.companySalaryChart,
        companyId
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanySalaryChart_url(companyId));
    }, {
        enabled: !!companyId
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/ButtonGroup/style.ts

function SalaryChart_ButtonGroup_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  margin-top: 40px;\n"
    ]);
    SalaryChart_ButtonGroup_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryChart_ButtonGroup_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-right: 1px solid ",
        ";\n      "
    ]);
    SalaryChart_ButtonGroup_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryChart_ButtonGroup_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-left: 1px solid ",
        ";\n      "
    ]);
    SalaryChart_ButtonGroup_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalaryChart_ButtonGroup_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    SalaryChart_ButtonGroup_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalaryChart_ButtonGroup_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    SalaryChart_ButtonGroup_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalaryChart_ButtonGroup_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    SalaryChart_ButtonGroup_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ButtonGroup_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 32px;\n  background: none;\n  padding: 0;\n  border-width: 0;\n  ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n\n  &:first-child {\n    border-radius: 16px 0px 0px 16px;\n\n    ",
        "\n  }\n\n  &:nth-child(2) {\n    border-left: none;\n    border-right: none;\n  }\n  &:last-child {\n    border-radius: 0px 16px 16px 0px;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    ButtonGroup_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var SalaryChart_ButtonGroup_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b699b06-0"
})(SalaryChart_ButtonGroup_style_templateObject());
var SalaryChart_ButtonGroup_style_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3b699b06-1"
})(ButtonGroup_style_templateObject6(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var year = param.year;
    return year === 3 && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_ButtonGroup_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var year = param.year;
    return year === 3 && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_ButtonGroup_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 1 && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_ButtonGroup_style_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 5 && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_ButtonGroup_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var active = param.active, year = param.year;
    return active && year === 3 && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_ButtonGroup_style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta500;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/ButtonGroup/index.tsx


var SalaryChart_ButtonGroup_YEARS = [
    1,
    3,
    5
];
function SalaryChart_ButtonGroup_ButtonGroup(param) {
    var currentYear = param.currentYear, onClick = param.onClick;
    var handleClick = function(year) {
        if (onClick) {
            onClick(year);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_ButtonGroup_style_Wrapper, {
        children: SalaryChart_ButtonGroup_YEARS.map(function(year) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryChart_ButtonGroup_style_Button, {
                active: currentYear === year,
                year: currentYear,
                "data-attribute-id": "company__salary__filter__click",
                "data-year": "".concat(year, "년"),
                onClick: function() {
                    return handleClick(year);
                },
                children: [
                    year,
                    "년"
                ]
            }, "salary-chart-button-".concat(year));
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/GuideMessage/style.ts

function SalaryChart_GuideMessage_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    SalaryChart_GuideMessage_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryChart_GuideMessage_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 10px 20px;\n  background: rgba(244, 244, 244, 0.9);\n  border-radius: 4px;\n  text-align: center;\n  transform: translate3d(-50%, -50%, 0);\n  transition: all 0.2s;\n  opacity: 0;\n  ",
        ";\n\n  ",
        "\n\n  ",
        " {\n    width: 180px;\n    margin-top: -20px;\n  }\n"
    ]);
    SalaryChart_GuideMessage_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SalaryChart_GuideMessage_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d197a4ab-0"
})(SalaryChart_GuideMessage_style_templateObject1(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var isEntered = param.isEntered;
    return isEntered && (0,styled_components_browser_esm/* css */.iv)(SalaryChart_GuideMessage_style_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/GuideMessage/index.tsx




function GuideMessage_GuideMessage() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), isEntered = ref[0], setIsEntered = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setIsEntered(true);
        }, 150);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_GuideMessage_style_Wrapper, {
        isEntered: isEntered,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "손가락을 올려",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "상세 정보를 확인해 보세요."
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "마우스를 올려",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "상세 정보를 확인해 보세요."
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/GuideMessage/hooks.ts


function GuideMessage_hooks_useDisplayTrigger(ref) {
    var _$ref = (0,react.useState)(), isDisplayed = _$ref[0], setIsDisplayed = _$ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && !isDisplayed) {
            setIsDisplayed(true);
        }
    }, [
        entry,
        isDisplayed
    ]);
    return isDisplayed || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/helper.ts


/**
 * 오늘 기준으로 1년,3년,5년의 모든 월정보를 문자열 배열로 반환한다. (YYYY-MM)
 * byQuarter인 경우 분기가 종료되는 날짜의 정보만 가져온다.
 * @param year
 * @param byQuarter
 * @returns
 */ function helper_getXAxisDates(year) {
    var length = year * 12;
    var dates = new Array(length).fill("");
    var lastYear = dayjs().subtract(year, "year").add(1, "month");
    dates.reduce(function(prev, current, index) {
        dates[index] = prev.format("YYYY-MM-01");
        return prev.add(1, "month");
    }, lastYear);
    return dates;
}
/**
 * 날짜를 특정년도만큼 잘라내고(1년/3년/5년) 오름차순으로 내려오는 데이터를 내림차순으로 변경
 * FIXME: 서버에 내림차순으로 내려줄 수 있는지
 *
 * @param data
 * @param year
 * @returns
 */ function helper_getSliceData(data, year) {
    if (!data) {
        return [];
    }
    return data.slice(year * -12);
}
function helper_getBarChartSizeProps(year, hasPadding) {
    switch(year){
        case 1:
            if (hasPadding) {
                return {
                    barThickness: 14,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 10
            };
        case 3:
            if (hasPadding) {
                return {
                    barThickness: 10,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 6
            };
        default:
            if (hasPadding) {
                return {
                    barThickness: 7,
                    borderWidth: 2,
                    borderColor: "transparent"
                };
            }
            return {
                barThickness: 3
            };
    }
}
function helper_getQuarter(month) {
    return Math.ceil(month / 3);
}
/**
 * 쿼터별로 데이터를 머지한다.
 * date는 YYYY.NQ
 * @param data
 */ function helper_getDataByQuarter(data, year) {
    var periodNum = 3;
    var result = [];
    var slicedData = helper_getSliceData(data, year);
    var divider = 0;
    slicedData.reduce(function(prev, current, index) {
        var date = dayjs_min_default()(current.date);
        var month = date.get("month") + 1;
        var quarter = helper_getQuarter(month);
        var isQuarter = month % periodNum === 0;
        var isLastItem = index === slicedData.length - 1;
        if (current.salary !== null) {
            divider++;
        }
        if (prev === null) {
            // 분기/년의 첫번째 개월이자 데이터의 마지막 요소인 경우
            if (isLastItem || isQuarter && index === 0) {
                result.push({
                    salary: current.salary / divider,
                    date: "".concat(date.format("YYYY"), ".").concat(quarter, "Q")
                });
                divider = 0;
                return null;
            }
            return current;
        }
        if (isQuarter || isLastItem) {
            var addedSalaryByQuarter = prev.salary + current.salary;
            // @ts-ignore
            var newSalary = addedSalaryByQuarter / divider;
            result.push({
                date: "".concat(date.format("YYYY"), ".").concat(quarter, "Q"),
                salary: newSalary === 0 ? null : newSalary
            });
            divider = 0;
            return null;
        }
        return {
            salary: prev.salary + current.salary
        };
    }, null);
    return result;
}
function helper_getLabelsByPediod(data, period, year) {
    if (period !== 12) {
        return data.map(function(item) {
            return item.date;
        });
    }
    var periodNum = 3;
    var result = [];
    // @ts-ignore
    data.reduce(function(prev, current, index) {
        var date = dayjs_min_default()(current.date);
        var month = date.get("month") + 1;
        var quarter = helper_getQuarter(month);
        var isQuarter = month % periodNum === 0;
        var isLastItem = index === data.length - 1;
        if (prev === null) {
            if (isLastItem || isQuarter && index === 0) {
                result.push("".concat(date.format("YYYY"), ".").concat(quarter, "Q"));
                return null;
            }
            return current;
        }
        if (isQuarter || isLastItem) {
            result.push("".concat(date.format("YYYY"), ".").concat(quarter, "Q"));
            return null;
        }
        return {
            // @ts-ignore
            salary: prev.salary + current.salary
        };
    }, null);
    return helper_getSliceData(result, year);
}
/**
 * 이번달 기준으로 1년, 3년, 5년치의 템플릿 데이터를 반환
 * @param year
 * @returns
 */ function helper_getDateArrayTemplate(year) {
    var today = dayjs_min_default()();
    var months = year * 12;
    var result = [];
    for(var i = 1; i <= months; i++){
        var date = today.subtract(months - i, "month");
        result.push({
            date: date.format("YYYY-MM-01"),
            salary: null
        });
    }
    return result;
}
/**
 * 실제 데이터와 template을 합병한 결과 반환
 * @param year
 * @param data
 * @returns
 */ function helper_getMergedDateArray(year, data) {
    var template = helper_getDateArrayTemplate(year);
    data.forEach(function(dateObj) {
        var date = dateObj.date;
        var salary = dateObj.salary;
        var targetIndex = template.findIndex(function(obj) {
            return obj.date === date;
        });
        if (targetIndex >= 0 && !(0,isEmpty/* isEmpty */.x)(salary) && typeof salary === "number") {
            template[targetIndex]["salary"] = salary;
        }
    });
    return template;
}
/**
 * 객체의 total값 유무에 따라 데이터가 유효한지 판단
 * @param data
 * @returns
 */ function helper_getIsEmptyData(data) {
    return data.every(function(obj) {
        return !obj.salary;
    });
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/constants.ts

var constants_LINE_STYLE = {
    backgroundColor: colors/* default.magenta500 */.Z.magenta500,
    borderColor: colors/* default.magenta500 */.Z.magenta500,
    borderWidth: 1
};
var constants_POINT_STYLE = {
    pointStyle: "circle",
    pointBorderColor: colors/* default.magenta500 */.Z.magenta500,
    pointRadius: 3.5,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 4,
    pointHoverBackgroundColor: colors/* default.white100 */.Z.white100
};
var constants_DEFAULT_CHART_STYLE = {
    borderWidth: 0
};
var constants_DEFAULT_OPTIONS = {
    animation: {
        duration: 100
    },
    interaction: {
        intersect: false,
        mode: "index"
    },
    plugins: {
        legend: {
            display: false
        },
        datalabels: {
            labels: {
                value: {
                    display: false
                }
            }
        }
    },
    parsing: {
        xAxis: "hired",
        yAxis: "left"
    },
    scales: {
        y: {
            ticks: {
                display: false
            },
            grid: {
                drawBorder: false,
                color: colors/* default.gray300 */.Z.gray300
            }
        },
        x: {
            ticks: {
                autoSkip: true,
                font: {
                    weight: "500",
                    lineHeight: "12px",
                    size: "10px",
                    family: "Pretendard"
                },
                color: colors/* default.gray700 */.Z.gray700
            },
            grid: {
                display: false
            }
        }
    }
};
var constants_TOOLTIP_LINE_PLUGINS = {
    id: "tooltipLine",
    // @ts-ignore
    beforeDraw: function(chart) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
            var ctx = chart.ctx;
            ctx.save();
            var activePoint = chart.tooltip._active[0];
            ctx.beginPath();
            ctx.setLineDash([
                2,
                2
            ]);
            ctx.moveTo(activePoint.element.x, chart.chartArea.top);
            ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = colors/* default.gray600 */.Z.gray600;
            ctx.stroke();
            ctx.restore();
        }
    }
};
var constants_TOOLTIP_CONNECT_DASH = {
    // @ts-ignore
    afterDraw: function(chart) {
        var ctx = chart.ctx;
        ctx.save();
        var datasets = chart.data.datasets;
        var ref = datasets[0], lineChartData = ref.data;
        ctx.strokeStyle = colors/* default.magenta500 */.Z.magenta500;
        var xFrom = null;
        var yFrom = null;
        var dirty = false;
        var data = chart.getDatasetMeta(0).data;
        if (!data || data.length === 0) {
            return true;
        }
        // @ts-ignore
        data.forEach(function(obj, index) {
            var ref;
            if (index === lineChartData.length - 1) {
                return;
            }
            var x = obj.x, y = obj.y, skip = obj.skip;
            var isNextSkiped = (ref = data[index + 1]) === null || ref === void 0 ? void 0 : ref.skip;
            if (!skip && isNextSkiped) {
                xFrom = x;
                yFrom = y;
                dirty = true;
            }
            if (skip && !isNextSkiped && dirty) {
                var ref1, ref2;
                var targetX = (ref1 = data[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.x;
                var targetY = (ref2 = data[index + 1]) === null || ref2 === void 0 ? void 0 : ref2.y;
                ctx.lineWidth = 1;
                ctx.setLineDash([
                    2,
                    2
                ]);
                ctx.beginPath();
                ctx.moveTo(xFrom, yFrom);
                ctx.lineTo(targetX, targetY);
                ctx.stroke();
                xFrom = null;
                yFrom = null;
            }
        });
        ctx.restore();
    }
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/hooks.ts










function SalaryChart_hooks_useChartProps(param) {
    var originData = param.originData, year = param.year, externalTooltipHandler = param.externalTooltipHandler;
    var ref = (0,react.useState)(), isInteracted = ref[0], setIsInteracted = ref[1];
    var displayMode = hooks_useGetDisplayMode(year);
    var datasetsData = hooks_useGetDatasetsData(originData, year);
    var labels = hooks_useGetLabels(originData, year);
    var ref1 = (0,react.useState)(constants_POINT_STYLE), pointStyle = ref1[0], setPointStyle = ref1[1];
    (0,react.useEffect)(function() {
        if (year === 5) {
            setPointStyle((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, constants_POINT_STYLE), {
                pointRadius: 2.5,
                pointHoverRdius: 3.5,
                pointHoverBorderWidth: 2.5
            }));
        } else {
            setPointStyle(constants_POINT_STYLE);
        }
    }, [
        year
    ]);
    var data = (0,react.useMemo)(function() {
        return {
            labels: labels,
            datasets: [
                (0,src_object_spread/* default */.Z)({
                    type: "line",
                    label: "평균급여",
                    data: datasetsData,
                    parsing: {
                        xAxisKey: "date",
                        yAxisKey: "salary"
                    }
                }, constants_LINE_STYLE, pointStyle), 
            ]
        };
    }, [
        datasetsData,
        year,
        labels
    ]);
    var options = (0,react.useMemo)(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS), {
            onHover: function() {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
            },
            onClick: function(ctx) {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
                var _dataPoints = (0,_sliced_to_array/* default */.Z)(ctx.chart.tooltip.dataPoints, 1), salaryPoint = _dataPoints[0];
                if (salaryPoint) {
                    var avgSalary = Number((0,formatted_number/* millionFormattedtoString */.X6)(salaryPoint.raw.salary));
                    var date = salaryPoint.label;
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salary__graph__click", {
                        graphType: "월별 평균급여",
                        date: date,
                        avgSalary: avgSalary,
                        education: null,
                        career: null
                    });
                }
            },
            plugins: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS.plugins), {
                tooltip: {
                    enabled: false,
                    external: externalTooltipHandler
                }
            }),
            scales: {
                x: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS.scales.x), {
                    grid: (0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS.scales.x.grid),
                    ticks: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS.scales.x.ticks), {
                        // @ts-ignore
                        callback: function(value, index) {
                            if (!displayMode) {
                                return undefined;
                            }
                            var currentLabel = labels[index];
                            var thisMonth = dayjs_min_default()().get("month") + 1;
                            var quarter = helper_getQuarter(thisMonth);
                            var date = dayjs_min_default()(currentLabel);
                            var month = date.get("month") + 1;
                            if (displayMode.labelsPeriod === 3 && Math.abs(thisMonth - month) % 3 === 0) {
                                return date.format("YYYY.MM");
                            }
                            if (displayMode.labelsPeriod === 6 && Math.abs(thisMonth - month) % 6 === 0) {
                                return date.format("YYYY.MM");
                            }
                            //  이 경우는 데이터도 쿼터별로 그룹핑 됨 (getDataByQuarter함수 참고)
                            if (displayMode.labelsPeriod === 12) {
                                if (labels[index].indexOf("".concat(quarter, "Q")) >= 0) {
                                    return labels[index];
                                }
                            }
                            return undefined;
                        }
                    })
                }),
                y: (0,src_object_spread/* default */.Z)({}, constants_DEFAULT_OPTIONS.scales.y)
            }
        });
    }, [
        displayMode,
        labels,
        externalTooltipHandler
    ]);
    var plugins = [
        constants_TOOLTIP_LINE_PLUGINS,
        constants_TOOLTIP_CONNECT_DASH
    ];
    return {
        data: data,
        options: options,
        plugins: plugins,
        isInteracted: isInteracted
    };
}
function hooks_useGetDatasetsData(originData, year) {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    return (0,react.useMemo)(function() {
        if (originData.length === 0) {
            return [];
        }
        if (isMobile && year !== 1) {
            return helper_getDataByQuarter(originData, year);
        }
        return helper_getSliceData(originData, year);
    }, [
        originData,
        isMobile,
        year
    ]);
}
function hooks_useGetLabels(originData, year) {
    var ref = (0,react.useState)([]), labels = ref[0], setLabels = ref[1];
    var displayMode = hooks_useGetDisplayMode(year);
    (0,react.useEffect)(function() {
        if (displayMode === null || displayMode === void 0 ? void 0 : displayMode.labelsPeriod) {
            var slicedData = helper_getSliceData(originData, year);
            setLabels(helper_getLabelsByPediod(slicedData, displayMode === null || displayMode === void 0 ? void 0 : displayMode.labelsPeriod, year));
        }
    }, [
        originData,
        displayMode
    ]);
    return labels;
}
/**
 *
 * @param year
 * @returns
 */ function hooks_useGetDisplayMode(year) {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), displayMode = ref[0], setDisplayMode = ref[1];
    (0,react.useEffect)(function() {
        if (year === 1) {
            setDisplayMode({
                labelsPeriod: 3,
                datasetDisplayMode: "month"
            });
            return;
        }
        if (isMobile) {
            setDisplayMode({
                labelsPeriod: 12,
                datasetDisplayMode: "quarter"
            });
            return;
        }
        setDisplayMode({
            labelsPeriod: 6,
            datasetDisplayMode: "month"
        });
    }, [
        year,
        isMobile
    ]);
    return displayMode;
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/Legends/style.ts

function SalaryChart_Legends_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n\n  ",
        " {\n    margin-top: 20px;\n  }\n"
    ]);
    SalaryChart_Legends_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryChart_Legends_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 14px;\n  align-items: center;\n  color: ",
        ";\n  ",
        ";\n\n  &::before {\n    content: '';\n    display: block;\n    width: 9px;\n    height: 9px;\n    margin-right: 7px;\n    width: 15px;\n    height: 3px;\n    background: ",
        ";\n  }\n\n  ",
        " {\n    margin-right: 44px;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    SalaryChart_Legends_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SalaryChart_Legends_style_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-67a0adf4-0"
})(SalaryChart_Legends_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var SalaryChart_Legends_style_Legend = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-67a0adf4-1"
})(SalaryChart_Legends_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, (0,helper/* getFontStyle */.p)("midium120_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.magenta500;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/Legends/index.tsx


function SalaryChart_Legends_Legends() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_Legends_style_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_Legends_style_Legend, {
            children: "평균급여"
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/TooltipSalaries/helper.ts

function TooltipSalaries_helper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translate3d(-100%, -50%, 0);\n      margin-left: -15px;\n\n      &::before {\n        left: auto;\n        right: -7px;\n        border-top: 6px solid transparent;\n        border-bottom: 6px solid transparent;\n        border-left: 7px solid ",
        ";\n      }\n    "
    ]);
    TooltipSalaries_helper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipSalaries_helper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, -50%, 0);\n    margin-left: 15px;\n\n    &::before {\n      left: -7px;\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      border-right: 7px solid ",
        ";\n    }\n  "
    ]);
    TooltipSalaries_helper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


function helper_getCssByXAlign(xAlign) {
    if (xAlign === "right" || xAlign === "center") {
        return (0,styled_components_browser_esm/* css */.iv)(TooltipSalaries_helper_templateObject(), function(param) {
            var theme = param.theme;
            return theme.colors.magenta700;
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(TooltipSalaries_helper_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}
function helper_getDateString(date) {
    if (!date) {
        return null;
    }
    if (date.indexOf("Q") >= 0) {
        return date;
    }
    return dayjs_min_default()(date).format("YYYY.MM");
}

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/TooltipSalaries/style.ts

function TooltipSalaries_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-width: 110px;\n  background: ",
        ";\n  padding: 10px;\n  border-radius: 4px;\n  pointer-events: none;\n  transition: left 0.1s ease, top 0.1s ease, opacity 0.1s ease;\n\n  &::before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translate3d(0, -50%, 0);\n  }\n\n  ",
        ";\n"
    ]);
    TooltipSalaries_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipSalaries_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipSalaries_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TooltipSalaries_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 3px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipSalaries_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TooltipSalaries_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipSalaries_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TooltipSalaries_style_Wrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return {
        style: {
            left: "".concat($x, "px"),
            top: "".concat($y, "px"),
            opacity: $opacity
        }
    };
}).withConfig({
    componentId: "sc-ffb1b5fd-0"
})(TooltipSalaries_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var xAlign = param.xAlign;
    return helper_getCssByXAlign(xAlign);
});
var TooltipSalaries_style_Date = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ffb1b5fd-1"
})(TooltipSalaries_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C2"));
var style_Total = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ffb1b5fd-2"
})(TooltipSalaries_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_B3"));
var style_HiredAndLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ffb1b5fd-3"
})(TooltipSalaries_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C1"));

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/TooltipSalaries/index.tsx



function TooltipSalaries(param) {
    var date = param.date, salary = param.salary, xAlign = param.xAlign, $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipSalaries_style_Wrapper, {
        $x: $x,
        $y: $y,
        xAlign: xAlign,
        $opacity: $opacity,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipSalaries_style_Date, {
                children: helper_getDateString(date)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Total, {
                children: [
                    salary,
                    "만원"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/ChartContents/style.ts

function SalaryChart_ChartContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n"
    ]);
    SalaryChart_ChartContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryChart_ChartContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 610px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n\n  ",
        " {\n    width: 580px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SalaryChart_ChartContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryChart_ChartContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: ",
        ";\n  transform: translate3d(-50%, -50%, 0);\n  margin-top: -25px;\n  ",
        "\n\n  ",
        " {\n    margin-top: -15px;\n  }\n"
    ]);
    SalaryChart_ChartContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var SalaryChart_ChartContents_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-0"
})(SalaryChart_ChartContents_style_templateObject());
var ChartContents_style_ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-1"
})(SalaryChart_ChartContents_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ChartContents_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-2"
})(SalaryChart_ChartContents_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/ChartContents/index.tsx



















chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* Legend */.De, chart/* PointElement */.od, chart/* LineElement */.jn, chart/* Tooltip */.u);
function SalaryChartContents(param) {
    var companyId = param.companyId;
    var wrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(3), year = ref[0], setYear = ref[1];
    var ref1 = (0,react.useState)(), tooltipProps = ref1[0], setTooltipProps = ref1[1];
    var ref2 = (0,react.useState)(), isEmptyData = ref2[0], setIsEmptyData = ref2[1];
    var ref3 = useCompanySalaryChart(companyId), originData = ref3.data;
    var ref4 = (0,react.useState)([]), salariesChartData = ref4[0], setSalariesChartData = ref4[1];
    var isDisplyGuide = GuideMessage_hooks_useDisplayTrigger(wrapperRef);
    (0,react.useEffect)(function() {
        if (originData) {
            var mergedData = helper_getMergedDateArray(year, originData);
            setSalariesChartData(mergedData);
            setIsEmptyData(helper_getIsEmptyData(mergedData));
        }
    }, [
        originData,
        year
    ]);
    var externalTooltipHandler = (0,react.useCallback)(function(context) {
        if (context.tooltip.opacity === 0) {
            var newTooltipProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tooltipProps), {
                $opacity: 0
            });
            if (!(0,isEqual/* isEqual */.X)(tooltipProps, newTooltipProps)) {
                // @ts-ignore
                setTooltipProps(newTooltipProps);
            }
            return;
        }
        var tooltip = context.tooltip;
        var xAlign = tooltip.xAlign, dataPoints = tooltip.dataPoints;
        var _element = dataPoints[0].element, x = _element.x, y = _element.y;
        var _title = (0,_sliced_to_array/* default */.Z)(tooltip.title, 1), date = _title[0];
        if (dataPoints[0] === undefined) {
            setTooltipProps(undefined);
            return;
        }
        var salary = dataPoints[0].raw.salary;
        var formattedSalary = (0,formatted_number/* millionFormattedtoString */.X6)(salary);
        var newTooltipProps1 = {
            $x: x,
            $y: y,
            $opacity: 1,
            xAlign: xAlign,
            salary: formattedSalary,
            date: date
        };
        if (!(0,isEqual/* isEqual */.X)(tooltipProps, newTooltipProps1)) setTooltipProps(newTooltipProps1);
    }, [
        year,
        tooltipProps,
        salariesChartData
    ]);
    var ref5 = SalaryChart_hooks_useChartProps({
        originData: salariesChartData,
        year: year,
        externalTooltipHandler: externalTooltipHandler
    }), data = ref5.data, options = ref5.options, plugins = ref5.plugins, isInteracted = ref5.isInteracted;
    (0,react.useEffect)(function() {
        setTooltipProps(undefined);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryChart_ChartContents_style_Wrapper, {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_Legends_Legends, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartContents_style_ChartContainer, {
                children: [
                    salariesChartData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Line */.x1, {
                                data: data,
                                options: options,
                                plugins: plugins
                            }),
                            tooltipProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipSalaries, (0,src_object_spread/* default */.Z)({}, tooltipProps))
                        ]
                    }),
                    isEmptyData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChartContents_style_NoData, {
                        children: [
                            "최근 정보가 없습니다.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 기간을 변경해보세요."
                        ]
                    }),
                    isDisplyGuide && !isInteracted && !isEmptyData && /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideMessage_GuideMessage, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_ButtonGroup_ButtonGroup, {
                currentYear: year,
                onClick: function(year) {
                    return setYear(year);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/SignupNudgeSalaryChart/style.ts

function SignupNudgeSalaryChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  cursor: pointer;\n"
    ]);
    SignupNudgeSalaryChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SignupNudgeSalaryChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 606px;\n  height: 269px;\n  margin: 0 auto;\n\n  ",
        " {\n    width: 100%;\n    height: 0;\n    padding-bottom: 58%;\n  }\n"
    ]);
    SignupNudgeSalaryChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SignupNudgeSalaryChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n"
    ]);
    SignupNudgeSalaryChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SignupNudgeSalaryChart_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  min-width: 224px;\n  padding: 16px 32px;\n  background-color: #fff;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    SignupNudgeSalaryChart_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SignupNudgeSalaryChart_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  ",
        ";\n"
    ]);
    SignupNudgeSalaryChart_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SignupNudgeSalaryChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6a54c0-0"
})(SignupNudgeSalaryChart_style_templateObject());
var SignupNudgeSalaryChart_style_VideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6a54c0-1"
})(SignupNudgeSalaryChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-9a6a54c0-2"
})(SignupNudgeSalaryChart_style_templateObject2());
var SignupNudgeSalaryChart_style_MessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6a54c0-3"
})(SignupNudgeSalaryChart_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var SignupNudgeSalaryChart_style_Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6a54c0-4"
})(SignupNudgeSalaryChart_style_templateObject4(), (0,helper/* getFontStyle */.p)("midium150_C1"));

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/SignupNudgeSalaryChart/index.tsx












function SignupNudgeSalaryChart(param) {
    var companyId = param.companyId;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var moveOneIdPage = (0,useMoveOneIdPage/* default */.Z)();
    var data = (0,useCompanyInfo/* default */.Z)(companyId).data;
    var videoAssetName = (0,react.useMemo)(function() {
        if (isMobile) {
            return "video-chart-salary-m";
        }
        return "video-chart-salary";
    }, [
        isMobile
    ]);
    var handleClick = function() {
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salary__login__click", {
            companyHash: data === null || data === void 0 ? void 0 : data.PK_NM_HASH,
            companyName: data === null || data === void 0 ? void 0 : data.name,
            graphType: "인원 월별"
        });
        moveOneIdPage({
            beforeUrl: "".concat(env/* WEB_URL */.h$).concat(router.asPath, "#salary-linechart"),
            messageKey: "kreditjob_company_bookmark_title"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeSalaryChart_style_Wrapper, {
        onClick: function() {
            return handleClick();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_Legends_Legends, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeSalaryChart_style_VideoWrapper, {
                children: [
                    videoAssetName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Video, {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        playsInline: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".webm"),
                                type: "video/webm"
                            }, "/images/".concat(videoAssetName, ".webm")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "/images/".concat(videoAssetName, ".mp4"),
                                type: "video/mp4"
                            }, "/images/".concat(videoAssetName, ".mp4"))
                        ]
                    }, videoAssetName),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeSalaryChart_style_MessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupNudgeSalaryChart_style_Message, {
                                children: [
                                    data === null || data === void 0 ? void 0 : data.name,
                                    "의",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "평균급여 추이가 궁금하다면?"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "magenta",
                                size: "sm",
                                children: "로그인"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_ButtonGroup_ButtonGroup, {
                currentYear: 3
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/style.ts

function SalaryChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n  scroll-margin-top: 200px;\n"
    ]);
    SalaryChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SalaryChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a8e2154-0"
})(SalaryChart_style_templateObject());

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/SalaryChart/index.tsx









function SalaryChart(param) {
    var companyId = param.companyId;
    var router = (0,next_router.useRouter)();
    var wrapperRef = (0,react.useRef)(null);
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var status = useCompanySalaryChart(companyId).status;
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("#"), 2), path = ref[0], hash = ref[1];
        if (wrapperRef.current && hash === "salary-linechart" && status === "success") {
            if (window) {
                router.replace(path);
                wrapperRef.current.scrollIntoView();
            }
        }
    }, [
        status,
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart_style_Wrapper, {
        ref: wrapperRef,
        children: !isActiveUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupNudgeSalaryChart, {
            companyId: companyId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChartContents, {
            companyId: companyId
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalaryInfo/index.tsx



























function SalaryInfo(param) {
    var registerRef = param.registerRef, companyStates = param.companyStates;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = hooks_useDropdownSelect(), selectedOption = ref.selectedOption, handleSelectChange = ref.handleSelectChange;
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref1.data;
    var isSalaryBlocked = !companyStates.salary;
    var isClosed = companyStates.closed;
    var salaryQuery = useGetCompanySalaryQuery(companyId, isSalaryBlocked, isClosed, selectedOption);
    var cardProps = {
        title: "연봉",
        sectionId: COMPANY_DETAIL_MENU.SALARY,
        registerRef: registerRef,
        rightCardHeader: !(companyStates.deleted || companyStates.closed || !salaryQuery.data || salaryQuery.isError) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownSource, {
            value: selectedOption || COMPANY_SOURCE[salaryQuery.data.defaultSource],
            options: salaryQuery.data.sourceOptions,
            emptyValue: !(selectedOption || COMPANY_SOURCE[salaryQuery.data.defaultSource]) ? "정보없음" : undefined,
            tooltipHelperText: salaryQuery.data.salaryGraphData[0].updatedAt ? "".concat(dayjs_min_default()(salaryQuery.data.salaryGraphData[0].updatedAt).format("YYYY.MM"), " 기준 :") : "연봉 출처 : ",
            tooltipText: "출처의 데이터를 기반으로 추정된 값으로, 참고 자료로만 활용하시길 바랍니다.",
            onChange: function(value) {
                (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__salarySource__click", {
                    gnbKind: "연봉",
                    from: selectedOption || COMPANY_SOURCE[salaryQuery.data.defaultSource],
                    to: value
                });
                handleSelectChange(value);
            }
        })
    };
    if ((companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed) || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted)) {
        return null;
    }
    if (isSalaryBlocked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(company_BlockedInfo, {})
        }));
    }
    if (salaryQuery.isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
        }));
    }
    if (salaryQuery.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
        children: [
            salaryQuery.data.salaryGraphData[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_SalarySummary, {
                salary: salaryQuery.data.salaryGraphData[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_Salary, {
                data: salaryQuery.data.salaryGraphData,
                companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_WikiSalary, {
                id: companyId,
                isSalaryBlocked: isSalaryBlocked,
                selectSource: selectedOption || COMPANY_SOURCE[salaryQuery.data.defaultSource]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalaryInfo_style_S.SalaryChartContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySectionTitle, {
                        inlineCss: SalaryInfo_style_S.cssTitleBullet,
                        children: [
                            "월별 평균급여",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                width: 215,
                                tooltipText: "\n              매년 7월은 국민연금 정산월입니다. 본 자료는 국민연금 보험료 납부액을 기반으로 산출하므로 정산 월의 전 월과 평균 급여차이가 크게 날 수 있습니다.\n              <br/><br/>\n              국민연금 보험료는 기준소득월액에 따라 차등 산정됩니다. 본 기업의 기준소득월액이 상한액을 초과하거나 하한액을 미달한다면 추정에 오차가 발생할 수 있을 수 있습니다. (2022년 상한액 553만 원, 하한액 35만 원)\n              ",
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryInfo_style_S.SalaryGreyBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalaryChart, {
                            companyId: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.PK_NM_HASH
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionCompany, {})
        ]
    }));
}
/* harmony default export */ var company_SalaryInfo = (/*#__PURE__*/(0,react.memo)(SalaryInfo));

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanySales.ts







var useCompanySales_url = function(companyId) {
    return "/api/company/".concat(companyId, "/sales");
};
function useGetCompanySales(isClosed, companyId, selectedOption) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companySales */.Z.companySales,
        companyId
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanySales_url(companyId));
    }, {
        enabled: !isClosed && !!companyId,
        // @ts-ignore
        select: function(response) {
            return transformSales(response, selectedOption);
        }
    });
}
var transformSales = function(data, selectedOption) {
    if (!data || !data.sales || !data.defaultSource) {
        return {
            activeSales: {
                perPerson: {
                    industryRate: null,
                    rateType: "INDUSTRY",
                    sales: null,
                    totalRate: null
                },
                salesSalaryRate: {
                    industryRate: null,
                    rateType: "INDUSTRY",
                    sales: null,
                    totalRate: null
                },
                total: {
                    industryRate: null,
                    rateType: "INDUSTRY",
                    sales: null,
                    totalRate: null
                },
                updatedAt: null
            },
            defaultSource: null
        };
    }
    var sourceOption = salesSource(data);
    var source = selectedOption ? (0,object/* getKeyByValue */.V9)(SalesSource, selectedOption) : data.defaultSource;
    var activeSales = getActiveSales(data.sales, source);
    return {
        activeSales: activeSales,
        defaultSource: activeSales.total.sales ? data.defaultSource : null,
        sourceOption: sourceOption
    };
};
var getActiveSales = function(data, source) {
    var activeSales = data[source];
    return activeSales;
};
var salesSource = function(data) {
    var tempOptions = useCompanySales_getAcitveSource(data.sales);
    var hasCorpSource = tempOptions.indexOf(SalesSource.CORP) > -1;
    var tempSource = Object.values(SalesSource).map(function(option) {
        return {
            value: option,
            disabled: tempOptions.indexOf(option) < 0,
            selected: SalesSource[data.defaultSource] === option
        };
    });
    // 기업제공이 없을때 tempSource[0]을 제거
    return hasCorpSource ? tempSource : tempSource.slice(1);
};
var useCompanySales_getAcitveSource = function(data) {
    var tempOptions = [];
    var keys = Object.keys(data || {});
    keys.forEach(function(source) {
        return data[source].total.sales && SalesSource[source] && tempOptions.push(SalesSource[source]);
    });
    return tempOptions;
};
function salesDisplayPercent(sales, type) {
    var rate = sales.rateType === "INDUSTRY" ? sales.industryRate : sales.totalRate;
    if (typeof rate !== "number") {
        return "-";
    }
    var percent = Math.round((0,formatted_number/* parseToPercent */.lz)(rate));
    if (type === "salary" && sales.sales) {
        if ((0,company/* getSalaryRate */.k3)(sales.sales) === 100) {
            return 1;
        }
    }
    if (percent === 0) {
        return 1;
    } else if (percent > 100) {
        return 100;
    } else {
        return percent;
    }
}
function numberToKorean(num, type) {
    var salesDisplayData = function salesDisplayData(sales, unit) {
        var koreanNumber = (sales / unit).toFixed(1);
        return koreanNumber[koreanNumber.length - 1] === "0" || unit === 1.0e4 ? koreanNumber.split(".")[0] : koreanNumber;
    };
    if (type === "salary") {
        return (0,company/* getSalaryRate */.k3)(num) + "%";
    }
    if (num >= 1.0e15) {
        return salesDisplayData(num, 1.0e15) + "경원";
    } else if (num >= 1.0e12) {
        return salesDisplayData(num, 1.0e12) + "조원";
    } else if (num >= 1.0e8) {
        return salesDisplayData(num, 1.0e8) + "억원";
    } else {
        return salesDisplayData(num, 1.0e4) + "만원";
    }
}

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/style.ts

function SalesInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n\n  & > span:not(:last-child) {\n    margin-right: 5px;\n  }\n\n  &:nth-last-child(1) {\n    flex-direction: column;\n    gap: 8px;\n  }\n"
    ]);
    SalesInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 244px;\n\n  ",
        " {\n    min-width: 214px;\n  }\n\n  & > hr {\n    width: 30px;\n    margin: 16px auto 18px;\n    border-top: 1px solid ",
        ";\n\n    ",
        " {\n      margin: 12px auto 15px;\n    }\n  }\n\n  & > ",
        ":last-child {\n    margin-top: 7px;\n  }\n\n  .emphasize {\n    color: ",
        ";\n    ",
        ";\n  }\n\n  .grayColor {\n    color: ",
        ";\n  }\n"
    ]);
    SalesInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 50px;\n  margin-top: 30px;\n\n  ",
        " {\n    width: 100%;\n    max-width: 640px;\n    margin-left: auto;\n    margin-right: auto;\n    justify-content: center;\n  }\n\n  & > ",
        " {\n    margin-top: 20px;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    margin-bottom: 20px;\n    margin-top: 60px;\n\n    & > ",
        " {\n      margin-top: 0;\n      margin-bottom: 30px;\n    }\n\n    & > ",
        ":not(:last-child) {\n      margin-bottom: 60px;\n    }\n  }\n"
    ]);
    SalesInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    SalesInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 0;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    SalesInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 3px 4px 1px;\n  border-radius: 9px;\n  background: ",
        ";\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    SalesInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SalesInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    SalesInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var SalesInfo_style_Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-0"
})(SalesInfo_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var SalesInfoCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-1"
})(SalesInfo_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, SalesInfo_style_Row, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, (0,helper/* getFontStyle */.p)("bold150_C1"), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var SalesRateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-2"
})(SalesInfo_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, SalesInfoCard, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, SalesInfoCard, SalesInfoCard);
var FinancialChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-3"
})(SalesInfo_style_templateObject3());
var SalesInfo_style_ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-4"
})(SalesInfo_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_BadgeNew = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-248cf031-5"
})(SalesInfo_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta100;
}, (0,helper/* getFontStyle */.p)("midium120_C1"));
var style_cssTitleChart = (0,styled_components_browser_esm/* css */.iv)(SalesInfo_style_templateObject6());

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/SalesRate/index.tsx







function SalesRate(param) {
    var title = param.title, sales = param.sales, tooltipText = param.tooltipText, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalesInfoCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalesInfo_style_Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                        typography: "midium120_B3",
                        children: title
                    }),
                    tooltipText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        tooltipText: tooltipText,
                        position: "center",
                        width: type === "person" ? 120 : 190,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                            width: 15,
                            color: Theme/* default.colors.gray700 */.Z.colors.gray700
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_style_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                    typography: "bold120_T1",
                    children: sales.sales ? numberToKorean(sales.sales, type) : "정보없음"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_style_Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                    typography: "midium150_C1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "grayColor",
                            children: sales.rateType === "INDUSTRY" ? "동종업계" : "전체"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "emphasize",
                            children: " 상위 ".concat(salesDisplayPercent(sales, type), "%")
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var SalesInfo_SalesRate = (SalesRate);

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanyFinancialChart.ts



var useCompanyFinancialChart_url = function(companyId) {
    return "/api/company/".concat(companyId, "/financialReport");
};
function useCompanyFinancialChartData(companyId) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companyFinancialChart */.Z.companyFinancialChart,
        companyId
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanyFinancialChart_url(companyId));
    }, {
        enabled: !!companyId
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/GuideMessage/style.ts

function FinancialChart_GuideMessage_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    FinancialChart_GuideMessage_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinancialChart_GuideMessage_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 10px 20px;\n  background: rgba(244, 244, 244, 0.9);\n  border-radius: 4px;\n  text-align: center;\n  transform: translate3d(-50%, -50%, 0);\n  transition: all 0.2s;\n  opacity: 0;\n  ",
        ";\n\n  ",
        "\n\n  ",
        " {\n    width: 180px;\n    margin-top: -20px;\n  }\n"
    ]);
    FinancialChart_GuideMessage_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FinancialChart_GuideMessage_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d197a4ab-0"
})(FinancialChart_GuideMessage_style_templateObject1(), (0,helper/* getFontStyle */.p)("midium150_C1"), function(param) {
    var isEntered = param.isEntered;
    return isEntered && (0,styled_components_browser_esm/* css */.iv)(FinancialChart_GuideMessage_style_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/GuideMessage/index.tsx




function FinancialChart_GuideMessage_GuideMessage() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(), isEntered = ref[0], setIsEntered = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setIsEntered(true);
        }, 150);
    }, []);
    return(// FIXME: Sales Guide message랑 통일
    /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_GuideMessage_style_Wrapper, {
        isEntered: isEntered,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "".concat(isMobile ? "손가락" : "마우스", "를 올려"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "상세 정보를 확인해 보세요."
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/GuideMessage/hooks.ts


function FinancialChart_GuideMessage_hooks_useDisplayTrigger(ref) {
    var _$ref = (0,react.useState)(), isDisplayed = _$ref[0], setIsDisplayed = _$ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)(ref, {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && !isDisplayed) {
            setIsDisplayed(true);
        }
    }, [
        entry,
        isDisplayed
    ]);
    return isDisplayed || (entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
}

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/constants.ts

var TEMPLATE_CHART_DATA = [
    {
        year: 2019,
        salesAmount: null,
        profit: null,
        income: null
    },
    {
        year: 2020,
        salesAmount: null,
        profit: null,
        income: null
    },
    {
        year: 2021,
        salesAmount: null,
        profit: null,
        income: null
    }, 
];
var FinancialChart_constants_LINE_STYLE = {
    backgroundColor: colors/* default.magenta500 */.Z.magenta500,
    borderColor: colors/* default.magenta500 */.Z.magenta500,
    borderWidth: 1
};
var FinancialChart_constants_POINT_STYLE = {
    pointStyle: "circle",
    pointBorderColor: colors/* default.magenta500 */.Z.magenta500,
    pointRadius: 3.5,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 4,
    pointHoverBackgroundColor: colors/* default.white100 */.Z.white100
};
var FinancialChart_constants_DEFAULT_CHART_STYLE = {
    barThickness: 24,
    borderWidth: 2,
    borderColor: "transparent",
    borderRadius: 4
};
var FinancialChart_constants_DEFAULT_OPTIONS = {
    animation: {
        duration: 100
    },
    interaction: {
        intersect: false,
        mode: "index"
    },
    plugins: {
        legend: {
            display: false
        },
        datalabels: {
            labels: {
                value: {
                    display: false
                }
            }
        }
    },
    parsing: {
        xAxis: "hired",
        yAxis: "left"
    },
    scales: {
        y: {
            grid: {
                drawBorder: false,
                color: function(ctx) {
                    return ctx.tick.value === 0 ? "#dbdbdb" : colors/* default.gray300 */.Z.gray300;
                }
            }
        },
        x: {
            ticks: {
                autoSkip: true,
                color: colors/* default.gray700 */.Z.gray700,
                font: {
                    size: 10,
                    weight: "500",
                    family: "Pretendard"
                }
            },
            grid: {
                display: false
            }
        }
    }
};
var FinancialChart_constants_TOOLTIP_LINE_PLUGINS = {
    id: "tooltipLine",
    // @ts-ignore
    beforeDraw: function(chart) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
            var ctx = chart.ctx;
            ctx.save();
            var activePoint = chart.tooltip._active[0];
            ctx.beginPath();
            ctx.setLineDash([
                2,
                2
            ]);
            ctx.moveTo(activePoint.element.x, chart.chartArea.top);
            ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = colors/* default.gray600 */.Z.gray600;
            ctx.stroke();
            ctx.restore();
        }
    }
};
var FinancialChart_constants_TOOLTIP_CONNECT_DASH = {
    // @ts-ignore
    afterDraw: function(chart) {
        var ctx = chart.ctx, rawData = chart.data;
        var datasets = rawData.datasets;
        var ref = datasets[0], lineChartData = ref.data;
        var isEmpty = lineChartData.every(function(item) {
            return item.salesAmount === null;
        });
        if (isEmpty) {
            return;
        }
        ctx.save();
        ctx.strokeStyle = colors/* default.magenta500 */.Z.magenta500;
        var xFrom = null;
        var yFrom = null;
        var dirty = false;
        var data = chart.getDatasetMeta(0).data;
        if (!data || data.length === 0) {
            return true;
        }
        // @ts-ignore
        data.forEach(function(obj, index) {
            var ref;
            if (index === lineChartData.length - 1) {
                return;
            }
            var x = obj.x, y = obj.y, skip = obj.skip;
            var isNextSkiped = (ref = data[index + 1]) === null || ref === void 0 ? void 0 : ref.skip;
            if (!skip && isNextSkiped) {
                xFrom = x;
                yFrom = y;
                dirty = true;
            }
            if (skip && !isNextSkiped && dirty) {
                var ref1, ref2;
                var targetX = (ref1 = data[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.x;
                var targetY = (ref2 = data[index + 1]) === null || ref2 === void 0 ? void 0 : ref2.y;
                ctx.lineWidth = 1;
                ctx.setLineDash([
                    2,
                    2
                ]);
                ctx.beginPath();
                ctx.moveTo(xFrom, yFrom);
                ctx.lineTo(targetX, targetY);
                ctx.stroke();
                xFrom = null;
                yFrom = null;
            }
        });
        ctx.restore();
    }
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/hooks.ts







function FinancialChart_hooks_useChartProps(param) {
    var originData = param.originData, externalTooltipHandler = param.externalTooltipHandler, isEmpty = param.isEmpty;
    var ref = (0,react.useState)(), isInteracted = ref[0], setIsInteracted = ref[1];
    var labels = [
        2019,
        2020,
        2021
    ];
    var data = (0,react.useMemo)(function() {
        return {
            labels: labels,
            datasets: [
                (0,src_object_spread/* default */.Z)({
                    type: "line",
                    label: "전체인원",
                    data: originData,
                    parsing: {
                        xAxisKey: "year",
                        yAxisKey: "salesAmount"
                    }
                }, FinancialChart_constants_LINE_STYLE, FinancialChart_constants_POINT_STYLE),
                (0,src_object_spread/* default */.Z)({
                    type: "bar",
                    label: "영업이익",
                    data: originData,
                    parsing: {
                        xAxisKey: "year",
                        yAxisKey: "operatingIncome"
                    },
                    backgroundColor: "#87519B"
                }, FinancialChart_constants_DEFAULT_CHART_STYLE),
                (0,src_object_spread/* default */.Z)({
                    type: "bar",
                    label: "당기순이익",
                    data: originData,
                    parsing: {
                        xAxisKey: "year",
                        yAxisKey: "netIncome"
                    },
                    backgroundColor: "#F8DDC7"
                }, FinancialChart_constants_DEFAULT_CHART_STYLE), 
            ]
        };
    }, [
        originData,
        labels
    ]);
    var options = (0,react.useMemo)(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS), {
            onHover: function() {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
            },
            onClick: function(ctx) {
                if (!isInteracted) {
                    setIsInteracted(true);
                }
                var _dataPoints = (0,_sliced_to_array/* default */.Z)(ctx.chart.tooltip.dataPoints, 1), salesAmountPoint = _dataPoints[0];
                if (salesAmountPoint) {
                    var revenue = salesAmountPoint.parsed.y;
                    var year = salesAmountPoint.label;
                    (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__revenue__graph__click", {
                        revenue: revenue,
                        year: year
                    });
                }
            },
            plugins: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS.plugins), {
                tooltip: {
                    enabled: false,
                    external: externalTooltipHandler
                }
            }),
            scales: {
                x: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS.scales.x), {
                    grid: (0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS.scales.x.grid),
                    ticks: (0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS.scales.x.ticks)
                }),
                y: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, FinancialChart_constants_DEFAULT_OPTIONS.scales.y), {
                    ticks: {
                        display: !isEmpty,
                        callback: function callback(value) {
                            return (0,string/* getTransformMoneyUnit */.fs)(value, true);
                        }
                    }
                })
            }
        });
    }, [
        labels,
        isEmpty,
        externalTooltipHandler
    ]);
    var plugins = [
        FinancialChart_constants_TOOLTIP_LINE_PLUGINS,
        FinancialChart_constants_TOOLTIP_CONNECT_DASH
    ];
    return {
        data: data,
        options: options,
        plugins: plugins,
        isInteracted: isInteracted
    };
}

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/Legends/constants.ts
var constants_LEGEND_LIST = [
    {
        id: "매출액",
        type: "salesAmount"
    },
    {
        id: "영업이익",
        type: "operatingIncome"
    },
    {
        id: "당기순이익",
        type: "netIncome"
    }, 
];

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/Legends/style.ts

function FinancialChart_Legends_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          background: #f8ddc7;\n        }\n      "
    ]);
    FinancialChart_Legends_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinancialChart_Legends_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          background: #87519b;\n        }\n      "
    ]);
    FinancialChart_Legends_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinancialChart_Legends_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        &::before {\n          width: 15px;\n          height: 3px;\n          background: #e27893;\n        }\n      "
    ]);
    FinancialChart_Legends_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FinancialChart_Legends_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n\n  ",
        " {\n    margin-bottom: 30px;\n  }\n"
    ]);
    FinancialChart_Legends_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FinancialChart_Legends_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 14px;\n  align-items: center;\n  color: ",
        ";\n  ",
        ";\n\n  &::before {\n    content: '';\n    display: block;\n    width: 9px;\n    height: 9px;\n    margin-right: 7px;\n  }\n\n  ",
        " {\n    margin-right: 32px;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  ",
        "\n"
    ]);
    FinancialChart_Legends_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


function style_getCssByType(type) {
    switch(type){
        case "netIncome":
            return (0,styled_components_browser_esm/* css */.iv)(FinancialChart_Legends_style_templateObject());
        case "operatingIncome":
            return (0,styled_components_browser_esm/* css */.iv)(FinancialChart_Legends_style_templateObject1());
        default:
            return (0,styled_components_browser_esm/* css */.iv)(FinancialChart_Legends_style_templateObject2());
    }
}
var FinancialChart_Legends_style_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b8719c93-0"
})(FinancialChart_Legends_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var FinancialChart_Legends_style_Legend = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b8719c93-1"
})(FinancialChart_Legends_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
}, (0,helper/* getFontStyle */.p)("midium120_C1"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var type = param.type;
    return style_getCssByType(type);
});

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/Legends/index.tsx



function FinancialChart_Legends_Legends() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_Legends_style_Wrapper, {
        children: constants_LEGEND_LIST.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_Legends_style_Legend, {
                type: item.type,
                children: item.id
            }, "financial-chart-legend-".concat(item.type));
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/TooltipFinancial/helper.ts

function TooltipFinancial_helper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translate3d(-100%, -50%, 0);\n      margin-left: -15px;\n\n      &::before {\n        left: auto;\n        right: -7px;\n        border-top: 6px solid transparent;\n        border-bottom: 6px solid transparent;\n        border-left: 7px solid ",
        ";\n      }\n    "
    ]);
    TooltipFinancial_helper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipFinancial_helper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: translate3d(0, -50%, 0);\n    margin-left: 15px;\n\n    &::before {\n      left: -7px;\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      border-right: 7px solid ",
        ";\n    }\n  "
    ]);
    TooltipFinancial_helper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


function TooltipFinancial_helper_getCssByXAlign(xAlign) {
    if (xAlign === "right") {
        return (0,styled_components_browser_esm/* css */.iv)(TooltipFinancial_helper_templateObject(), function(param) {
            var theme = param.theme;
            return theme.colors.magenta700;
        });
    }
    return (0,styled_components_browser_esm/* css */.iv)(TooltipFinancial_helper_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}
function TooltipFinancial_helper_getDateString(date) {
    if (!date) {
        return null;
    }
    if (date.indexOf("Q") >= 0) {
        return date;
    }
    return dayjs(date).format("YYYY.MM");
}

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/TooltipFinancial/style.ts

function TooltipFinancial_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-width: 150px;\n  background: ",
        ";\n  padding: 10px;\n  border-radius: 4px;\n  pointer-events: none;\n  transition: left 0.1s ease, top 0.1s ease, opacity 0.1s ease;\n\n  &::before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translate3d(0, -50%, 0);\n  }\n\n  ",
        ";\n"
    ]);
    TooltipFinancial_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipFinancial_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipFinancial_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TooltipFinancial_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4px;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipFinancial_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TooltipFinancial_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    TooltipFinancial_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TooltipFinancial_style_Wrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return {
        style: {
            left: "".concat($x, "px"),
            top: "".concat($y, "px"),
            opacity: $opacity
        }
    };
}).withConfig({
    componentId: "sc-dfbe908b-0"
})(TooltipFinancial_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var xAlign = param.xAlign;
    return TooltipFinancial_helper_getCssByXAlign(xAlign);
});
var TooltipFinancial_style_Date = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfbe908b-1"
})(TooltipFinancial_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C2"));
var Revenue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfbe908b-2"
})(TooltipFinancial_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_B3"));
var Income = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfbe908b-3"
})(TooltipFinancial_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, (0,helper/* getFontStyle */.p)("bold120_C1"));

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/TooltipFinancial/index.tsx


function TooltipFinancial(param) {
    var year = param.year, salesAmount = param.salesAmount, operatingIncome = param.operatingIncome, netIncome = param.netIncome, xAlign = param.xAlign, $x = param.$x, $y = param.$y, $opacity = param.$opacity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipFinancial_style_Wrapper, {
        $x: $x,
        $y: $y,
        xAlign: xAlign,
        $opacity: $opacity,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipFinancial_style_Date, {
                children: year
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Revenue, {
                children: [
                    "매출액 ",
                    salesAmount
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Income, {
                children: [
                    "영업이익 ",
                    operatingIncome
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Income, {
                children: [
                    "당기순이익 ",
                    netIncome
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/ChartContents/style.ts

function FinancialChart_ChartContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n"
    ]);
    FinancialChart_ChartContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinancialChart_ChartContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 610px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n\n  ",
        " {\n    width: 580px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    FinancialChart_ChartContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinancialChart_ChartContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: ",
        ";\n  transform: translate3d(-50%, -50%, 0);\n  margin-top: -25px;\n  ",
        "\n\n  ",
        " {\n    margin-top: -15px;\n  }\n"
    ]);
    FinancialChart_ChartContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FinancialChart_ChartContents_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-0"
})(FinancialChart_ChartContents_style_templateObject());
var FinancialChart_ChartContents_style_ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-1"
})(FinancialChart_ChartContents_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var FinancialChart_ChartContents_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2829f894-2"
})(FinancialChart_ChartContents_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/ChartContents/index.tsx
















chart/* Chart.register */.kL.register(chartjs_plugin_datalabels_esm/* default */.Z, chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* BarElement */.ZL, chart/* Legend */.De, chart/* PointElement */.od, chart/* LineElement */.jn, chart/* Tooltip */.u);
function FinancialChart_ChartContents_ChartContents(param) {
    var originData = param.data, isEmpty = param.isEmpty;
    var wrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(), tooltipProps = ref[0], setTooltipProps = ref[1];
    var isDisplyGuide = FinancialChart_GuideMessage_hooks_useDisplayTrigger(wrapperRef);
    var externalTooltipHandler = (0,react.useCallback)(function(context) {
        if (context.tooltip.opacity === 0) {
            // @ts-ignore
            setTooltipProps(function(prevState) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                    $opacity: 0
                });
            });
            return;
        }
        var tooltip = context.tooltip;
        var xAlign = tooltip.xAlign, dataPoints = tooltip.dataPoints;
        var _element = dataPoints[0].element, x = _element.x, y = _element.y;
        var _title = (0,_sliced_to_array/* default */.Z)(tooltip.title, 1), year = _title[0];
        if (dataPoints[2] === undefined) {
            setTooltipProps(undefined);
            return;
        }
        var _raw = dataPoints[0].raw, salesAmount = _raw.salesAmount, operatingIncome = _raw.operatingIncome, netIncome = _raw.netIncome;
        var newTooltipProps = {
            $x: x,
            $y: y,
            $opacity: 1,
            xAlign: xAlign,
            salesAmount: (0,string/* getTransformMoneyUnit */.fs)(salesAmount, true),
            operatingIncome: (0,string/* getTransformMoneyUnit */.fs)(operatingIncome, true),
            netIncome: (0,string/* getTransformMoneyUnit */.fs)(netIncome, true),
            year: year
        };
        if (!(0,isEqual/* isEqual */.X)(tooltipProps, newTooltipProps)) setTooltipProps(newTooltipProps);
    }, [
        tooltipProps,
        originData
    ]);
    var ref1 = FinancialChart_hooks_useChartProps({
        originData: originData,
        externalTooltipHandler: externalTooltipHandler,
        isEmpty: isEmpty
    }), data = ref1.data, options = ref1.options, plugins = ref1.plugins, isInteracted = ref1.isInteracted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinancialChart_ChartContents_style_Wrapper, {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_Legends_Legends, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinancialChart_ChartContents_style_ChartContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Line */.x1, {
                                data: data,
                                options: options,
                                plugins: plugins
                            }),
                            tooltipProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipFinancial, (0,src_object_spread/* default */.Z)({}, tooltipProps))
                        ]
                    }),
                    isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_ChartContents_style_NoData, {
                        children: "재무제표 정보가 없습니다."
                    }),
                    !isEmpty && isDisplyGuide && !isInteracted && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_GuideMessage_GuideMessage, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/style.ts

function FinancialChart_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  text-align: center;\n  scroll-margin-top: 200px;\n"
    ]);
    FinancialChart_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinancialChart_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 610px;\n  margin: 0 auto;\n  box-sizing: border-box;\n  position: relative;\n\n  ",
        " {\n    width: 580px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    FinancialChart_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinancialChart_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: ",
        ";\n  transform: translate3d(-50%, -50%, 0);\n  margin-top: -25px;\n  ",
        "\n\n  ",
        " {\n    margin-top: -15px;\n  }\n"
    ]);
    FinancialChart_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FinancialChart_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-0"
})(FinancialChart_style_templateObject());
var FinancialChart_style_ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-1"
})(FinancialChart_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var FinancialChart_style_NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1447ee25-2"
})(FinancialChart_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("bold150_B3"), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/FinancialChart/index.tsx







function FinancialChart(param) {
    var companyId = param.companyId;
    var ref = (0,react.useState)(), chartData = ref[0], setChartData = ref[1];
    var ref1 = (0,react.useState)(), isEmpty = ref1[0], setIsEmpty = ref1[1];
    var ref2 = useCompanyFinancialChartData(companyId), data = ref2.data, status = ref2.status;
    var wrapperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (data) {
            var _source;
            var chartData = (_source = data.financialReport[data.source]) !== null && _source !== void 0 ? _source : [];
            var mergedChartData = TEMPLATE_CHART_DATA.map(function(item) {
                var obj = chartData.find(function(chartObj) {
                    return chartObj.year === item.year;
                });
                if (!obj) {
                    return item;
                }
                return obj;
            });
            var _isEmpty = mergedChartData.every(function(data) {
                return data.salesAmount === null;
            });
            setChartData(mergedChartData);
            setIsEmpty(_isEmpty);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_style_Wrapper, {
        ref: wrapperRef,
        children: status === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart_ChartContents_ChartContents, {
            data: chartData,
            isEmpty: isEmpty
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
    });
};

;// CONCATENATED MODULE: ./src/features/company/SalesInfo/index.tsx





















function SalesInfo(param) {
    var registerRef = param.registerRef, companyStates = param.companyStates;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref6 = hooks_useDropdownSelect(), selectedOption = ref6.selectedOption, handleSelectChange = ref6.handleSelectChange;
    var salesQuery = useGetCompanySales(companyStates.closed, companyId, selectedOption);
    var cardProps = {
        registerRef: registerRef,
        title: "매출",
        sectionId: COMPANY_DETAIL_MENU.SALES,
        rightCardHeader: !(companyStates.closed || companyStates.deleted || !companyStates.sales || !salesQuery.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownSource, {
            value: selectedOption || SalesSource[(ref = salesQuery.data) === null || ref === void 0 ? void 0 : ref.defaultSource],
            emptyValue: !(selectedOption || ((ref1 = salesQuery.data) === null || ref1 === void 0 ? void 0 : ref1.defaultSource)) ? "정보없음" : undefined,
            options: (ref2 = salesQuery.data) === null || ref2 === void 0 ? void 0 : ref2.sourceOption,
            isShowTooltip: false,
            tooltipHelperText: ((ref3 = salesQuery.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.activeSales) === null || ref4 === void 0 ? void 0 : ref4.updatedAt) && salesQuery.data.defaultSource ? "".concat(dayjs_min_default()((ref5 = salesQuery.data) === null || ref5 === void 0 ? void 0 : ref5.activeSales.updatedAt).format("YYYY.MM"), " 기준") : "매출 출처 :",
            onChange: function(value) {
                handleSelectChange(value);
            }
        })
    };
    if ((companyStates === null || companyStates === void 0 ? void 0 : companyStates.closed) || (companyStates === null || companyStates === void 0 ? void 0 : companyStates.deleted)) {
        return null;
    }
    if (!(companyStates === null || companyStates === void 0 ? void 0 : companyStates.sales)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(company_BlockedInfo, {})
        }));
    }
    if (salesQuery.isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
        }));
    }
    if (salesQuery.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalesRateWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_SalesRate, {
                        title: "매출",
                        sales: salesQuery.data.activeSales.total,
                        type: "total"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_SalesRate, {
                        title: "1인당 매출액",
                        tooltipText: "매출액 / 인원수",
                        sales: salesQuery.data.activeSales.perPerson,
                        type: "person"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_SalesRate, {
                        title: "매출액 대비 임금 비율",
                        tooltipText: "매출액 / (평균임금 X 인원수)",
                        sales: salesQuery.data.activeSales.salesSalaryRate,
                        type: "salary"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinancialChartWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySectionTitle, {
                        inlineCss: style_cssTitleChart,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_BadgeNew, {
                                children: "NEW"
                            }),
                            "별도 재무제표 (금감원)",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                width: 240,
                                tooltipText: "별도 재무제표에는 종속기업의 손익이 포함되어 있지 않습니다.",
                                position: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesInfo_style_ChartWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialChart, {
                            companyId: companyId
                        })
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var company_SalesInfo = (SalesInfo);

;// CONCATENATED MODULE: ./src/hooks/query/company/useCompanySummary.tsx



var useCompanySummary_getUrl = function(companyHash) {
    return "/api/company/".concat(companyHash, "/summary");
};
function useGetCompanySummary(companyHash) {
    return (0,index_production.useQuery)([
        queryKeys/* default.companySummary */.Z.companySummary,
        companyHash
    ], function() {
        return (0,fetch/* fetcher */._)(useCompanySummary_getUrl(companyHash));
    }, {
        enabled: !!companyHash
    });
};

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/ClosedContent.tsx

function ClosedContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 48px auto 60px auto;\n\n  & > img {\n    width: 120px;\n    margin-bottom: 8px;\n  }\n\n  & > span {\n    color: ",
        ";\n  }\n"
    ]);
    ClosedContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function ClosedContent(param) {
    var closedDate = param.closedDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClosedContent_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://image.wanted.co.kr/kreditjob/www/tear.png",
                alt: "sad face"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                typography: "bold120_B2",
                children: [
                    "폐업된 기업입니다.",
                    closedDate && "(".concat(dayjs_min_default()(closedDate).format("YYYY.MM.DD"), ")")
                ]
            })
        ]
    });
}
/* harmony default export */ var SummaryInfo_ClosedContent = (ClosedContent);
var ClosedContent_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c81bc47-0"
})(ClosedContent_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/DeletedContent.tsx

function DeletedContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 48px auto 60px auto;\n\n  & > img {\n    width: 120px;\n    margin-bottom: 8px;\n  }\n\n  & > span {\n    color: ",
        ";\n  }\n"
    ]);
    DeletedContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function DeletedContent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeletedContent_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://image.wanted.co.kr/kreditjob/www/sigh.png",
                alt: "sigh face"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                typography: "midium120_B1",
                children: "더 이상 유효하지 않은 기업입니다."
            })
        ]
    });
}
/* harmony default export */ var SummaryInfo_DeletedContent = (DeletedContent);
var DeletedContent_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a4e0031-0"
})(DeletedContent_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/style.ts

function SummaryInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fafafa;\n  border-radius: 4px;\n  height: 60px;\n  padding: auto 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > span:not(:last-child) {\n    margin-right: 10px;\n  }\n\n  ",
        " {\n    & > span:not(:last-child) {\n      ",
        "\n    }\n\n    & > span:last-child {\n      ",
        "\n    }\n  }\n"
    ]);
    SummaryInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 200px;\n  align-items: center;\n\n  & > div {\n    width: 160px; // 애니메이션 작업하면서 수정\n    height: 100px;\n    margin-bottom: 10px;\n  }\n\n  ",
        " {\n    max-width: 100%;\n    flex-direction: row;\n    justify-content: center;\n\n    & > div {\n      width: 112px; // 애니메이션 작업하면서 수정\n      height: 70px;\n      margin-bottom: 10px;\n    }\n  }\n"
    ]);
    SummaryInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  .emphasize {\n    color: #d63461;\n  }\n\n  & > ",
        ":not(:last-child) {\n    margin-right: 100px;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    ",
        "\n\n    & > ",
        ":not(:last-child) {\n      margin: 0;\n    }\n  }\n"
    ]);
    SummaryInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  padding: 20px;\n  text-align: left;\n\n  & > span:not(:last-child) {\n    margin-bottom: 7px;\n  }\n\n  & > span:last-child {\n    text-align: right;\n    color: #7d7d7d;\n    margin-top: auto;\n  }\n\n  ",
        " {\n    min-width: 250px;\n  }\n"
    ]);
    SummaryInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overscroll-behavior: contain;\n  mouse-wheel: horizontal;\n  padding: 0 30px;\n\n  ",
        " {\n    padding: 0 20px;\n  }\n\n  & > ",
        ":not(:last-child) {\n    margin-right: 15px;\n  }\n\n  ",
        " {\n    overflow-x: scroll;\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    SummaryInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 30px;\n\n  ",
        " {\n    padding: 0 20px;\n  }\n"
    ]);
    SummaryInfo_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0 0 0;\n\n  & > div > ",
        " {\n    margin-top: 45px;\n  }\n\n  & > ",
        " {\n    margin-top: 56px;\n  }\n\n  ",
        " {\n    & > div > ",
        " {\n      margin-top: 28px;\n    }\n\n    & > ",
        " {\n      margin-top: 28px;\n    }\n  }\n"
    ]);
    SummaryInfo_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  &::before {\n    content: '-';\n    margin-right: 10px;\n  }\n"
    ]);
    SummaryInfo_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  gap: 8px;\n  width: 731px;\n\n  ",
        " {\n    width: 100%;\n    max-width: 640px;\n    margin: 0 auto;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    width: 100%;\n    gap: 0px;\n  }\n"
    ]);
    SummaryInfo_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    SummaryInfo_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 256px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 30px;\n\n    ",
        " {\n      width: unset;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: flex-start;\n    }\n  "
    ]);
    SummaryInfo_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SummaryInfo_style_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    img {\n      width: 40px;\n      height: 40px;\n    }\n    ",
        " {\n      flex-direction: row;\n      img {\n        width: 16px;\n        height: 16px;\n        margin-right: 4px;\n      }\n    }\n  "
    ]);
    SummaryInfo_style_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function style_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n      "
    ]);
    style_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function style_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n\n    ",
        "\n    ",
        " {\n      span {\n        order: 2;\n      }\n\n      div {\n        order: 1;\n      }\n    }\n  "
    ]);
    style_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function style_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    margin-bottom: 3px;\n    margin-top: 16px;\n\n    ",
        " {\n      margin: 0;\n\n      ",
        "\n    }\n  "
    ]);
    style_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function style_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    ",
        " {\n      align-items: flex-end;\n      gap: 8px;\n    }\n  "
    ]);
    style_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function style_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    border-radius: 4px;\n    padding: 0 4px;\n    margin-left: 4px;\n    ",
        ";\n\n    ",
        " {\n      margin: 0;\n      margin-right: 4px;\n\n      ",
        ";\n    }\n  "
    ]);
    style_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function style_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 35px;\n    margin: 16px 0;\n\n    ",
        " {\n      height: 100%;\n      margin: 0;\n    }\n  "
    ]);
    style_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          &:nth-child(2) {\n            color: ",
        ";\n            ",
        "\n          }\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: ",
        ";\n\n    &:nth-child(2) {\n      margin-top: 4px;\n    }\n\n    span {\n      ",
        "\n\n      &:nth-child(1) {\n        margin-right: 4px;\n      }\n\n      &:nth-child(3) {\n        margin-left: 4px;\n      }\n    }\n\n    ",
        " {\n      justify-content: flex-end;\n      &:nth-child(2) {\n        margin-top: 8px;\n      }\n      span {\n        font-size: 14px;\n        line-height: 17px;\n      }\n    }\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n\n    div {\n      margin-left: 5px;\n    }\n    ",
        " {\n      ",
        "\n    }\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}



var style_Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-0"
})(SummaryInfo_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, (0,helper/* getFontStyle */.p)("bold120_B3"), (0,helper/* getFontStyle */.p)("bold120_T1"));
var Record = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-1"
})(SummaryInfo_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var EmphasizeAnimation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-2"
})(SummaryInfo_style_templateObject2(), Record, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, (0,helper/* getFontStyle */.p)("bold120_B3"), Record);
var InfoBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-3"
})(SummaryInfo_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var InfoBlockWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-4"
})(SummaryInfo_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, InfoBlock, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CardContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-5"
})(SummaryInfo_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var SummaryInfo_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-6"
})(SummaryInfo_style_templateObject6(), EmphasizeAnimation, InfoBlockWrapper, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, EmphasizeAnimation, InfoBlockWrapper);
var SubText = (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
    componentId: "sc-fe4d2dab-7"
})(SummaryInfo_style_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var CompanySummaryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-8"
})(SummaryInfo_style_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CompanySummaryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe4d2dab-9"
})(SummaryInfo_style_templateObject9());
var SummaryInfo_style_S = {
    SummaryCardItem: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-10"
    })(SummaryInfo_style_templateObject10(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Label: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-11"
    })(SummaryInfo_style_templateObject11(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    TitleWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-12"
    })(style_templateObject13(), function(props) {
        return props.isEmpty && (0,styled_components_browser_esm/* css */.iv)(style_templateObject12(), function(param) {
            var theme = param.theme;
            return theme.colors.gray600;
        });
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Title: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-fe4d2dab-13"
    })(style_templateObject14(), function(param) {
        var theme = param.theme;
        return theme.colors.gray700;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, (0,helper/* getFontStyle */.p)("midium150_B3")),
    Content: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-14"
    })(style_templateObject15(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Badge: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-15"
    })(style_templateObject16(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta100;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    }, (0,helper/* getFontStyle */.p)("bold150_C1"), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, (0,helper/* getFontStyle */.p)("bold150_B3")),
    SubTitleWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-16"
    })(style_templateObject17(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    SubTitle: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-fe4d2dab-17"
    })(_templateObject19(), function(param) {
        var theme = param.theme;
        return theme.colors.greynavy300;
    }, function(props) {
        return props.isEmpty && (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), function(param) {
            var theme = param.theme;
            return theme.colors.greynavy100;
        }, (0,helper/* getFontStyle */.p)("midium120_C1"));
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Source: (0,styled_components_browser_esm/* default */.ZP)(components_Text/* default */.Z).withConfig({
        componentId: "sc-fe4d2dab-18"
    })(_templateObject20(), function(param) {
        var theme = param.theme;
        return theme.colors.gray700;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }, (0,helper/* getFontStyle */.p)("midium150_B3"))
};

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/EmployeeCard.tsx












function EmployeeCard(param) {
    var employee = param.employee, companyStates = param.companyStates;
    var employeeDisplay = function employeeDisplay(employeeData, type) {
        if (type === "percent") {
            return (0,formatted_number/* parseToPercent */.lz)(employeeData, 0);
        }
        return (0,isEmpty/* isEmpty */.x)(employeeData) ? "정보없음" : "".concat(employeeData.toLocaleString(), "명");
    };
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var _rate;
    var rate = (0,company/* getSalaryRate */.k3)((_rate = employee.rate) !== null && _rate !== void 0 ? _rate : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SummaryCardItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Label, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/".concat(isMobile ? "employee_m.png" : "employee.png"),
                        alt: "money"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Title, {
                        typography: "midium150_C1",
                        children: "총 인원"
                    })
                ]
            }),
            companyStates.employee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.TitleWrapper, {
                        isEmpty: (0,isEmpty/* isEmpty */.x)(employee.total),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                typography: isMobile ? "bold150_T1" : "bold150_B1",
                                children: employeeDisplay(employee.total, "number")
                            }),
                            rate && rate <= 50 && !(0,isEmpty/* isEmpty */.x)(employee.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Badge, {
                                children: [
                                    "상위 ",
                                    rate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitle, {
                                isEmpty: (0,isEmpty/* isEmpty */.x)(employee.left),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "midium120_C1",
                                        children: "퇴사"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: employeeDisplay(employee.left, "number")
                                    }),
                                    !(0,isEmpty/* isEmpty */.x)(employee.leftRate) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: [
                                            "(",
                                            employeeDisplay(employee.leftRate, "percent"),
                                            "%)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitle, {
                                isEmpty: (0,isEmpty/* isEmpty */.x)(employee.hired),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "midium120_C1",
                                        children: "입사"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: employeeDisplay(employee.hired, "number")
                                    }),
                                    !(0,isEmpty/* isEmpty */.x)(employee.hiredRate) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: [
                                            "(",
                                            employeeDisplay(employee.hiredRate, "percent"),
                                            "%)"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Source, {
                        typography: "midium150_C1",
                        children: [
                            "출처 :",
                            " ",
                            employee.source ? "".concat(COMPANY_SOURCE[employee.source], " ").concat(dayjs_min_default()(employee.updatedAt).format("YYYY.MM"), " ") : "정보없음",
                            employee.updatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                tooltipText: "퇴사율과 인원증가율은 최근 1년을 기준으로 합니다.",
                                position: isMobile ? "right" : "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationMark/* default */.Z, {
                                    width: 15,
                                    color: theme.colors.gray700
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                    typography: isMobile ? "bold150_T1" : "bold150_B1",
                    children: "비공개"
                })
            })
        ]
    });
}
/* harmony default export */ var SummaryInfo_EmployeeCard = (EmployeeCard);

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/SalaryCard.tsx









function SalaryCard(param) {
    var salary = param.salary, companyStates = param.companyStates;
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var _rate;
    var rate = (0,company/* getSalaryRate */.k3)((_rate = salary.rate) !== null && _rate !== void 0 ? _rate : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SummaryCardItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Label, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/".concat(isMobile ? "money_m.png" : "money.png"),
                        alt: "money"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Title, {
                        typography: "midium150_C1",
                        children: "예상평균연봉"
                    })
                ]
            }),
            companyStates.salary ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.TitleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                typography: isMobile ? "bold150_T1" : "bold150_B1",
                                children: (0,isEmpty/* isEmpty */.x)(salary.salary) ? "수집 중.." : "".concat((0,formatted_number/* millionFormattedtoString */.X6)(salary.salary), "만원")
                            }),
                            rate && rate <= 50 && !(0,isEmpty/* isEmpty */.x)(salary.salary) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Badge, {
                                children: [
                                    "상위 ",
                                    rate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.SubTitleWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                    typography: "midium120_C1",
                                    children: "월 세전 "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                    typography: "bold120_C1",
                                    children: (0,isEmpty/* isEmpty */.x)(salary.salary) ? "수집 중.." : "".concat((0,formatted_number/* millionFormattedtoString */.X6)(Number(salary.salary) / 12).toLocaleString(), "만원")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Source, {
                        typography: "midium150_C1",
                        children: "출처 : ".concat((0,isEmpty/* isEmpty */.x)(salary.source) ? "정보없음" : "".concat(COMPANY_SOURCE[salary.source], " ").concat(salary.updatedAt ? dayjs_min_default()(salary.updatedAt).format("YYYY.MM") : ""))
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                    typography: isMobile ? "bold150_T1" : "bold150_B1",
                    children: "비공개"
                })
            })
        ]
    });
}
/* harmony default export */ var SummaryInfo_SalaryCard = (SalaryCard);

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/SalesCard.tsx









function SalesCard(param) {
    var sales = param.sales, companyStates = param.companyStates;
    var displaySales = function displaySales(salesData, type) {
        if (typeof salesData !== "number" || !salesData || salesData === 0) {
            return "정보없음";
        }
        return (0,formatted_number/* numberToKorean */.Ak)(salesData, type);
    };
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var _rate;
    var rate = (0,company/* getSalaryRate */.k3)((_rate = sales.rate) !== null && _rate !== void 0 ? _rate : 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SummaryCardItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Label, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/".concat(isMobile ? "sales_m.png" : "sales.png"),
                        alt: "money"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Title, {
                        typography: "midium150_C1",
                        children: "총 매출액"
                    })
                ]
            }),
            companyStates.sales ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.TitleWrapper, {
                        isEmpty: (0,isEmpty/* isEmpty */.x)(sales.total),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                typography: isMobile ? "bold150_T1" : "bold150_B1",
                                children: displaySales(sales.total, "total")
                            }),
                            rate && rate <= 50 && !(0,isEmpty/* isEmpty */.x)(sales.total) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Badge, {
                                children: [
                                    "상위 ",
                                    rate,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitle, {
                                isEmpty: (0,isEmpty/* isEmpty */.x)(sales.perPerson),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "midium120_C1",
                                        children: "1인당 매출액"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: displaySales(sales.perPerson, "person")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.SubTitle, {
                                isEmpty: (0,isEmpty/* isEmpty */.x)(sales.salesSalaryRate),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "midium120_C1",
                                        children: "매출 대비 임금"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                                        typography: "bold120_C1",
                                        children: displaySales(sales.salesSalaryRate, "salary")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryInfo_style_S.Source, {
                        typography: "midium150_C1",
                        children: [
                            "출처 :",
                            " ",
                            !(0,isEmpty/* isEmpty */.x)(sales.source) && !(0,isEmpty/* isEmpty */.x)(sales.total) ? "".concat(SalesSource[sales.source], " ").concat(sales.updatedAt ? dayjs_min_default()(sales.updatedAt).format("YYYY.MM") : "") : "정보없음"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_style_S.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Text/* default */.Z, {
                    typography: isMobile ? "bold150_T1" : "bold150_B1",
                    children: "비공개"
                })
            })
        ]
    });
}
/* harmony default export */ var SummaryInfo_SalesCard = (SalesCard);

;// CONCATENATED MODULE: ./src/features/company/SummaryInfo/index.tsx















function SummaryInfo(param) {
    var registerRef = param.registerRef, companyStates = param.companyStates;
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = useGetCompanySummary(companyId), data = ref.data, status = ref.status;
    var cardProps = {
        title: "기업 요약",
        registerRef: registerRef,
        sectionId: COMPANY_DETAIL_MENU.COMPANY_SUMMARY
    };
    if (status === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection, {})
        }));
    }
    if (status === "loading") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        }));
    }
    if (companyStates.deleted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_DeletedContent, {})
        }));
    }
    if (companyStates.closed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_ClosedContent, {
                closedDate: companyStates.closedAt
            })
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Card, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, cardProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanySummaryWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_SalaryCard, {
                    salary: data.salary,
                    companyStates: companyStates
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_EmployeeCard, {
                    employee: data.employee,
                    companyStates: companyStates
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryInfo_SalesCard, {
                    sales: data.sales,
                    companyStates: companyStates
                })
            ]
        })
    }));
}
/* harmony default export */ var company_SummaryInfo = (SummaryInfo);

;// CONCATENATED MODULE: ./src/hooks/query/company/useWantedJobPosting.ts



function useWantedJobPosting(id) {
    return (0,index_production.useQuery)([
        queryKeys/* default.wantedJobPosting */.Z.wantedJobPosting,
        id
    ], function() {
        return (0,fetch/* fetcher */._)("https://www.wanted.co.kr/api/v1/company_briefs?kreditjob_pk=".concat(id));
    }, {
        enabled: !!id
    });
};

// EXTERNAL MODULE: ./src/lib/styles/Theme/common.ts
var common = __webpack_require__(55153);
;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/CompanyCard/style.ts

function CompanyCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 65px;\n  padding: 0 16px;\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n"
    ]);
    CompanyCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyCard_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ",
        ";\n"
    ]);
    CompanyCard_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyCard_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 45px;\n  width: 45px;\n  height: 45px;\n  margin-right: 12px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n\n  img {\n    width: 38px;\n  }\n"
    ]);
    CompanyCard_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyCard_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-right: 10px;\n  ",
        ";\n"
    ]);
    CompanyCard_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CompanyCard_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2px;\n  ",
        ";\n  ",
        ";\n"
    ]);
    CompanyCard_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CompanyCard_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    CompanyCard_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CompanyCard_style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a4521cc-0"
})(CompanyCard_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var LeftArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a4521cc-1"
})(CompanyCard_style_templateObject1(), common/* ellipsis */.LH);
var style_Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a4521cc-2"
})(CompanyCard_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var style_CompanyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a4521cc-3"
})(CompanyCard_style_templateObject3(), common/* ellipsis */.LH);
var CompanyName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5a4521cc-4"
})(CompanyCard_style_templateObject4(), (0,helper/* getFontStyle */.p)("bold120_B3"), common/* ellipsis */.LH);
var Address = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5a4521cc-5"
})(CompanyCard_style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium120_C1"), common/* ellipsis */.LH);

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/CompanyCard/index.tsx




function CompanyCard(param) {
    var PK_NM_HASH = param.PK_NM_HASH, companyName = param.companyName, isRecommended = param.isRecommended, location = param.location, linkMore = param.linkMore, logoThumbnail = param.logoThumbnail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyCard_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Logo, {
                        children: !logoThumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: "company_logo",
                            src: "https://static.wanted.co.kr/images/kj/default_company_logo.png",
                            width: 40,
                            style: {
                                width: "25px"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoThumbnail,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_CompanyInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyName, {
                                children: companyName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                children: location
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "magenta",
                size: "sm",
                as: "a",
                href: linkMore,
                target: "_blank",
                "data-attribute-id": "company__position__seeMore",
                "data-company-name": companyName,
                "data-company-hash": PK_NM_HASH,
                "data-connection": isRecommended ? "추천기업 채용 공고" : "채용 공고",
                children: "더 많은 공고 보기"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/hooks.tsx


function hooks_useCompanyInfo(param) {
    var wantedJobPosting = param.wantedJobPosting, PK_NM_HASH = param.PK_NM_HASH;
    if (!wantedJobPosting) {
        return {};
    }
    return {
        sectionTitle: (wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.is_recommended) ? "추천기업 채용 공고" : "채용 공고",
        rightCardHeader: wantedJobPosting.is_recommended ? undefined : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "magenta",
            size: "sm",
            as: "a",
            href: "https://www.wanted.co.kr/company/".concat(wantedJobPosting.company.id),
            target: "_blank",
            "data-attribute-id": "company__position__seeMore",
            "data-company-name": wantedJobPosting.company.name,
            "data-company-hash": wantedJobPosting.PK_NM_HASH,
            "data-connection": wantedJobPosting.is_recommended ? "추천기업 채용 공고" : "채용 공고",
            children: "더 많은 공고 보기"
        }),
        linkMore: "https://www.wanted.co.kr/company/".concat(wantedJobPosting.company.id)
    };
}

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/JobPostingCard/style.ts

function JobPostingCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 230px;\n  height: 60px;\n  padding: 12px 16px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  ",
        ";\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    JobPostingCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobPostingCard_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    JobPostingCard_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function JobPostingCard_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4px;\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    JobPostingCard_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function JobPostingCard_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    JobPostingCard_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var JobPostingCard_style_Wrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-f60e07ca-0"
})(JobPostingCard_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, common/* ellipsis */.LH, function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f60e07ca-1"
})(JobPostingCard_style_templateObject1());
var JobPostingCard_style_Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-f60e07ca-2"
})(JobPostingCard_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, (0,helper/* getFontStyle */.p)("bold120_B3"), common/* ellipsis */.LH);
var Reward = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f60e07ca-3"
})(JobPostingCard_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, (0,helper/* getFontStyle */.p)("midium120_C1"), common/* ellipsis */.LH);

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/JobPostingCard/index.tsx



function JobPostingCard(param) {
    var PK_NM_HASH = param.PK_NM_HASH, companyName = param.name, isRecommended = param.is_recommended, position = param.position, reward = param.reward, href = param.href, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostingCard_style_Wrapper, {
        href: href,
        onClick: onClick,
        target: "_blank",
        "data-attribute-id": "company__position__click",
        "data-company-hash": PK_NM_HASH,
        "data-company-name": companyName,
        "data-connection": isRecommended ? "추천기업 채용 공고" : "채용 공고",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostingCard_style_Title, {
                    children: position
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Reward, {
                    children: [
                        "채용 보상금: ",
                        (0,formatted_number/* formattedMoney */.gR)(reward),
                        " 원"
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/style.ts

function WantedJobPostingInfo_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    WantedJobPostingInfo_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WantedJobPostingInfo_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 234px;\n  height: 136px;\n  background-color: ",
        ";\n  border-radius: 4px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  ",
        " {\n    flex: 0 0 auto;\n  }\n"
    ]);
    WantedJobPostingInfo_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WantedJobPostingInfo_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    WantedJobPostingInfo_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WantedJobPostingInfo_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        grid-template-columns: 1fr;\n      "
    ]);
    WantedJobPostingInfo_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WantedJobPostingInfo_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr 1fr;\n  width: 100%;\n  margin-left: 16px;\n\n  ",
        " {\n    margin-left: 0;\n    margin-top: 16px;\n\n    ",
        "\n  }\n"
    ]);
    WantedJobPostingInfo_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var WantedJobPostingInfo_style_Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfac5543-0"
})(WantedJobPostingInfo_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Poster = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfac5543-1"
})(WantedJobPostingInfo_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CompanyCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfac5543-2"
})(WantedJobPostingInfo_style_templateObject2());
var JobList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfac5543-3"
})(WantedJobPostingInfo_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var length = param.length;
    return length <= 1 && (0,styled_components_browser_esm/* css */.iv)(WantedJobPostingInfo_style_templateObject3());
});

;// CONCATENATED MODULE: ./src/features/company/WantedJobPostingInfo/index.tsx







function WantedJobPostingInfo(param) {
    var companyId = param.companyId, isRecommended = param.isRecommended;
    var ref = useWantedJobPosting(companyId), wantedJobPosting = ref.data;
    var ref1 = hooks_useCompanyInfo({
        wantedJobPosting: wantedJobPosting,
        PK_NM_HASH: companyId
    }), sectionTitle = ref1.sectionTitle, rightCardHeader = ref1.rightCardHeader, linkMore = ref1.linkMore;
    if (isRecommended !== (wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.is_recommended)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_Card, {
        sectionId: "watned-job-posting",
        title: sectionTitle,
        rightCardHeader: rightCardHeader,
        style: {
            marginTop: "16px"
        },
        children: [
            (wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.is_recommended) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCardWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCard, {
                    PK_NM_HASH: companyId,
                    companyName: wantedJobPosting.company.name,
                    isRecommended: wantedJobPosting.is_recommended,
                    location: wantedJobPosting.company.location,
                    logoThumbnail: wantedJobPosting.company.logo_thumb_img,
                    linkMore: linkMore
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WantedJobPostingInfo_style_Contents, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Poster, {
                        children: (wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.company.title_img) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.company.title_img,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobList, {
                        length: wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.company.jobs.length,
                        children: wantedJobPosting === null || wantedJobPosting === void 0 ? void 0 : wantedJobPosting.company.jobs.slice(0, 4).map(function(job) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostingCard, {
                                position: job.position,
                                reward: job.reward,
                                href: "https://www.wanted.co.kr/wd/".concat(job.id),
                                PK_NM_HASH: companyId,
                                name: wantedJobPosting.company.name,
                                is_recommended: wantedJobPosting.is_recommended
                            }, job.id);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/company/CompanyPage/style.ts

function CompanyPage_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    CompanyPage_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyPage_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 30px auto 0;\n  padding-bottom: 30px;\n  max-width: ",
        "px;\n  min-height: 366px;\n  position: relative;\n  box-sizing: content-box;\n\n  ",
        " {\n    width: 100%;\n    padding: 0 32px 30px;\n    box-sizing: border-box;\n  }\n\n  ",
        " {\n    min-height: inherit;\n    padding: 0;\n    margin-top: 16px;\n  }\n\n  & > section {\n    margin-bottom: 32px;\n\n    ",
        " {\n      margin-bottom: 16px;\n    }\n  }\n"
    ]);
    CompanyPage_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyPage_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 310px;\n  right: 0;\n  top: 0;\n\n  ",
        " {\n    position: relative;\n    width: 100%;\n    top: auto;\n    right: auto;\n  }\n"
    ]);
    CompanyPage_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompanyPage_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 33px;\n\n  ",
        " {\n    width: 300px;\n    margin: 0 auto;\n  }\n"
    ]);
    CompanyPage_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CompanyPage_style_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3abb950b-0"
})(CompanyPage_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray200;
});
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3abb950b-1"
})(CompanyPage_style_templateObject1(), layout/* DESKTOP_WIDTH */.JH, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var style_Aside = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3abb950b-2"
})(CompanyPage_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CompanyPage_style_GoogleAdsBanner = (0,styled_components_browser_esm/* default */.ZP)(GoogleAdsBanner/* default */.Z).withConfig({
    componentId: "sc-3abb950b-3"
})(CompanyPage_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});

;// CONCATENATED MODULE: ./src/features/company/CompanyPage/index.tsx























react_ab_test.emitter.addPlayListener(function(experimentName, variantName) {
    (0,thirdPartyEvent/* setAmplitudeUserProperties */.$Y)({
        abTest_company_community: variantName
    });
});
function CompanyPage() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var companyId = (0,useRouterQuery/* useRouterQuery */.o)("companyId");
    var ref = (0,useCompanyStates/* default */.Z)(companyId), companyStates = ref.data, companyStatesStatus = ref.status;
    var ref1 = (0,useCompanyInfo/* default */.Z)(companyId), companyInfo = ref1.data, companyInfoStatus = ref1.status;
    var ref2 = hooks_useCardObserver(), registerRef = ref2.registerRef, selectedMenu = ref2.selectedMenu;
    var endOfWrapperRef = (0,react.useRef)(null);
    if (companyInfoStatus === "error" || companyStatesStatus === "error") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage, {});
    }
    if (!companyStates) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyPage_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Header, {
                selectedMenu: selectedMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_SummaryInfo, {
                        registerRef: registerRef,
                        companyStates: companyStates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {
                        targetRef: endOfWrapperRef,
                        companyInfo: companyInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewInfo, {
                        registerRef: registerRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InterviewReviewInfo, {
                        registerRef: registerRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WantedJobPostingInfo, {
                        companyId: companyId,
                        isRecommended: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_EmployeeInfo, {
                        registerRef: registerRef,
                        companyStates: companyStates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_SalaryInfo, {
                        registerRef: registerRef,
                        companyStates: companyStates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_SalesInfo, {
                        registerRef: registerRef,
                        companyStates: companyStates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_ab_test.Experiment, {
                        name: "abTest_company_community",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_ab_test.Variant, {
                                name: "A",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobdomInfo, {
                                    registerRef: registerRef
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_ab_test.Variant, {
                                name: "B",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WantedJobPostingInfo, {
                        companyId: companyId,
                        isRecommended: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "data-attribute-id": "company__banner__click",
                        "data-banner-location": "bottom",
                        "data-banner-type": "ads",
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage_style_GoogleAdsBanner, {
                            bannerType: "mobileBanner",
                            slotId: "8076432031"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage_style_GoogleAdsBanner, {
                            bannerType: "leaderBoard",
                            slotId: "8397610632"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageCompanyInfo, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: endOfWrapperRef
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/company/[companyId]/index.tsx











var ServerSideError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(ServerSideError, Error1);
    var _super = (0,_create_super/* default */.Z)(ServerSideError);
    function ServerSideError(message) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            params[_key - 1] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ServerSideError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(params)));
        _this.message = message;
        _this.name = "ServerSideError";
        return _this;
    }
    return ServerSideError;
}((0,_wrap_native_super/* default */.Z)(Error));
function Company(param) {
    var title = param.title, description = param.description, url = param.url, companyId = param.companyId, companyName = param.companyName, companyCategory = param.companyCategory, companyIndustry = param.companyIndustry, companyJobRecommended = param.companyJobRecommended;
    (0,react.useEffect)(function() {
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__view", {
            companyName: companyName,
            companyHash: companyId,
            companyType: companyCategory,
            companyIndustry: companyIndustry,
            connection: companyJobRecommended ? "추천기업 채용 공고" : "채용 공고"
        });
    }, [
        companyId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }, "og-title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }, "og-description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: url
                    }, "og-url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://image.wanted.co.kr/kreditjob/www/sns-share-company.jpg"
                    }, "og-image")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderOnClient/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPage, {})
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _companyId_ = (Company);


/***/ }),

/***/ 28554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports isClipboardSupported, copyToClipboard */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _home_runner_work_kreditjob_front_kreditjob_front_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_kreditjob_front_kreditjob_front_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_kreditjob_front_kreditjob_front_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var isClipboardSupported = function() {
    return (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) != null;
};
/**
 * 인자로 받은 텍스트를 클립보드에 복사합니다.
 *
 * @example
 * ```ts
 * const result = await copyToClipboard('하이');
 * if (result) {
 *   console.log('클립보드에 복사 성공');
 * } else {
 *   console.log('클립보드에 복사 실패');
 * }
 * ```
 */ var copyToClipboard = function(text) {
    return new Promise(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_runner_work_kreditjob_front_kreditjob_front_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve) {
            return _home_runner_work_kreditjob_front_kreditjob_front_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isClipboardSupported()) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return navigator.clipboard.writeText(text);
                    case 3:
                        resolve(true);
                        return _ctx.abrupt("return");
                    case 5:
                        resolve(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(resolve) {
            return _ref.apply(this, arguments);
        };
    }());
};
/* harmony default export */ __webpack_exports__["ZP"] = (copyToClipboard);


/***/ }),

/***/ 52794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": function() { return /* binding */ getPercentage; },
/* harmony export */   "fs": function() { return /* binding */ getTransformMoneyUnit; },
/* harmony export */   "vS": function() { return /* binding */ textEllipsis; }
/* harmony export */ });
/* unused harmony export getMoneyUnit */
/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23230);

function textEllipsis(str, index) {
    if (str.length <= index) {
        return str;
    }
    var result = str.trim().substring(0, index);
    return result.trim() + "...";
}
/**
 * 값에 따라 금액단위 반환
 * @param value
 * @returns
 */ function getMoneyUnit(value) {
    if (value < 1e8 && value >= 1e4) {
        return "만";
    }
    if (value < 1e12 && value >= 1e8) {
        return "억";
    }
    if (value >= 1e12) {
        return "조";
    }
    return "";
}
/**
 * 값에 따라 만원,억,조 단위 문자열로 변환
 *
 * @param value
 * @param round
 * @param prefix
 * @returns
 */ function getTransformMoneyUnit(value, round) {
    var prefix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var absoluteValue = Math.abs(value);
    var unit = getMoneyUnit(absoluteValue);
    var divider;
    if (absoluteValue / 1e12 >= 1) {
        divider = 1e12;
    } else if (absoluteValue / 1e8 >= 1) {
        divider = 1e8;
    } else if (absoluteValue / 1e4 >= 1) {
        divider = 1e4;
    } else {
        divider = 1;
    }
    var rest = Math.abs(value % divider);
    var moneyValue = value / divider;
    var validValue = Number(Math.sign(moneyValue) * Math.floor(Math.abs(moneyValue))).toLocaleString();
    prefix.push("".concat(validValue).concat(unit));
    if (round) {
        return "".concat((0,_number__WEBPACK_IMPORTED_MODULE_0__/* .toFixedWithoutRound */ .Vd)(moneyValue, 1).toLocaleString()).concat(unit);
    }
    if (rest === 0) {
        return "".concat(prefix.join(" ")).trim();
    }
    return getTransformMoneyUnit(rest, round, prefix);
}
/**
 * 백분율값 반환
 * @param percentage
 * @param fixed
 * @returns number
 */ function getPercentage(number) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var value = number * 100;
    return (0,_number__WEBPACK_IMPORTED_MODULE_0__/* .toFixedWithoutRound */ .Vd)(value, fixed);
}


/***/ }),

/***/ 56852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ typedArrayTypeNames; },
/* harmony export */   "QV": function() { return /* binding */ primitiveTypes; },
/* harmony export */   "oL": function() { return /* binding */ getType; }
/* harmony export */ });
var primitiveTypes = [
    "[object Boolean]",
    "[object String]",
    "[object Number]",
    "[object Null]",
    "[object Undefined]", 
];
var typedArrayTypeNames = [
    "[object BigInt64Array]",
    "[object BigUint64Array]",
    "[object Float32Array]",
    "[object Float64Array]",
    "[object Int16Array]",
    "[object Int32Array]",
    "[object Int8Array]",
    "[object Uint16Array]",
    "[object Uint32Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]", 
];
function getType(value) {
    var toString = Object.prototype.toString;
    return toString.call(value);
}


/***/ }),

/***/ 8892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ isSet; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "_N": function() { return /* binding */ isMap; },
/* harmony export */   "fU": function() { return /* binding */ isTypedArray; },
/* harmony export */   "kK": function() { return /* binding */ isNil; },
/* harmony export */   "ty": function() { return /* binding */ isPrimitiveType; }
/* harmony export */ });
/* unused harmony exports is, isString, isNumber, isBoolean */
/* harmony import */ var _internal_getType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56852);

/**
 * 타입가드를 편하게 사용할 수 있는 유틸 함수 입니다.
 *
 * 하지만 타입 가딩을 하는 타입이 string | number <=> string과 같은 서브타입 관계가 아니더라도, 이 함수는 그대로 타입가드를 적용하기 때문에 Type Safely하지 않은 상황이 발생할 수 있습니다.
 *
 * 이 함수를 사용하면 반드시 타입 가딩 이후에 타입이 어떻게 평가되었는지 확인해주세요.
 */ function is(value, validator) {
    return validator(value);
}
/**
 * 인자로 받은 값이 String 타입인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * isString('foo'); // true
 * ```
 */ function isString(value) {
    return getType(value) === "[object String]";
}
/**
 * 인자로 받은 값이 Number 타입인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * isNumber(-1); // true
 * ```
 */ function isNumber(value) {
    return getType(value) === "[object Number]";
}
/**
 * 인자로 받은 값이 Boolean 타입인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * isBoolean(false); // true
 * ```
 */ function isBoolean(value) {
    return getType(value) === "[object Boolean]";
}
/**
 * isNil 은 value가 null, undefined 인지 확인해주는 함수입니다.
 *
 * @example
 * ```ts
 * isNil(null); // true
 * isNil(void 0); // true
 * isNil(NaN); // false
 * ```
 */ function isNil(value) {
    return value === null || value === undefined;
}
/**
 * 인자로 받은 값이 원시 자료형인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * isPrimitiveType('') // true
 * isPrimitiveType(1) // true
 * isPrimitiveType(false) // true
 * isPrimitiveType(NaN) // true
 * isPrimitiveType({}) // false
 * isPrimitiveType([]) // false
 * ```
 */ function isPrimitiveType(value) {
    return _internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .primitiveTypes.includes */ .QV.includes((0,_internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(value));
}
/**
 * 인자로 받은 값이 Map인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * const map = new Map();
 * isMap(map); // true
 * ```
 */ function isMap(value) {
    return (0,_internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(value) === "[object Map]";
}
/**
 * 인자로 받은 값이 Set인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * const set = new Set();
 * isSet(set); // true
 * ```
 */ function isSet(value) {
    return (0,_internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(value) === "[object Set]";
}
/**
 * 인자로 받은 값이 TypedArray인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * const arr = new Int16Array();
 * isTypedArray(arr); // true
 * ```
 */ function isTypedArray(value) {
    return _internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .typedArrayTypeNames.includes */ .I0.includes((0,_internal_getType__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(value));
}
/**
 * 인자로 받은 값이 정규식 객체인지 여부를 반환합니다.
 *
 * @example
 * ```ts
 * const regex = /123/;
 * isRegExp(regex); // true
 * ```
 */ function isRegExp(value) {
    return value.constructor !== null && value.constructor === RegExp;
}


/***/ }),

/***/ 48192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ isEqual; }
});

// EXTERNAL MODULE: ./src/utils/lodash/_internal/getType.ts
var getType = __webpack_require__(56852);
;// CONCATENATED MODULE: ./src/utils/lodash/getObjectkeys/index.ts
/**
 * 객체의 키가 아닌 string을 반환하는 Object.keys 대신 사용할 수 있는 Type Safe한 함수입니다
 */ function getObjectKeys(object) {
    return Object.keys(object);
}
/* harmony default export */ var getObjectkeys = (getObjectKeys);

// EXTERNAL MODULE: ./src/utils/lodash/is/index.ts
var is = __webpack_require__(8892);
;// CONCATENATED MODULE: ./src/utils/lodash/isEqual/index.ts



/**
 * 첫 번째 인자의 값과 두 번째 인자의 값을 깊은 비교합니다.
 *
 * isEqual이 true를 반환한다면 첫 번째 인자의 타입은 두 번째 인자의 타입과 동일하다고 평가됩니다.
 *
 * @example
 * ```ts
 * type Foo = { a: number; b?: string };
 * const obj1 = { a: 1 };
 * const obj2: Type = { a: 1 };
 *
 * if (isEqual(a, b)) {
 *   // a는 Foo 타입으로 추론됩니다.
 * }
 * ```
 */ function isEqual(a, b) {
    if ((0,getType/* getType */.oL)(a) !== (0,getType/* getType */.oL)(b)) {
        return false;
    }
    if ((0,is/* isPrimitiveType */.ty)(a) && (0,is/* isPrimitiveType */.ty)(b)) {
        return Object.is(a, b);
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        for(var i = a.length; i--; i !== 0){
            if (!isEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    if ((0,is/* isTypedArray */.fU)(a) && (0,is/* isTypedArray */.fU)(b)) {
        if (a.length !== b.length) {
            return false;
        }
        for(var i1 = a.length; i1--; i1 !== 0){
            if (a[i1] !== b[i1]) {
                return false;
            }
        }
        return true;
    }
    if ((0,is/* isMap */._N)(a) && (0,is/* isMap */._N)(b)) {
        if (a.size !== b.size) {
            return false;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = a.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i2 = _step.value;
                if (b.has(i2[0]) === false) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = a.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var i3 = _step1.value;
                if (!isEqual(i3[1], b.get(i3[0]))) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return true;
    }
    if ((0,is/* isSet */.DM)(a) && (0,is/* isSet */.DM)(b)) {
        if (a.size !== b.size) {
            return false;
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = a.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var i4 = _step2.value;
                if (b.has(i4[0]) === false) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return true;
    }
    if ((0,is/* isRegExp */.Kj)(a) && (0,is/* isRegExp */.Kj)(b)) {
        return a.source === b.source && a.flags === b.flags;
    }
    var objectPrototype = Object.prototype;
    if (a.valueOf !== objectPrototype.valueOf) {
        return a.valueOf() === b.valueOf();
    }
    if (a.toString !== objectPrototype.toString) {
        return a.toSring() === b.toString();
    }
    var keys = getObjectkeys(a);
    var keysLength = keys.length;
    if (keysLength !== getObjectkeys(b).length) {
        return false;
    }
    for(var i5 = keysLength; i5--; i5 !== 0){
        if (!objectPrototype.hasOwnProperty.call(b, keys[i5])) {
            return false;
        }
    }
    for(var i6 = keysLength; i6--; i6 !== 0){
        var key = keys[i6];
        if (!isEqual(a[key], b[key])) {
            return false;
        }
    }
    return true;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [757,848,911,774,888,179], function() { return __webpack_exec__(54505); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);